import { getDefaultExportFromCjs as Ao, commonjsGlobal as Yr } from "./ghl-ui.es436.js";
import { __module as Qr } from "./ghl-ui.es437.js";
(function(Zr, To) {
  (function(k) {
    Zr.exports = k();
  })(function() {
    var k = (w, d) => () => (d || w((d = { exports: {} }).exports, d), d.exports), Te = k((w, d) => {
      var u = function(m) {
        return m && m.Math == Math && m;
      };
      d.exports = u(typeof globalThis == "object" && globalThis) || u(typeof window == "object" && window) || u(typeof self == "object" && self) || u(typeof Yr == "object" && Yr) || function() {
        return this;
      }() || Function("return this")();
    }), Ee = k((w, d) => {
      d.exports = function(u) {
        try {
          return !!u();
        } catch {
          return !0;
        }
      };
    }), Le = k((w, d) => {
      var u = Ee();
      d.exports = !u(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    }), Rt = k((w, d) => {
      var u = Ee();
      d.exports = !u(function() {
        var m = (function() {
        }).bind();
        return typeof m != "function" || m.hasOwnProperty("prototype");
      });
    }), Ut = k((w, d) => {
      var u = Rt(), m = Function.prototype.call;
      d.exports = u ? m.bind(m) : function() {
        return m.apply(m, arguments);
      };
    }), ei = k((w) => {
      var d = {}.propertyIsEnumerable, u = Object.getOwnPropertyDescriptor, m = u && !d.call({ 1: 2 }, 1);
      w.f = m ? function(c) {
        var x = u(this, c);
        return !!x && x.enumerable;
      } : d;
    }), bs = k((w, d) => {
      d.exports = function(u, m) {
        return { enumerable: !(u & 1), configurable: !(u & 2), writable: !(u & 4), value: m };
      };
    }), Ce = k((w, d) => {
      var u = Rt(), m = Function.prototype, c = m.call, x = u && m.bind.bind(c, c);
      d.exports = u ? x : function(b) {
        return function() {
          return c.apply(b, arguments);
        };
      };
    }), ct = k((w, d) => {
      var u = Ce(), m = u({}.toString), c = u("".slice);
      d.exports = function(x) {
        return c(m(x), 8, -1);
      };
    }), ti = k((w, d) => {
      var u = Ce(), m = Ee(), c = ct(), x = Object, b = u("".split);
      d.exports = m(function() {
        return !x("z").propertyIsEnumerable(0);
      }) ? function(P) {
        return c(P) == "String" ? b(P, "") : x(P);
      } : x;
    }), Ts = k((w, d) => {
      d.exports = function(u) {
        return u == null;
      };
    }), Es = k((w, d) => {
      var u = Ts(), m = TypeError;
      d.exports = function(c) {
        if (u(c))
          throw m("Can't call method on " + c);
        return c;
      };
    }), _t = k((w, d) => {
      var u = ti(), m = Es();
      d.exports = function(c) {
        return u(m(c));
      };
    }), Cs = k((w, d) => {
      var u = typeof document == "object" && document.all, m = typeof u > "u" && u !== void 0;
      d.exports = { all: u, IS_HTMLDDA: m };
    }), Pe = k((w, d) => {
      var u = Cs(), m = u.all;
      d.exports = u.IS_HTMLDDA ? function(c) {
        return typeof c == "function" || c === m;
      } : function(c) {
        return typeof c == "function";
      };
    }), qe = k((w, d) => {
      var u = Pe(), m = Cs(), c = m.all;
      d.exports = m.IS_HTMLDDA ? function(x) {
        return typeof x == "object" ? x !== null : u(x) || x === c;
      } : function(x) {
        return typeof x == "object" ? x !== null : u(x);
      };
    }), dt = k((w, d) => {
      var u = Te(), m = Pe(), c = function(x) {
        return m(x) ? x : void 0;
      };
      d.exports = function(x, b) {
        return arguments.length < 2 ? c(u[x]) : u[x] && u[x][b];
      };
    }), si = k((w, d) => {
      var u = Ce();
      d.exports = u({}.isPrototypeOf);
    }), ri = k((w, d) => {
      var u = dt();
      d.exports = u("navigator", "userAgent") || "";
    }), ii = k((w, d) => {
      var u = Te(), m = ri(), c = u.process, x = u.Deno, b = c && c.versions || x && x.version, P = b && b.v8, D, v;
      P && (D = P.split("."), v = D[0] > 0 && D[0] < 4 ? 1 : +(D[0] + D[1])), !v && m && (D = m.match(/Edge\/(\d+)/), (!D || D[1] >= 74) && (D = m.match(/Chrome\/(\d+)/), D && (v = +D[1]))), d.exports = v;
    }), vs = k((w, d) => {
      var u = ii(), m = Ee();
      d.exports = !!Object.getOwnPropertySymbols && !m(function() {
        var c = Symbol();
        return !String(c) || !(Object(c) instanceof Symbol) || !Symbol.sham && u && u < 41;
      });
    }), Ss = k((w, d) => {
      var u = vs();
      d.exports = u && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }), ws = k((w, d) => {
      var u = dt(), m = Pe(), c = si(), x = Ss(), b = Object;
      d.exports = x ? function(P) {
        return typeof P == "symbol";
      } : function(P) {
        var D = u("Symbol");
        return m(D) && c(D.prototype, b(P));
      };
    }), ai = k((w, d) => {
      var u = String;
      d.exports = function(m) {
        try {
          return u(m);
        } catch {
          return "Object";
        }
      };
    }), zt = k((w, d) => {
      var u = Pe(), m = ai(), c = TypeError;
      d.exports = function(x) {
        if (u(x))
          return x;
        throw c(m(x) + " is not a function");
      };
    }), ni = k((w, d) => {
      var u = zt(), m = Ts();
      d.exports = function(c, x) {
        var b = c[x];
        return m(b) ? void 0 : u(b);
      };
    }), oi = k((w, d) => {
      var u = Ut(), m = Pe(), c = qe(), x = TypeError;
      d.exports = function(b, P) {
        var D, v;
        if (P === "string" && m(D = b.toString) && !c(v = u(D, b)) || m(D = b.valueOf) && !c(v = u(D, b)) || P !== "string" && m(D = b.toString) && !c(v = u(D, b)))
          return v;
        throw x("Can't convert object to primitive value");
      };
    }), hi = k((w, d) => {
      d.exports = !1;
    }), Ht = k((w, d) => {
      var u = Te(), m = Object.defineProperty;
      d.exports = function(c, x) {
        try {
          m(u, c, { value: x, configurable: !0, writable: !0 });
        } catch {
          u[c] = x;
        }
        return x;
      };
    }), $t = k((w, d) => {
      var u = Te(), m = Ht(), c = "__core-js_shared__", x = u[c] || m(c, {});
      d.exports = x;
    }), Is = k((w, d) => {
      var u = hi(), m = $t();
      (d.exports = function(c, x) {
        return m[c] || (m[c] = x !== void 0 ? x : {});
      })("versions", []).push({ version: "3.26.1", mode: u ? "pure" : "global", copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    }), Ns = k((w, d) => {
      var u = Es(), m = Object;
      d.exports = function(c) {
        return m(u(c));
      };
    }), Ue = k((w, d) => {
      var u = Ce(), m = Ns(), c = u({}.hasOwnProperty);
      d.exports = Object.hasOwn || function(x, b) {
        return c(m(x), b);
      };
    }), ks = k((w, d) => {
      var u = Ce(), m = 0, c = Math.random(), x = u(1 .toString);
      d.exports = function(b) {
        return "Symbol(" + (b === void 0 ? "" : b) + ")_" + x(++m + c, 36);
      };
    }), mt = k((w, d) => {
      var u = Te(), m = Is(), c = Ue(), x = ks(), b = vs(), P = Ss(), D = m("wks"), v = u.Symbol, M = v && v.for, S = P ? v : v && v.withoutSetter || x;
      d.exports = function(U) {
        if (!c(D, U) || !(b || typeof D[U] == "string")) {
          var _ = "Symbol." + U;
          b && c(v, U) ? D[U] = v[U] : P && M ? D[U] = M(_) : D[U] = S(_);
        }
        return D[U];
      };
    }), li = k((w, d) => {
      var u = Ut(), m = qe(), c = ws(), x = ni(), b = oi(), P = mt(), D = TypeError, v = P("toPrimitive");
      d.exports = function(M, S) {
        if (!m(M) || c(M))
          return M;
        var U = x(M, v), _;
        if (U) {
          if (S === void 0 && (S = "default"), _ = u(U, M, S), !m(_) || c(_))
            return _;
          throw D("Can't convert object to primitive value");
        }
        return S === void 0 && (S = "number"), b(M, S);
      };
    }), Ds = k((w, d) => {
      var u = li(), m = ws();
      d.exports = function(c) {
        var x = u(c, "string");
        return m(x) ? x : x + "";
      };
    }), pi = k((w, d) => {
      var u = Te(), m = qe(), c = u.document, x = m(c) && m(c.createElement);
      d.exports = function(b) {
        return x ? c.createElement(b) : {};
      };
    }), Fs = k((w, d) => {
      var u = Le(), m = Ee(), c = pi();
      d.exports = !u && !m(function() {
        return Object.defineProperty(c("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }), Ls = k((w) => {
      var d = Le(), u = Ut(), m = ei(), c = bs(), x = _t(), b = Ds(), P = Ue(), D = Fs(), v = Object.getOwnPropertyDescriptor;
      w.f = d ? v : function(M, S) {
        if (M = x(M), S = b(S), D)
          try {
            return v(M, S);
          } catch {
          }
        if (P(M, S))
          return c(!u(m.f, M, S), M[S]);
      };
    }), ui = k((w, d) => {
      var u = Le(), m = Ee();
      d.exports = u && m(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: !1 }).prototype != 42;
      });
    }), Vt = k((w, d) => {
      var u = qe(), m = String, c = TypeError;
      d.exports = function(x) {
        if (u(x))
          return x;
        throw c(m(x) + " is not an object");
      };
    }), ft = k((w) => {
      var d = Le(), u = Fs(), m = ui(), c = Vt(), x = Ds(), b = TypeError, P = Object.defineProperty, D = Object.getOwnPropertyDescriptor, v = "enumerable", M = "configurable", S = "writable";
      w.f = d ? m ? function(U, _, J) {
        if (c(U), _ = x(_), c(J), typeof U == "function" && _ === "prototype" && "value" in J && S in J && !J[S]) {
          var K = D(U, _);
          K && K[S] && (U[_] = J.value, J = { configurable: M in J ? J[M] : K[M], enumerable: v in J ? J[v] : K[v], writable: !1 });
        }
        return P(U, _, J);
      } : P : function(U, _, J) {
        if (c(U), _ = x(_), c(J), u)
          try {
            return P(U, _, J);
          } catch {
          }
        if ("get" in J || "set" in J)
          throw b("Accessors not supported");
        return "value" in J && (U[_] = J.value), U;
      };
    }), Bs = k((w, d) => {
      var u = Le(), m = ft(), c = bs();
      d.exports = u ? function(x, b, P) {
        return m.f(x, b, c(1, P));
      } : function(x, b, P) {
        return x[b] = P, x;
      };
    }), ci = k((w, d) => {
      var u = Le(), m = Ue(), c = Function.prototype, x = u && Object.getOwnPropertyDescriptor, b = m(c, "name"), P = b && (function() {
      }).name === "something", D = b && (!u || u && x(c, "name").configurable);
      d.exports = { EXISTS: b, PROPER: P, CONFIGURABLE: D };
    }), Ms = k((w, d) => {
      var u = Ce(), m = Pe(), c = $t(), x = u(Function.toString);
      m(c.inspectSource) || (c.inspectSource = function(b) {
        return x(b);
      }), d.exports = c.inspectSource;
    }), di = k((w, d) => {
      var u = Te(), m = Pe(), c = u.WeakMap;
      d.exports = m(c) && /native code/.test(String(c));
    }), mi = k((w, d) => {
      var u = Is(), m = ks(), c = u("keys");
      d.exports = function(x) {
        return c[x] || (c[x] = m(x));
      };
    }), Os = k((w, d) => {
      d.exports = {};
    }), fi = k((w, d) => {
      var u = di(), m = Te(), c = qe(), x = Bs(), b = Ue(), P = $t(), D = mi(), v = Os(), M = "Object already initialized", S = m.TypeError, U = m.WeakMap, _, J, K, q = function(ne) {
        return K(ne) ? J(ne) : _(ne, {});
      }, ie = function(ne) {
        return function(ye) {
          var st;
          if (!c(ye) || (st = J(ye)).type !== ne)
            throw S("Incompatible receiver, " + ne + " required");
          return st;
        };
      };
      u || P.state ? (ae = P.state || (P.state = new U()), ae.get = ae.get, ae.has = ae.has, ae.set = ae.set, _ = function(ne, ye) {
        if (ae.has(ne))
          throw S(M);
        return ye.facade = ne, ae.set(ne, ye), ye;
      }, J = function(ne) {
        return ae.get(ne) || {};
      }, K = function(ne) {
        return ae.has(ne);
      }) : (ue = D("state"), v[ue] = !0, _ = function(ne, ye) {
        if (b(ne, ue))
          throw S(M);
        return ye.facade = ne, x(ne, ue, ye), ye;
      }, J = function(ne) {
        return b(ne, ue) ? ne[ue] : {};
      }, K = function(ne) {
        return b(ne, ue);
      });
      var ae, ue;
      d.exports = { set: _, get: J, has: K, enforce: q, getterFor: ie };
    }), js = k((w, d) => {
      var u = Ee(), m = Pe(), c = Ue(), x = Le(), b = ci().CONFIGURABLE, P = Ms(), D = fi(), v = D.enforce, M = D.get, S = Object.defineProperty, U = x && !u(function() {
        return S(function() {
        }, "length", { value: 8 }).length !== 8;
      }), _ = String(String).split("String"), J = d.exports = function(K, q, ie) {
        String(q).slice(0, 7) === "Symbol(" && (q = "[" + String(q).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), ie && ie.getter && (q = "get " + q), ie && ie.setter && (q = "set " + q), (!c(K, "name") || b && K.name !== q) && (x ? S(K, "name", { value: q, configurable: !0 }) : K.name = q), U && ie && c(ie, "arity") && K.length !== ie.arity && S(K, "length", { value: ie.arity });
        try {
          ie && c(ie, "constructor") && ie.constructor ? x && S(K, "prototype", { writable: !1 }) : K.prototype && (K.prototype = void 0);
        } catch {
        }
        var ae = v(K);
        return c(ae, "source") || (ae.source = _.join(typeof q == "string" ? q : "")), K;
      };
      Function.prototype.toString = J(function() {
        return m(this) && M(this).source || P(this);
      }, "toString");
    }), yi = k((w, d) => {
      var u = Pe(), m = ft(), c = js(), x = Ht();
      d.exports = function(b, P, D, v) {
        v || (v = {});
        var M = v.enumerable, S = v.name !== void 0 ? v.name : P;
        if (u(D) && c(D, S, v), v.global)
          M ? b[P] = D : x(P, D);
        else {
          try {
            v.unsafe ? b[P] && (M = !0) : delete b[P];
          } catch {
          }
          M ? b[P] = D : m.f(b, P, { value: D, enumerable: !1, configurable: !v.nonConfigurable, writable: !v.nonWritable });
        }
        return b;
      };
    }), xi = k((w, d) => {
      var u = Math.ceil, m = Math.floor;
      d.exports = Math.trunc || function(c) {
        var x = +c;
        return (x > 0 ? m : u)(x);
      };
    }), Rs = k((w, d) => {
      var u = xi();
      d.exports = function(m) {
        var c = +m;
        return c !== c || c === 0 ? 0 : u(c);
      };
    }), gi = k((w, d) => {
      var u = Rs(), m = Math.max, c = Math.min;
      d.exports = function(x, b) {
        var P = u(x);
        return P < 0 ? m(P + b, 0) : c(P, b);
      };
    }), Pi = k((w, d) => {
      var u = Rs(), m = Math.min;
      d.exports = function(c) {
        return c > 0 ? m(u(c), 9007199254740991) : 0;
      };
    }), qt = k((w, d) => {
      var u = Pi();
      d.exports = function(m) {
        return u(m.length);
      };
    }), Ai = k((w, d) => {
      var u = _t(), m = gi(), c = qt(), x = function(b) {
        return function(P, D, v) {
          var M = u(P), S = c(M), U = m(v, S), _;
          if (b && D != D) {
            for (; S > U; )
              if (_ = M[U++], _ != _)
                return !0;
          } else
            for (; S > U; U++)
              if ((b || U in M) && M[U] === D)
                return b || U || 0;
          return !b && -1;
        };
      };
      d.exports = { includes: x(!0), indexOf: x(!1) };
    }), bi = k((w, d) => {
      var u = Ce(), m = Ue(), c = _t(), x = Ai().indexOf, b = Os(), P = u([].push);
      d.exports = function(D, v) {
        var M = c(D), S = 0, U = [], _;
        for (_ in M)
          !m(b, _) && m(M, _) && P(U, _);
        for (; v.length > S; )
          m(M, _ = v[S++]) && (~x(U, _) || P(U, _));
        return U;
      };
    }), Ti = k((w, d) => {
      d.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }), Ei = k((w) => {
      var d = bi(), u = Ti(), m = u.concat("length", "prototype");
      w.f = Object.getOwnPropertyNames || function(c) {
        return d(c, m);
      };
    }), Ci = k((w) => {
      w.f = Object.getOwnPropertySymbols;
    }), vi = k((w, d) => {
      var u = dt(), m = Ce(), c = Ei(), x = Ci(), b = Vt(), P = m([].concat);
      d.exports = u("Reflect", "ownKeys") || function(D) {
        var v = c.f(b(D)), M = x.f;
        return M ? P(v, M(D)) : v;
      };
    }), Si = k((w, d) => {
      var u = Ue(), m = vi(), c = Ls(), x = ft();
      d.exports = function(b, P, D) {
        for (var v = m(P), M = x.f, S = c.f, U = 0; U < v.length; U++) {
          var _ = v[U];
          !u(b, _) && !(D && u(D, _)) && M(b, _, S(P, _));
        }
      };
    }), wi = k((w, d) => {
      var u = Ee(), m = Pe(), c = /#|\.prototype\./, x = function(M, S) {
        var U = P[b(M)];
        return U == v ? !0 : U == D ? !1 : m(S) ? u(S) : !!S;
      }, b = x.normalize = function(M) {
        return String(M).replace(c, ".").toLowerCase();
      }, P = x.data = {}, D = x.NATIVE = "N", v = x.POLYFILL = "P";
      d.exports = x;
    }), Us = k((w, d) => {
      var u = Te(), m = Ls().f, c = Bs(), x = yi(), b = Ht(), P = Si(), D = wi();
      d.exports = function(v, M) {
        var S = v.target, U = v.global, _ = v.stat, J, K, q, ie, ae, ue;
        if (U ? K = u : _ ? K = u[S] || b(S, {}) : K = (u[S] || {}).prototype, K)
          for (q in M) {
            if (ae = M[q], v.dontCallGetSet ? (ue = m(K, q), ie = ue && ue.value) : ie = K[q], J = D(U ? q : S + (_ ? "." : "#") + q, v.forced), !J && ie !== void 0) {
              if (typeof ae == typeof ie)
                continue;
              P(ae, ie);
            }
            (v.sham || ie && ie.sham) && c(ae, "sham", !0), x(K, q, ae, v);
          }
      };
    }), Ii = k(() => {
      var w = Us(), d = Te();
      w({ global: !0, forced: d.globalThis !== d }, { globalThis: d });
    }), Ni = k(() => {
      Ii();
    }), ki = k((w, d) => {
      var u = js(), m = ft();
      d.exports = function(c, x, b) {
        return b.get && u(b.get, x, { getter: !0 }), b.set && u(b.set, x, { setter: !0 }), m.f(c, x, b);
      };
    }), Di = k((w, d) => {
      var u = Vt();
      d.exports = function() {
        var m = u(this), c = "";
        return m.hasIndices && (c += "d"), m.global && (c += "g"), m.ignoreCase && (c += "i"), m.multiline && (c += "m"), m.dotAll && (c += "s"), m.unicode && (c += "u"), m.unicodeSets && (c += "v"), m.sticky && (c += "y"), c;
      };
    }), Fi = k(() => {
      var w = Te(), d = Le(), u = ki(), m = Di(), c = Ee(), x = w.RegExp, b = x.prototype, P = d && c(function() {
        var D = !0;
        try {
          x(".", "d");
        } catch {
          D = !1;
        }
        var v = {}, M = "", S = D ? "dgimsy" : "gimsy", U = function(q, ie) {
          Object.defineProperty(v, q, { get: function() {
            return M += ie, !0;
          } });
        }, _ = { dotAll: "s", global: "g", ignoreCase: "i", multiline: "m", sticky: "y" };
        D && (_.hasIndices = "d");
        for (var J in _)
          U(J, _[J]);
        var K = Object.getOwnPropertyDescriptor(b, "flags").get.call(v);
        return K !== S || M !== S;
      });
      P && u(b, "flags", { configurable: !0, get: m });
    }), _s = k((w, d) => {
      var u = ct();
      d.exports = Array.isArray || function(m) {
        return u(m) == "Array";
      };
    }), Li = k((w, d) => {
      var u = TypeError, m = 9007199254740991;
      d.exports = function(c) {
        if (c > m)
          throw u("Maximum allowed index exceeded");
        return c;
      };
    }), Bi = k((w, d) => {
      var u = ct(), m = Ce();
      d.exports = function(c) {
        if (u(c) === "Function")
          return m(c);
      };
    }), Mi = k((w, d) => {
      var u = Bi(), m = zt(), c = Rt(), x = u(u.bind);
      d.exports = function(b, P) {
        return m(b), P === void 0 ? b : c ? x(b, P) : function() {
          return b.apply(P, arguments);
        };
      };
    }), Oi = k((w, d) => {
      var u = _s(), m = qt(), c = Li(), x = Mi(), b = function(P, D, v, M, S, U, _, J) {
        for (var K = S, q = 0, ie = _ ? x(_, J) : !1, ae, ue; q < M; )
          q in v && (ae = ie ? ie(v[q], q, D) : v[q], U > 0 && u(ae) ? (ue = m(ae), K = b(P, D, ae, ue, K, U - 1) - 1) : (c(K + 1), P[K] = ae), K++), q++;
        return K;
      };
      d.exports = b;
    }), ji = k((w, d) => {
      var u = mt(), m = u("toStringTag"), c = {};
      c[m] = "z", d.exports = String(c) === "[object z]";
    }), Ri = k((w, d) => {
      var u = ji(), m = Pe(), c = ct(), x = mt(), b = x("toStringTag"), P = Object, D = c(function() {
        return arguments;
      }()) == "Arguments", v = function(M, S) {
        try {
          return M[S];
        } catch {
        }
      };
      d.exports = u ? c : function(M) {
        var S, U, _;
        return M === void 0 ? "Undefined" : M === null ? "Null" : typeof (U = v(S = P(M), b)) == "string" ? U : D ? c(S) : (_ = c(S)) == "Object" && m(S.callee) ? "Arguments" : _;
      };
    }), Ui = k((w, d) => {
      var u = Ce(), m = Ee(), c = Pe(), x = Ri(), b = dt(), P = Ms(), D = function() {
      }, v = [], M = b("Reflect", "construct"), S = /^\s*(?:class|function)\b/, U = u(S.exec), _ = !S.exec(D), J = function(q) {
        if (!c(q))
          return !1;
        try {
          return M(D, v, q), !0;
        } catch {
          return !1;
        }
      }, K = function(q) {
        if (!c(q))
          return !1;
        switch (x(q)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return !1;
        }
        try {
          return _ || !!U(S, P(q));
        } catch {
          return !0;
        }
      };
      K.sham = !0, d.exports = !M || m(function() {
        var q;
        return J(J.call) || !J(Object) || !J(function() {
          q = !0;
        }) || q;
      }) ? K : J;
    }), _i = k((w, d) => {
      var u = _s(), m = Ui(), c = qe(), x = mt(), b = x("species"), P = Array;
      d.exports = function(D) {
        var v;
        return u(D) && (v = D.constructor, m(v) && (v === P || u(v.prototype)) ? v = void 0 : c(v) && (v = v[b], v === null && (v = void 0))), v === void 0 ? P : v;
      };
    }), zi = k((w, d) => {
      var u = _i();
      d.exports = function(m, c) {
        return new (u(m))(c === 0 ? 0 : c);
      };
    }), Hi = k(() => {
      var w = Us(), d = Oi(), u = zt(), m = Ns(), c = qt(), x = zi();
      w({ target: "Array", proto: !0 }, { flatMap: function(b) {
        var P = m(this), D = c(P), v;
        return u(b), v = x(P, 0), v.length = d(v, P, P, D, 0, 1, b, arguments.length > 1 ? arguments[1] : void 0), v;
      } });
    }), $i = k((w, d) => {
      Ni(), Fi(), Hi();
      var u = Object.defineProperty, m = Object.getOwnPropertyDescriptor, c = Object.getOwnPropertyNames, x = Object.prototype.hasOwnProperty, b = (L, N) => function() {
        return L && (N = (0, L[c(L)[0]])(L = 0)), N;
      }, P = (L, N) => function() {
        return N || (0, L[c(L)[0]])((N = { exports: {} }).exports, N), N.exports;
      }, D = (L, N) => {
        for (var I in N)
          u(L, I, { get: N[I], enumerable: !0 });
      }, v = (L, N, I, A) => {
        if (N && typeof N == "object" || typeof N == "function")
          for (let g of c(N))
            !x.call(L, g) && g !== I && u(L, g, { get: () => N[g], enumerable: !(A = m(N, g)) || A.enumerable });
        return L;
      }, M = (L) => v(u({}, "__esModule", { value: !0 }), L), S = b({ "<define:process>"() {
      } }), U = P({ "src/utils/try-combinations.js"(L, N) {
        S();
        function I() {
          let A;
          for (var g = arguments.length, E = new Array(g), y = 0; y < g; y++)
            E[y] = arguments[y];
          for (let [O, V] of E.entries())
            try {
              return { result: V() };
            } catch (X) {
              O === 0 && (A = X);
            }
          return { error: A };
        }
        N.exports = I;
      } }), _ = P({ "src/language-js/utils/get-shebang.js"(L, N) {
        S();
        function I(A) {
          if (!A.startsWith("#!"))
            return "";
          let g = A.indexOf(`
`);
          return g === -1 ? A : A.slice(0, g);
        }
        N.exports = I;
      } }), J = P({ "src/utils/text/skip-inline-comment.js"(L, N) {
        S();
        function I(A, g) {
          if (g === !1)
            return !1;
          if (A.charAt(g) === "/" && A.charAt(g + 1) === "*") {
            for (let E = g + 2; E < A.length; ++E)
              if (A.charAt(E) === "*" && A.charAt(E + 1) === "/")
                return E + 2;
          }
          return g;
        }
        N.exports = I;
      } }), K = P({ "src/utils/text/skip-newline.js"(L, N) {
        S();
        function I(A, g, E) {
          let y = E && E.backwards;
          if (g === !1)
            return !1;
          let O = A.charAt(g);
          if (y) {
            if (A.charAt(g - 1) === "\r" && O === `
`)
              return g - 2;
            if (O === `
` || O === "\r" || O === "\u2028" || O === "\u2029")
              return g - 1;
          } else {
            if (O === "\r" && A.charAt(g + 1) === `
`)
              return g + 2;
            if (O === `
` || O === "\r" || O === "\u2028" || O === "\u2029")
              return g + 1;
          }
          return g;
        }
        N.exports = I;
      } }), q = P({ "src/utils/text/skip.js"(L, N) {
        S();
        function I(O) {
          return (V, X, Q) => {
            let z = Q && Q.backwards;
            if (X === !1)
              return !1;
            let { length: W } = V, C = X;
            for (; C >= 0 && C < W; ) {
              let Z = V.charAt(C);
              if (O instanceof RegExp) {
                if (!O.test(Z))
                  return C;
              } else if (!O.includes(Z))
                return C;
              z ? C-- : C++;
            }
            return C === -1 || C === W ? C : !1;
          };
        }
        var A = I(/\s/), g = I(" 	"), E = I(",; 	"), y = I(/[^\n\r]/);
        N.exports = { skipWhitespace: A, skipSpaces: g, skipToLineEnd: E, skipEverythingButNewLine: y };
      } }), ie = P({ "src/utils/text/skip-trailing-comment.js"(L, N) {
        S();
        var { skipEverythingButNewLine: I } = q();
        function A(g, E) {
          return E === !1 ? !1 : g.charAt(E) === "/" && g.charAt(E + 1) === "/" ? I(g, E) : E;
        }
        N.exports = A;
      } }), ae = P({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(L, N) {
        S();
        var I = J(), A = K(), g = ie(), { skipSpaces: E } = q();
        function y(O, V) {
          let X = null, Q = V;
          for (; Q !== X; )
            X = Q, Q = E(O, Q), Q = I(O, Q), Q = g(O, Q), Q = A(O, Q);
          return Q;
        }
        N.exports = y;
      } }), ue = {};
      D(ue, { EOL: () => Jt, arch: () => Vi, cpus: () => Vs, default: () => Xs, endianness: () => ne, freemem: () => Hs, getNetworkInterfaces: () => Js, hostname: () => ye, loadavg: () => st, networkInterfaces: () => Ws, platform: () => qi, release: () => Ks, tmpDir: () => Kt, tmpdir: () => Wt, totalmem: () => $s, type: () => qs, uptime: () => zs });
      function ne() {
        if (typeof yt > "u") {
          var L = new ArrayBuffer(2), N = new Uint8Array(L), I = new Uint16Array(L);
          if (N[0] = 1, N[1] = 2, I[0] === 258)
            yt = "BE";
          else if (I[0] === 513)
            yt = "LE";
          else
            throw new Error("unable to figure out endianess");
        }
        return yt;
      }
      function ye() {
        return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
      }
      function st() {
        return [];
      }
      function zs() {
        return 0;
      }
      function Hs() {
        return Number.MAX_VALUE;
      }
      function $s() {
        return Number.MAX_VALUE;
      }
      function Vs() {
        return [];
      }
      function qs() {
        return "Browser";
      }
      function Ks() {
        return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
      }
      function Ws() {
      }
      function Js() {
      }
      function Vi() {
        return "javascript";
      }
      function qi() {
        return "browser";
      }
      function Kt() {
        return "/tmp";
      }
      var yt, Wt, Jt, Xs, Ki = b({ "node-modules-polyfills:os"() {
        S(), Wt = Kt, Jt = `
`, Xs = { EOL: Jt, tmpdir: Wt, tmpDir: Kt, networkInterfaces: Ws, getNetworkInterfaces: Js, release: Ks, type: qs, cpus: Vs, totalmem: $s, freemem: Hs, uptime: zs, loadavg: st, hostname: ye, endianness: ne };
      } }), Wi = P({ "node-modules-polyfills-commonjs:os"(L, N) {
        S();
        var I = (Ki(), M(ue));
        if (I && I.default) {
          N.exports = I.default;
          for (let A in I)
            N.exports[A] = I[A];
        } else
          I && (N.exports = I);
      } }), Ji = P({ "node_modules/detect-newline/index.js"(L, N) {
        S();
        var I = (A) => {
          if (typeof A != "string")
            throw new TypeError("Expected a string");
          let g = A.match(/(?:\r?\n)/g) || [];
          if (g.length === 0)
            return;
          let E = g.filter((O) => O === `\r
`).length, y = g.length - E;
          return E > y ? `\r
` : `
`;
        };
        N.exports = I, N.exports.graceful = (A) => typeof A == "string" && I(A) || `
`;
      } }), Xi = P({ "node_modules/jest-docblock/build/index.js"(L) {
        S(), Object.defineProperty(L, "__esModule", { value: !0 }), L.extract = C, L.parse = le, L.parseWithComments = H, L.print = Y, L.strip = Z;
        function N() {
          let ee = Wi();
          return N = function() {
            return ee;
          }, ee;
        }
        function I() {
          let ee = A(Ji());
          return I = function() {
            return ee;
          }, ee;
        }
        function A(ee) {
          return ee && ee.__esModule ? ee : { default: ee };
        }
        var g = /\*\/$/, E = /^\/\*\*?/, y = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, O = /(^|\s+)\/\/([^\r\n]*)/g, V = /^(\r?\n)+/, X = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, Q = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, z = /(\r?\n|^) *\* ?/g, W = [];
        function C(ee) {
          let pe = ee.match(y);
          return pe ? pe[0].trimLeft() : "";
        }
        function Z(ee) {
          let pe = ee.match(y);
          return pe && pe[0] ? ee.substring(pe[0].length) : ee;
        }
        function le(ee) {
          return H(ee).pragmas;
        }
        function H(ee) {
          let pe = (0, I().default)(ee) || N().EOL;
          ee = ee.replace(E, "").replace(g, "").replace(z, "$1");
          let xe = "";
          for (; xe !== ee; )
            xe = ee, ee = ee.replace(X, `${pe}$1 $2${pe}`);
          ee = ee.replace(V, "").trimRight();
          let F = /* @__PURE__ */ Object.create(null), G = ee.replace(Q, "").replace(V, "").trimRight(), ge;
          for (; ge = Q.exec(ee); ) {
            let te = ge[2].replace(O, "");
            typeof F[ge[1]] == "string" || Array.isArray(F[ge[1]]) ? F[ge[1]] = W.concat(F[ge[1]], te) : F[ge[1]] = te;
          }
          return { comments: G, pragmas: F };
        }
        function Y(ee) {
          let { comments: pe = "", pragmas: xe = {} } = ee, F = (0, I().default)(pe) || N().EOL, G = "/**", ge = " *", te = " */", we = Object.keys(xe), Ae = we.map((be) => he(be, xe[be])).reduce((be, rt) => be.concat(rt), []).map((be) => `${ge} ${be}${F}`).join("");
          if (!pe) {
            if (we.length === 0)
              return "";
            if (we.length === 1 && !Array.isArray(xe[we[0]])) {
              let be = xe[we[0]];
              return `${G} ${he(we[0], be)[0]}${te}`;
            }
          }
          let xt = pe.split(F).map((be) => `${ge} ${be}`).join(F) + F;
          return G + F + (pe ? xt : "") + (pe && we.length ? ge + F : "") + Ae + te;
        }
        function he(ee, pe) {
          return W.concat(pe).map((xe) => `@${ee} ${xe}`.trim());
        }
      } }), Gi = P({ "src/common/end-of-line.js"(L, N) {
        S();
        function I(y) {
          let O = y.indexOf("\r");
          return O >= 0 ? y.charAt(O + 1) === `
` ? "crlf" : "cr" : "lf";
        }
        function A(y) {
          switch (y) {
            case "cr":
              return "\r";
            case "crlf":
              return `\r
`;
            default:
              return `
`;
          }
        }
        function g(y, O) {
          let V;
          switch (O) {
            case `
`:
              V = /\n/g;
              break;
            case "\r":
              V = /\r/g;
              break;
            case `\r
`:
              V = /\r\n/g;
              break;
            default:
              throw new Error(`Unexpected "eol" ${JSON.stringify(O)}.`);
          }
          let X = y.match(V);
          return X ? X.length : 0;
        }
        function E(y) {
          return y.replace(/\r\n?/g, `
`);
        }
        N.exports = { guessEndOfLine: I, convertEndOfLineToChars: A, countEndOfLineChars: g, normalizeEndOfLine: E };
      } }), Yi = P({ "src/language-js/pragma.js"(L, N) {
        S();
        var { parseWithComments: I, strip: A, extract: g, print: E } = Xi(), { normalizeEndOfLine: y } = Gi(), O = _();
        function V(z) {
          let W = O(z);
          W && (z = z.slice(W.length + 1));
          let C = g(z), { pragmas: Z, comments: le } = I(C);
          return { shebang: W, text: z, pragmas: Z, comments: le };
        }
        function X(z) {
          let W = Object.keys(V(z).pragmas);
          return W.includes("prettier") || W.includes("format");
        }
        function Q(z) {
          let { shebang: W, text: C, pragmas: Z, comments: le } = V(z), H = A(C), Y = E({ pragmas: Object.assign({ format: "" }, Z), comments: le.trimStart() });
          return (W ? `${W}
` : "") + y(Y) + (H.startsWith(`
`) ? `
` : `

`) + H;
        }
        N.exports = { hasPragma: X, insertPragma: Q };
      } }), Gs = P({ "src/utils/is-non-empty-array.js"(L, N) {
        S();
        function I(A) {
          return Array.isArray(A) && A.length > 0;
        }
        N.exports = I;
      } }), Ys = P({ "src/language-js/loc.js"(L, N) {
        S();
        var I = Gs();
        function A(V) {
          var X, Q;
          let z = V.range ? V.range[0] : V.start, W = (X = (Q = V.declaration) === null || Q === void 0 ? void 0 : Q.decorators) !== null && X !== void 0 ? X : V.decorators;
          return I(W) ? Math.min(A(W[0]), z) : z;
        }
        function g(V) {
          return V.range ? V.range[1] : V.end;
        }
        function E(V, X) {
          let Q = A(V);
          return Number.isInteger(Q) && Q === A(X);
        }
        function y(V, X) {
          let Q = g(V);
          return Number.isInteger(Q) && Q === g(X);
        }
        function O(V, X) {
          return E(V, X) && y(V, X);
        }
        N.exports = { locStart: A, locEnd: g, hasSameLocStart: E, hasSameLoc: O };
      } }), Qs = P({ "src/language-js/parse/utils/create-parser.js"(L, N) {
        S();
        var { hasPragma: I } = Yi(), { locStart: A, locEnd: g } = Ys();
        function E(y) {
          return y = typeof y == "function" ? { parse: y } : y, Object.assign({ astFormat: "estree", hasPragma: I, locStart: A, locEnd: g }, y);
        }
        N.exports = E;
      } }), Xt = P({ "src/common/parser-create-error.js"(L, N) {
        S();
        function I(A, g) {
          let E = new SyntaxError(A + " (" + g.start.line + ":" + g.start.column + ")");
          return E.loc = g, E;
        }
        N.exports = I;
      } }), Zs = P({ "src/language-js/parse/utils/create-babel-parse-error.js"(L, N) {
        S();
        var I = Xt();
        function A(g) {
          let { message: E, loc: y } = g;
          return I(E.replace(/ \(.*\)/, ""), { start: { line: y ? y.line : 0, column: y ? y.column + 1 : 0 } });
        }
        N.exports = A;
      } }), Qi = P({ "src/language-js/utils/is-ts-keyword-type.js"(L, N) {
        S();
        function I(A) {
          let { type: g } = A;
          return g.startsWith("TS") && g.endsWith("Keyword");
        }
        N.exports = I;
      } }), Zi = P({ "src/language-js/utils/is-block-comment.js"(L, N) {
        S();
        var I = /* @__PURE__ */ new Set(["Block", "CommentBlock", "MultiLine"]), A = (g) => I.has(g == null ? void 0 : g.type);
        N.exports = A;
      } }), ea = P({ "src/language-js/utils/is-type-cast-comment.js"(L, N) {
        S();
        var I = Zi();
        function A(g) {
          return I(g) && g.value[0] === "*" && /@(?:type|satisfies)\b/.test(g.value);
        }
        N.exports = A;
      } }), ta = P({ "src/utils/get-last.js"(L, N) {
        S();
        var I = (A) => A[A.length - 1];
        N.exports = I;
      } }), sa = P({ "src/language-js/parse/postprocess/visit-node.js"(L, N) {
        S();
        function I(A, g) {
          if (Array.isArray(A)) {
            for (let E = 0; E < A.length; E++)
              A[E] = I(A[E], g);
            return A;
          }
          if (A && typeof A == "object" && typeof A.type == "string") {
            let E = Object.keys(A);
            for (let y = 0; y < E.length; y++)
              A[E[y]] = I(A[E[y]], g);
            return g(A) || A;
          }
          return A;
        }
        N.exports = I;
      } }), ra = P({ "src/language-js/parse/postprocess/throw-syntax-error.js"(L, N) {
        S();
        var I = Xt();
        function A(g, E) {
          let { start: y, end: O } = g.loc;
          throw I(E, { start: { line: y.line, column: y.column + 1 }, end: { line: O.line, column: O.column + 1 } });
        }
        N.exports = A;
      } }), ia = P({ "src/language-js/parse/postprocess/index.js"(L, N) {
        S();
        var { locStart: I, locEnd: A } = Ys(), g = Qi(), E = ea(), y = ta(), O = sa(), V = ra();
        function X(C, Z) {
          if (Z.parser !== "typescript" && Z.parser !== "flow" && Z.parser !== "acorn" && Z.parser !== "espree" && Z.parser !== "meriyah") {
            let H = /* @__PURE__ */ new Set();
            C = O(C, (Y) => {
              Y.leadingComments && Y.leadingComments.some(E) && H.add(I(Y));
            }), C = O(C, (Y) => {
              if (Y.type === "ParenthesizedExpression") {
                let { expression: he } = Y;
                if (he.type === "TypeCastExpression")
                  return he.range = Y.range, he;
                let ee = I(Y);
                if (!H.has(ee))
                  return he.extra = Object.assign(Object.assign({}, he.extra), {}, { parenthesized: !0 }), he;
              }
            });
          }
          return C = O(C, (H) => {
            switch (H.type) {
              case "ChainExpression":
                return Q(H.expression);
              case "LogicalExpression": {
                if (z(H))
                  return W(H);
                break;
              }
              case "VariableDeclaration": {
                let Y = y(H.declarations);
                Y && Y.init && le(H, Y);
                break;
              }
              case "TSParenthesizedType":
                return g(H.typeAnnotation) || H.typeAnnotation.type === "TSThisType" || (H.typeAnnotation.range = [I(H), A(H)]), H.typeAnnotation;
              case "TSTypeParameter":
                if (typeof H.name == "string") {
                  let Y = I(H);
                  H.name = { type: "Identifier", name: H.name, range: [Y, Y + H.name.length] };
                }
                break;
              case "ObjectExpression":
                if (Z.parser === "typescript") {
                  let Y = H.properties.find((he) => he.type === "Property" && he.value.type === "TSEmptyBodyFunctionExpression");
                  Y && V(Y.value, "Unexpected token.");
                }
                break;
              case "SequenceExpression": {
                let Y = y(H.expressions);
                H.range = [I(H), Math.min(A(Y), A(H))];
                break;
              }
              case "TopicReference":
                Z.__isUsingHackPipeline = !0;
                break;
              case "ExportAllDeclaration": {
                let { exported: Y } = H;
                if (Z.parser === "meriyah" && Y && Y.type === "Identifier") {
                  let he = Z.originalText.slice(I(Y), A(Y));
                  (he.startsWith('"') || he.startsWith("'")) && (H.exported = Object.assign(Object.assign({}, H.exported), {}, { type: "Literal", value: H.exported.name, raw: he }));
                }
                break;
              }
              case "PropertyDefinition":
                if (Z.parser === "meriyah" && H.static && !H.computed && !H.key) {
                  let Y = "static", he = I(H);
                  Object.assign(H, { static: !1, key: { type: "Identifier", name: Y, range: [he, he + Y.length] } });
                }
                break;
            }
          }), C;
          function le(H, Y) {
            Z.originalText[A(Y)] !== ";" && (H.range = [I(H), A(Y)]);
          }
        }
        function Q(C) {
          switch (C.type) {
            case "CallExpression":
              C.type = "OptionalCallExpression", C.callee = Q(C.callee);
              break;
            case "MemberExpression":
              C.type = "OptionalMemberExpression", C.object = Q(C.object);
              break;
            case "TSNonNullExpression":
              C.expression = Q(C.expression);
              break;
          }
          return C;
        }
        function z(C) {
          return C.type === "LogicalExpression" && C.right.type === "LogicalExpression" && C.operator === C.right.operator;
        }
        function W(C) {
          return z(C) ? W({ type: "LogicalExpression", operator: C.operator, left: W({ type: "LogicalExpression", operator: C.operator, left: C.left, right: C.right.left, range: [I(C.left), A(C.right.left)] }), right: C.right.right, range: [I(C), A(C)] }) : C;
        }
        N.exports = X;
      } }), er = P({ "node_modules/@babel/parser/lib/index.js"(L) {
        S(), Object.defineProperty(L, "__esModule", { value: !0 });
        var N = { sourceType: "script", sourceFilename: void 0, startColumn: 0, startLine: 1, allowAwaitOutsideFunction: !1, allowReturnOutsideFunction: !1, allowNewTargetOutsideFunction: !1, allowImportExportEverywhere: !1, allowSuperOutsideMethod: !1, allowUndeclaredExports: !1, plugins: [], strictMode: null, ranges: !1, tokens: !1, createParenthesizedExpressions: !1, errorRecovery: !1, attachComment: !0, annexB: !0 };
        function I(t) {
          if (t && t.annexB != null && t.annexB !== !1)
            throw new Error("The `annexB` option can only be set to `false`.");
          let e = {};
          for (let s of Object.keys(N))
            e[s] = t && t[s] != null ? t[s] : N[s];
          return e;
        }
        var A = class {
          constructor(t, e) {
            this.token = void 0, this.preserveSpace = void 0, this.token = t, this.preserveSpace = !!e;
          }
        }, g = { brace: new A("{"), j_oTag: new A("<tag"), j_cTag: new A("</tag"), j_expr: new A("<tag>...</tag>", !0) };
        g.template = new A("`", !0);
        var E = !0, y = !0, O = !0, V = !0, X = !0, Q = !0, z = class {
          constructor(t) {
            let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            this.label = void 0, this.keyword = void 0, this.beforeExpr = void 0, this.startsExpr = void 0, this.rightAssociative = void 0, this.isLoop = void 0, this.isAssign = void 0, this.prefix = void 0, this.postfix = void 0, this.binop = void 0, this.label = t, this.keyword = e.keyword, this.beforeExpr = !!e.beforeExpr, this.startsExpr = !!e.startsExpr, this.rightAssociative = !!e.rightAssociative, this.isLoop = !!e.isLoop, this.isAssign = !!e.isAssign, this.prefix = !!e.prefix, this.postfix = !!e.postfix, this.binop = e.binop != null ? e.binop : null, this.updateContext = null;
          }
        }, W = /* @__PURE__ */ new Map();
        function C(t) {
          let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          e.keyword = t;
          let s = F(t, e);
          return W.set(t, s), s;
        }
        function Z(t, e) {
          return F(t, { beforeExpr: E, binop: e });
        }
        var le = -1, H = [], Y = [], he = [], ee = [], pe = [], xe = [];
        function F(t) {
          let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          var s, r, i, a;
          return ++le, Y.push(t), he.push((s = e.binop) != null ? s : -1), ee.push((r = e.beforeExpr) != null ? r : !1), pe.push((i = e.startsExpr) != null ? i : !1), xe.push((a = e.prefix) != null ? a : !1), H.push(new z(t, e)), le;
        }
        function G(t) {
          let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          var s, r, i, a;
          return ++le, W.set(t, le), Y.push(t), he.push((s = e.binop) != null ? s : -1), ee.push((r = e.beforeExpr) != null ? r : !1), pe.push((i = e.startsExpr) != null ? i : !1), xe.push((a = e.prefix) != null ? a : !1), H.push(new z("name", e)), le;
        }
        var ge = { bracketL: F("[", { beforeExpr: E, startsExpr: y }), bracketHashL: F("#[", { beforeExpr: E, startsExpr: y }), bracketBarL: F("[|", { beforeExpr: E, startsExpr: y }), bracketR: F("]"), bracketBarR: F("|]"), braceL: F("{", { beforeExpr: E, startsExpr: y }), braceBarL: F("{|", { beforeExpr: E, startsExpr: y }), braceHashL: F("#{", { beforeExpr: E, startsExpr: y }), braceR: F("}"), braceBarR: F("|}"), parenL: F("(", { beforeExpr: E, startsExpr: y }), parenR: F(")"), comma: F(",", { beforeExpr: E }), semi: F(";", { beforeExpr: E }), colon: F(":", { beforeExpr: E }), doubleColon: F("::", { beforeExpr: E }), dot: F("."), question: F("?", { beforeExpr: E }), questionDot: F("?."), arrow: F("=>", { beforeExpr: E }), template: F("template"), ellipsis: F("...", { beforeExpr: E }), backQuote: F("`", { startsExpr: y }), dollarBraceL: F("${", { beforeExpr: E, startsExpr: y }), templateTail: F("...`", { startsExpr: y }), templateNonTail: F("...${", { beforeExpr: E, startsExpr: y }), at: F("@"), hash: F("#", { startsExpr: y }), interpreterDirective: F("#!..."), eq: F("=", { beforeExpr: E, isAssign: V }), assign: F("_=", { beforeExpr: E, isAssign: V }), slashAssign: F("_=", { beforeExpr: E, isAssign: V }), xorAssign: F("_=", { beforeExpr: E, isAssign: V }), moduloAssign: F("_=", { beforeExpr: E, isAssign: V }), incDec: F("++/--", { prefix: X, postfix: Q, startsExpr: y }), bang: F("!", { beforeExpr: E, prefix: X, startsExpr: y }), tilde: F("~", { beforeExpr: E, prefix: X, startsExpr: y }), doubleCaret: F("^^", { startsExpr: y }), doubleAt: F("@@", { startsExpr: y }), pipeline: Z("|>", 0), nullishCoalescing: Z("??", 1), logicalOR: Z("||", 1), logicalAND: Z("&&", 2), bitwiseOR: Z("|", 3), bitwiseXOR: Z("^", 4), bitwiseAND: Z("&", 5), equality: Z("==/!=/===/!==", 6), lt: Z("</>/<=/>=", 7), gt: Z("</>/<=/>=", 7), relational: Z("</>/<=/>=", 7), bitShift: Z("<</>>/>>>", 8), bitShiftL: Z("<</>>/>>>", 8), bitShiftR: Z("<</>>/>>>", 8), plusMin: F("+/-", { beforeExpr: E, binop: 9, prefix: X, startsExpr: y }), modulo: F("%", { binop: 10, startsExpr: y }), star: F("*", { binop: 10 }), slash: Z("/", 10), exponent: F("**", { beforeExpr: E, binop: 11, rightAssociative: !0 }), _in: C("in", { beforeExpr: E, binop: 7 }), _instanceof: C("instanceof", { beforeExpr: E, binop: 7 }), _break: C("break"), _case: C("case", { beforeExpr: E }), _catch: C("catch"), _continue: C("continue"), _debugger: C("debugger"), _default: C("default", { beforeExpr: E }), _else: C("else", { beforeExpr: E }), _finally: C("finally"), _function: C("function", { startsExpr: y }), _if: C("if"), _return: C("return", { beforeExpr: E }), _switch: C("switch"), _throw: C("throw", { beforeExpr: E, prefix: X, startsExpr: y }), _try: C("try"), _var: C("var"), _const: C("const"), _with: C("with"), _new: C("new", { beforeExpr: E, startsExpr: y }), _this: C("this", { startsExpr: y }), _super: C("super", { startsExpr: y }), _class: C("class", { startsExpr: y }), _extends: C("extends", { beforeExpr: E }), _export: C("export"), _import: C("import", { startsExpr: y }), _null: C("null", { startsExpr: y }), _true: C("true", { startsExpr: y }), _false: C("false", { startsExpr: y }), _typeof: C("typeof", { beforeExpr: E, prefix: X, startsExpr: y }), _void: C("void", { beforeExpr: E, prefix: X, startsExpr: y }), _delete: C("delete", { beforeExpr: E, prefix: X, startsExpr: y }), _do: C("do", { isLoop: O, beforeExpr: E }), _for: C("for", { isLoop: O }), _while: C("while", { isLoop: O }), _as: G("as", { startsExpr: y }), _assert: G("assert", { startsExpr: y }), _async: G("async", { startsExpr: y }), _await: G("await", { startsExpr: y }), _from: G("from", { startsExpr: y }), _get: G("get", { startsExpr: y }), _let: G("let", { startsExpr: y }), _meta: G("meta", { startsExpr: y }), _of: G("of", { startsExpr: y }), _sent: G("sent", { startsExpr: y }), _set: G("set", { startsExpr: y }), _static: G("static", { startsExpr: y }), _using: G("using", { startsExpr: y }), _yield: G("yield", { startsExpr: y }), _asserts: G("asserts", { startsExpr: y }), _checks: G("checks", { startsExpr: y }), _exports: G("exports", { startsExpr: y }), _global: G("global", { startsExpr: y }), _implements: G("implements", { startsExpr: y }), _intrinsic: G("intrinsic", { startsExpr: y }), _infer: G("infer", { startsExpr: y }), _is: G("is", { startsExpr: y }), _mixins: G("mixins", { startsExpr: y }), _proto: G("proto", { startsExpr: y }), _require: G("require", { startsExpr: y }), _satisfies: G("satisfies", { startsExpr: y }), _keyof: G("keyof", { startsExpr: y }), _readonly: G("readonly", { startsExpr: y }), _unique: G("unique", { startsExpr: y }), _abstract: G("abstract", { startsExpr: y }), _declare: G("declare", { startsExpr: y }), _enum: G("enum", { startsExpr: y }), _module: G("module", { startsExpr: y }), _namespace: G("namespace", { startsExpr: y }), _interface: G("interface", { startsExpr: y }), _type: G("type", { startsExpr: y }), _opaque: G("opaque", { startsExpr: y }), name: F("name", { startsExpr: y }), string: F("string", { startsExpr: y }), num: F("num", { startsExpr: y }), bigint: F("bigint", { startsExpr: y }), decimal: F("decimal", { startsExpr: y }), regexp: F("regexp", { startsExpr: y }), privateName: F("#name", { startsExpr: y }), eof: F("eof"), jsxName: F("jsxName"), jsxText: F("jsxText", { beforeExpr: !0 }), jsxTagStart: F("jsxTagStart", { startsExpr: !0 }), jsxTagEnd: F("jsxTagEnd"), placeholder: F("%%", { startsExpr: !0 }) };
        function te(t) {
          return t >= 93 && t <= 130;
        }
        function we(t) {
          return t <= 92;
        }
        function Ae(t) {
          return t >= 58 && t <= 130;
        }
        function xt(t) {
          return t >= 58 && t <= 134;
        }
        function be(t) {
          return ee[t];
        }
        function rt(t) {
          return pe[t];
        }
        function Ca(t) {
          return t >= 29 && t <= 33;
        }
        function or(t) {
          return t >= 127 && t <= 129;
        }
        function va(t) {
          return t >= 90 && t <= 92;
        }
        function Gt(t) {
          return t >= 58 && t <= 92;
        }
        function Sa(t) {
          return t >= 39 && t <= 59;
        }
        function wa(t) {
          return t === 34;
        }
        function Ia(t) {
          return xe[t];
        }
        function Na(t) {
          return t >= 119 && t <= 121;
        }
        function ka(t) {
          return t >= 122 && t <= 128;
        }
        function Be(t) {
          return Y[t];
        }
        function gt(t) {
          return he[t];
        }
        function Da(t) {
          return t === 57;
        }
        function Pt(t) {
          return t >= 24 && t <= 25;
        }
        function Ie(t) {
          return H[t];
        }
        H[8].updateContext = (t) => {
          t.pop();
        }, H[5].updateContext = H[7].updateContext = H[23].updateContext = (t) => {
          t.push(g.brace);
        }, H[22].updateContext = (t) => {
          t[t.length - 1] === g.template ? t.pop() : t.push(g.template);
        }, H[140].updateContext = (t) => {
          t.push(g.j_expr, g.j_oTag);
        };
        function At(t, e) {
          if (t == null)
            return {};
          var s = {}, r = Object.keys(t), i, a;
          for (a = 0; a < r.length; a++)
            i = r[a], !(e.indexOf(i) >= 0) && (s[i] = t[i]);
          return s;
        }
        var Me = class {
          constructor(t, e, s) {
            this.line = void 0, this.column = void 0, this.index = void 0, this.line = t, this.column = e, this.index = s;
          }
        }, bt = class {
          constructor(t, e) {
            this.start = void 0, this.end = void 0, this.filename = void 0, this.identifierName = void 0, this.start = t, this.end = e;
          }
        };
        function fe(t, e) {
          let { line: s, column: r, index: i } = t;
          return new Me(s, r + e, i + e);
        }
        var Yt = { SyntaxError: "BABEL_PARSER_SYNTAX_ERROR", SourceTypeModuleError: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED" }, Fa = function(t) {
          let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t.length - 1;
          return { get() {
            return t.reduce((s, r) => s[r], this);
          }, set(s) {
            t.reduce((r, i, a) => a === e ? r[i] = s : r[i], this);
          } };
        }, La = (t, e, s) => Object.keys(s).map((r) => [r, s[r]]).filter((r) => {
          let [, i] = r;
          return !!i;
        }).map((r) => {
          let [i, a] = r;
          return [i, typeof a == "function" ? { value: a, enumerable: !1 } : typeof a.reflect == "string" ? Object.assign({}, a, Fa(a.reflect.split("."))) : a];
        }).reduce((r, i) => {
          let [a, n] = i;
          return Object.defineProperty(r, a, Object.assign({ configurable: !0 }, n));
        }, Object.assign(new t(), e)), Ba = { ImportMetaOutsideModule: { message: `import.meta may appear only with 'sourceType: "module"'`, code: Yt.SourceTypeModuleError }, ImportOutsideModule: { message: `'import' and 'export' may appear only with 'sourceType: "module"'`, code: Yt.SourceTypeModuleError } }, hr = { ArrayPattern: "array destructuring pattern", AssignmentExpression: "assignment expression", AssignmentPattern: "assignment expression", ArrowFunctionExpression: "arrow function expression", ConditionalExpression: "conditional expression", CatchClause: "catch clause", ForOfStatement: "for-of statement", ForInStatement: "for-in statement", ForStatement: "for-loop", FormalParameters: "function parameter list", Identifier: "identifier", ImportSpecifier: "import specifier", ImportDefaultSpecifier: "import default specifier", ImportNamespaceSpecifier: "import namespace specifier", ObjectPattern: "object destructuring pattern", ParenthesizedExpression: "parenthesized expression", RestElement: "rest element", UpdateExpression: { true: "prefix operation", false: "postfix operation" }, VariableDeclarator: "variable declaration", YieldExpression: "yield expression" }, Qt = (t) => {
          let { type: e, prefix: s } = t;
          return e === "UpdateExpression" ? hr.UpdateExpression[String(s)] : hr[e];
        }, Ma = { AccessorIsGenerator: (t) => {
          let { kind: e } = t;
          return `A ${e}ter cannot be a generator.`;
        }, ArgumentsInClass: "'arguments' is only allowed in functions and class methods.", AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.", AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.", AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.", AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.", AwaitInUsingBinding: "'await' is not allowed to be used as a name in 'using' declarations.", AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.", AwaitNotInAsyncFunction: "'await' is only allowed within async functions.", BadGetterArity: "A 'get' accessor must not have any formal parameters.", BadSetterArity: "A 'set' accessor must have exactly one formal parameter.", BadSetterRestParameter: "A 'set' accessor function argument must not be a rest parameter.", ConstructorClassField: "Classes may not have a field named 'constructor'.", ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.", ConstructorIsAccessor: "Class constructor may not be an accessor.", ConstructorIsAsync: "Constructor can't be an async function.", ConstructorIsGenerator: "Constructor can't be a generator.", DeclarationMissingInitializer: (t) => {
          let { kind: e } = t;
          return `Missing initializer in ${e} declaration.`;
        }, DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.", DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. Remove the 'decoratorsBeforeExport: true' option to use the 'export @decorator class {}' syntax.", DecoratorsBeforeAfterExport: "Decorators can be placed *either* before or after the 'export' keyword, but not in both locations at the same time.", DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?", DecoratorExportClass: "Decorators must be placed *after* the 'export' keyword. Remove the 'decoratorsBeforeExport: false' option to use the '@decorator export class {}' syntax.", DecoratorSemicolon: "Decorators must not be followed by a semicolon.", DecoratorStaticBlock: "Decorators can't be used with a static block.", DeletePrivateField: "Deleting a private field is not allowed.", DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.", DuplicateConstructor: "Duplicate constructor in the same class.", DuplicateDefaultExport: "Only one default export allowed per module.", DuplicateExport: (t) => {
          let { exportName: e } = t;
          return `\`${e}\` has already been exported. Exported identifiers must be unique.`;
        }, DuplicateProto: "Redefinition of __proto__ property.", DuplicateRegExpFlags: "Duplicate regular expression flag.", ElementAfterRest: "Rest element must be last element.", EscapedCharNotAnIdentifier: "Invalid Unicode escape.", ExportBindingIsString: (t) => {
          let { localName: e, exportName: s } = t;
          return `A string literal cannot be used as an exported binding without \`from\`.
- Did you mean \`export { '${e}' as '${s}' } from 'some-module'\`?`;
        }, ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.", ForInOfLoopInitializer: (t) => {
          let { type: e } = t;
          return `'${e === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`;
        }, ForInUsing: "For-in loop may not start with 'using' declaration.", ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.", ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.", GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.", IllegalBreakContinue: (t) => {
          let { type: e } = t;
          return `Unsyntactic ${e === "BreakStatement" ? "break" : "continue"}.`;
        }, IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.", IllegalReturn: "'return' outside of function.", ImportBindingIsString: (t) => {
          let { importName: e } = t;
          return `A string literal cannot be used as an imported binding.
- Did you mean \`import { "${e}" as foo }\`?`;
        }, ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments.", ImportCallArity: (t) => {
          let { maxArgumentCount: e } = t;
          return `\`import()\` requires exactly ${e === 1 ? "one argument" : "one or two arguments"}.`;
        }, ImportCallNotNewExpression: "Cannot use new with import(...).", ImportCallSpreadArgument: "`...` is not allowed in `import()`.", ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.", ImportReflectionHasAssertion: "`import module x` cannot have assertions.", ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.', IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.", InvalidBigIntLiteral: "Invalid BigIntLiteral.", InvalidCodePoint: "Code point out of bounds.", InvalidCoverInitializedName: "Invalid shorthand property initializer.", InvalidDecimal: "Invalid decimal.", InvalidDigit: (t) => {
          let { radix: e } = t;
          return `Expected number in radix ${e}.`;
        }, InvalidEscapeSequence: "Bad character escape sequence.", InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.", InvalidEscapedReservedWord: (t) => {
          let { reservedWord: e } = t;
          return `Escape sequence in keyword ${e}.`;
        }, InvalidIdentifier: (t) => {
          let { identifierName: e } = t;
          return `Invalid identifier ${e}.`;
        }, InvalidLhs: (t) => {
          let { ancestor: e } = t;
          return `Invalid left-hand side in ${Qt(e)}.`;
        }, InvalidLhsBinding: (t) => {
          let { ancestor: e } = t;
          return `Binding invalid left-hand side in ${Qt(e)}.`;
        }, InvalidNumber: "Invalid number.", InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.", InvalidOrUnexpectedToken: (t) => {
          let { unexpected: e } = t;
          return `Unexpected character '${e}'.`;
        }, InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.", InvalidPrivateFieldResolution: (t) => {
          let { identifierName: e } = t;
          return `Private name #${e} is not defined.`;
        }, InvalidPropertyBindingPattern: "Binding member expression.", InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.", InvalidRestAssignmentPattern: "Invalid rest operator's argument.", LabelRedeclaration: (t) => {
          let { labelName: e } = t;
          return `Label '${e}' is already declared.`;
        }, LetInLexicalBinding: "'let' is not allowed to be used as a name in 'let' or 'const' declarations.", LineTerminatorBeforeArrow: "No line break is allowed before '=>'.", MalformedRegExpFlags: "Invalid regular expression flag.", MissingClassName: "A class name is required.", MissingEqInAssignment: "Only '=' operator can be used for specifying default value.", MissingSemicolon: "Missing semicolon.", MissingPlugin: (t) => {
          let { missingPlugin: e } = t;
          return `This experimental syntax requires enabling the parser plugin: ${e.map((s) => JSON.stringify(s)).join(", ")}.`;
        }, MissingOneOfPlugins: (t) => {
          let { missingPlugin: e } = t;
          return `This experimental syntax requires enabling one of the following parser plugin(s): ${e.map((s) => JSON.stringify(s)).join(", ")}.`;
        }, MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.", MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.", ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.", ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.", ModuleAttributesWithDuplicateKeys: (t) => {
          let { key: e } = t;
          return `Duplicate key "${e}" is not allowed in module attributes.`;
        }, ModuleExportNameHasLoneSurrogate: (t) => {
          let { surrogateCharCode: e } = t;
          return `An export name cannot include a lone surrogate, found '\\u${e.toString(16)}'.`;
        }, ModuleExportUndefined: (t) => {
          let { localName: e } = t;
          return `Export '${e}' is not defined.`;
        }, MultipleDefaultsInSwitch: "Multiple default clauses.", NewlineAfterThrow: "Illegal newline after throw.", NoCatchOrFinally: "Missing catch or finally clause.", NumberIdentifier: "Identifier directly after number.", NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.", ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.", OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.", OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.", OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.", ParamDupe: "Argument name clash.", PatternHasAccessor: "Object pattern can't contain getter or setter.", PatternHasMethod: "Object pattern can't contain methods.", PrivateInExpectedIn: (t) => {
          let { identifierName: e } = t;
          return `Private names are only allowed in property accesses (\`obj.#${e}\`) or in \`in\` expressions (\`#${e} in obj\`).`;
        }, PrivateNameRedeclaration: (t) => {
          let { identifierName: e } = t;
          return `Duplicate private name #${e}.`;
        }, RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", RecordNoProto: "'__proto__' is not allowed in Record expressions.", RestTrailingComma: "Unexpected trailing comma after rest element.", SloppyFunction: "In non-strict mode code, functions can only be declared at top level or inside a block.", SloppyFunctionAnnexB: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.", StaticPrototype: "Classes may not have static property named prototype.", SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?", SuperPrivateField: "Private fields can't be accessed on super.", TrailingDecorator: "Decorators must be attached to a class element.", TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.", UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.', UnexpectedDigitAfterHash: "Unexpected digit after hash token.", UnexpectedImportExport: "'import' and 'export' may only appear at the top level.", UnexpectedKeyword: (t) => {
          let { keyword: e } = t;
          return `Unexpected keyword '${e}'.`;
        }, UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.", UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.", UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.", UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.", UnexpectedPrivateField: "Unexpected private name.", UnexpectedReservedWord: (t) => {
          let { reservedWord: e } = t;
          return `Unexpected reserved word '${e}'.`;
        }, UnexpectedSuper: "'super' is only allowed in object methods and classes.", UnexpectedToken: (t) => {
          let { expected: e, unexpected: s } = t;
          return `Unexpected token${s ? ` '${s}'.` : ""}${e ? `, expected "${e}"` : ""}`;
        }, UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.", UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script`.", UnsupportedBind: "Binding should be performed on object property.", UnsupportedDecoratorExport: "A decorated export must export a class declaration.", UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.", UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.", UnsupportedMetaProperty: (t) => {
          let { target: e, onlyValidPropertyName: s } = t;
          return `The only valid meta property for ${e} is ${e}.${s}.`;
        }, UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.", UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.", UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).", UnterminatedComment: "Unterminated comment.", UnterminatedRegExp: "Unterminated regular expression.", UnterminatedString: "Unterminated string constant.", UnterminatedTemplate: "Unterminated template.", UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.", VarRedeclaration: (t) => {
          let { identifierName: e } = t;
          return `Identifier '${e}' has already been declared.`;
        }, YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.", YieldInParameter: "Yield expression is not allowed in formal parameters.", ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0." }, Oa = { StrictDelete: "Deleting local variable in strict mode.", StrictEvalArguments: (t) => {
          let { referenceName: e } = t;
          return `Assigning to '${e}' in strict mode.`;
        }, StrictEvalArgumentsBinding: (t) => {
          let { bindingName: e } = t;
          return `Binding '${e}' in strict mode.`;
        }, StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.", StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.", StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.", StrictWith: "'with' in strict mode." }, ja = /* @__PURE__ */ new Set(["ArrowFunctionExpression", "AssignmentExpression", "ConditionalExpression", "YieldExpression"]), Ra = { PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.", PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.', PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.", PipeTopicUnconfiguredToken: (t) => {
          let { token: e } = t;
          return `Invalid topic token ${e}. In order to use ${e} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${e}" }.`;
        }, PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.", PipeUnparenthesizedBody: (t) => {
          let { type: e } = t;
          return `Hack-style pipe body cannot be an unparenthesized ${Qt({ type: e })}; please wrap it in parentheses.`;
        }, PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.', PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.", PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.", PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.", PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.", PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.' }, Ua = ["toMessage"], _a = ["message"];
        function za(t) {
          let { toMessage: e } = t, s = At(t, Ua);
          return function r(i) {
            let { loc: a, details: n } = i;
            return La(SyntaxError, Object.assign({}, s, { loc: a }), { clone() {
              let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h = o.loc || {};
              return r({ loc: new Me("line" in h ? h.line : this.loc.line, "column" in h ? h.column : this.loc.column, "index" in h ? h.index : this.loc.index), details: Object.assign({}, this.details, o.details) });
            }, details: { value: n, enumerable: !1 }, message: { get() {
              return `${e(this.details)} (${this.loc.line}:${this.loc.column})`;
            }, set(o) {
              Object.defineProperty(this, "message", { value: o });
            } }, pos: { reflect: "loc.index", enumerable: !0 }, missingPlugin: "missingPlugin" in n && { reflect: "details.missingPlugin", enumerable: !0 } });
          };
        }
        function Ne(t, e) {
          if (Array.isArray(t))
            return (r) => Ne(r, t[0]);
          let s = {};
          for (let r of Object.keys(t)) {
            let i = t[r], a = typeof i == "string" ? { message: () => i } : typeof i == "function" ? { message: i } : i, { message: n } = a, o = At(a, _a), h = typeof n == "string" ? () => n : n;
            s[r] = za(Object.assign({ code: Yt.SyntaxError, reasonCode: r, toMessage: h }, e ? { syntaxPlugin: e } : {}, o));
          }
          return s;
        }
        var p = Object.assign({}, Ne(Ba), Ne(Ma), Ne(Oa), Ne`pipelineOperator`(Ra)), { defineProperty: Ha } = Object, lr = (t, e) => Ha(t, e, { enumerable: !1, value: t[e] });
        function it(t) {
          return t.loc.start && lr(t.loc.start, "index"), t.loc.end && lr(t.loc.end, "index"), t;
        }
        var $a = (t) => class extends t {
          parse() {
            let e = it(super.parse());
            return this.options.tokens && (e.tokens = e.tokens.map(it)), e;
          }
          parseRegExpLiteral(e) {
            let { pattern: s, flags: r } = e, i = null;
            try {
              i = new RegExp(s, r);
            } catch {
            }
            let a = this.estreeParseLiteral(i);
            return a.regex = { pattern: s, flags: r }, a;
          }
          parseBigIntLiteral(e) {
            let s;
            try {
              s = BigInt(e);
            } catch {
              s = null;
            }
            let r = this.estreeParseLiteral(s);
            return r.bigint = String(r.value || e), r;
          }
          parseDecimalLiteral(e) {
            let s = this.estreeParseLiteral(null);
            return s.decimal = String(s.value || e), s;
          }
          estreeParseLiteral(e) {
            return this.parseLiteral(e, "Literal");
          }
          parseStringLiteral(e) {
            return this.estreeParseLiteral(e);
          }
          parseNumericLiteral(e) {
            return this.estreeParseLiteral(e);
          }
          parseNullLiteral() {
            return this.estreeParseLiteral(null);
          }
          parseBooleanLiteral(e) {
            return this.estreeParseLiteral(e);
          }
          directiveToStmt(e) {
            let s = e.value;
            delete e.value, s.type = "Literal", s.raw = s.extra.raw, s.value = s.extra.expressionValue;
            let r = e;
            return r.type = "ExpressionStatement", r.expression = s, r.directive = s.extra.rawValue, delete s.extra, r;
          }
          initFunction(e, s) {
            super.initFunction(e, s), e.expression = !1;
          }
          checkDeclaration(e) {
            e != null && this.isObjectProperty(e) ? this.checkDeclaration(e.value) : super.checkDeclaration(e);
          }
          getObjectOrClassMethodParams(e) {
            return e.value.params;
          }
          isValidDirective(e) {
            var s;
            return e.type === "ExpressionStatement" && e.expression.type === "Literal" && typeof e.expression.value == "string" && !((s = e.expression.extra) != null && s.parenthesized);
          }
          parseBlockBody(e, s, r, i, a) {
            super.parseBlockBody(e, s, r, i, a);
            let n = e.directives.map((o) => this.directiveToStmt(o));
            e.body = n.concat(e.body), delete e.directives;
          }
          pushClassMethod(e, s, r, i, a, n) {
            this.parseMethod(s, r, i, a, n, "ClassMethod", !0), s.typeParameters && (s.value.typeParameters = s.typeParameters, delete s.typeParameters), e.body.push(s);
          }
          parsePrivateName() {
            let e = super.parsePrivateName();
            return this.getPluginOption("estree", "classFeatures") ? this.convertPrivateNameToPrivateIdentifier(e) : e;
          }
          convertPrivateNameToPrivateIdentifier(e) {
            let s = super.getPrivateNameSV(e);
            return e = e, delete e.id, e.name = s, e.type = "PrivateIdentifier", e;
          }
          isPrivateName(e) {
            return this.getPluginOption("estree", "classFeatures") ? e.type === "PrivateIdentifier" : super.isPrivateName(e);
          }
          getPrivateNameSV(e) {
            return this.getPluginOption("estree", "classFeatures") ? e.name : super.getPrivateNameSV(e);
          }
          parseLiteral(e, s) {
            let r = super.parseLiteral(e, s);
            return r.raw = r.extra.raw, delete r.extra, r;
          }
          parseFunctionBody(e, s) {
            let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            super.parseFunctionBody(e, s, r), e.expression = e.body.type !== "BlockStatement";
          }
          parseMethod(e, s, r, i, a, n) {
            let o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !1, h = this.startNode();
            return h.kind = e.kind, h = super.parseMethod(h, s, r, i, a, n, o), h.type = "FunctionExpression", delete h.kind, e.value = h, n === "ClassPrivateMethod" && (e.computed = !1), this.finishNode(e, "MethodDefinition");
          }
          parseClassProperty() {
            let e = super.parseClassProperty(...arguments);
            return this.getPluginOption("estree", "classFeatures") && (e.type = "PropertyDefinition"), e;
          }
          parseClassPrivateProperty() {
            let e = super.parseClassPrivateProperty(...arguments);
            return this.getPluginOption("estree", "classFeatures") && (e.type = "PropertyDefinition", e.computed = !1), e;
          }
          parseObjectMethod(e, s, r, i, a) {
            let n = super.parseObjectMethod(e, s, r, i, a);
            return n && (n.type = "Property", n.kind === "method" && (n.kind = "init"), n.shorthand = !1), n;
          }
          parseObjectProperty(e, s, r, i) {
            let a = super.parseObjectProperty(e, s, r, i);
            return a && (a.kind = "init", a.type = "Property"), a;
          }
          isValidLVal(e, s, r) {
            return e === "Property" ? "value" : super.isValidLVal(e, s, r);
          }
          isAssignable(e, s) {
            return e != null && this.isObjectProperty(e) ? this.isAssignable(e.value, s) : super.isAssignable(e, s);
          }
          toAssignable(e) {
            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            if (e != null && this.isObjectProperty(e)) {
              let { key: r, value: i } = e;
              this.isPrivateName(r) && this.classScope.usePrivateName(this.getPrivateNameSV(r), r.loc.start), this.toAssignable(i, s);
            } else
              super.toAssignable(e, s);
          }
          toAssignableObjectExpressionProp(e, s, r) {
            e.kind === "get" || e.kind === "set" ? this.raise(p.PatternHasAccessor, { at: e.key }) : e.method ? this.raise(p.PatternHasMethod, { at: e.key }) : super.toAssignableObjectExpressionProp(e, s, r);
          }
          finishCallExpression(e, s) {
            let r = super.finishCallExpression(e, s);
            if (r.callee.type === "Import") {
              if (r.type = "ImportExpression", r.source = r.arguments[0], this.hasPlugin("importAssertions")) {
                var i;
                r.attributes = (i = r.arguments[1]) != null ? i : null;
              }
              delete r.arguments, delete r.callee;
            }
            return r;
          }
          toReferencedArguments(e) {
            e.type !== "ImportExpression" && super.toReferencedArguments(e);
          }
          parseExport(e, s) {
            let r = this.state.lastTokStartLoc, i = super.parseExport(e, s);
            switch (i.type) {
              case "ExportAllDeclaration":
                i.exported = null;
                break;
              case "ExportNamedDeclaration":
                i.specifiers.length === 1 && i.specifiers[0].type === "ExportNamespaceSpecifier" && (i.type = "ExportAllDeclaration", i.exported = i.specifiers[0].exported, delete i.specifiers);
              case "ExportDefaultDeclaration":
                {
                  var a;
                  let { declaration: n } = i;
                  (n == null ? void 0 : n.type) === "ClassDeclaration" && ((a = n.decorators) == null ? void 0 : a.length) > 0 && n.start === i.start && this.resetStartLocation(i, r);
                }
                break;
            }
            return i;
          }
          parseSubscript(e, s, r, i) {
            let a = super.parseSubscript(e, s, r, i);
            if (i.optionalChainMember) {
              if ((a.type === "OptionalMemberExpression" || a.type === "OptionalCallExpression") && (a.type = a.type.substring(8)), i.stop) {
                let n = this.startNodeAtNode(a);
                return n.expression = a, this.finishNode(n, "ChainExpression");
              }
            } else
              (a.type === "MemberExpression" || a.type === "CallExpression") && (a.optional = !1);
            return a;
          }
          hasPropertyAsPrivateName(e) {
            return e.type === "ChainExpression" && (e = e.expression), super.hasPropertyAsPrivateName(e);
          }
          isObjectProperty(e) {
            return e.type === "Property" && e.kind === "init" && !e.method;
          }
          isObjectMethod(e) {
            return e.method || e.kind === "get" || e.kind === "set";
          }
          finishNodeAt(e, s, r) {
            return it(super.finishNodeAt(e, s, r));
          }
          resetStartLocation(e, s) {
            super.resetStartLocation(e, s), it(e);
          }
          resetEndLocation(e) {
            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
            super.resetEndLocation(e, s), it(e);
          }
        }, Zt = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", pr = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿", Va = new RegExp("[" + Zt + "]"), qa = new RegExp("[" + Zt + pr + "]");
        Zt = pr = null;
        var ur = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938, 6, 4191], Ka = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
        function es(t, e) {
          let s = 65536;
          for (let r = 0, i = e.length; r < i; r += 2) {
            if (s += e[r], s > t)
              return !1;
            if (s += e[r + 1], s >= t)
              return !0;
          }
          return !1;
        }
        function ke(t) {
          return t < 65 ? t === 36 : t <= 90 ? !0 : t < 97 ? t === 95 : t <= 122 ? !0 : t <= 65535 ? t >= 170 && Va.test(String.fromCharCode(t)) : es(t, ur);
        }
        function Je(t) {
          return t < 48 ? t === 36 : t < 58 ? !0 : t < 65 ? !1 : t <= 90 ? !0 : t < 97 ? t === 95 : t <= 122 ? !0 : t <= 65535 ? t >= 170 && qa.test(String.fromCharCode(t)) : es(t, ur) || es(t, Ka);
        }
        var ts = { keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"], strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"], strictBind: ["eval", "arguments"] }, Wa = new Set(ts.keyword), Ja = new Set(ts.strict), Xa = new Set(ts.strictBind);
        function cr(t, e) {
          return e && t === "await" || t === "enum";
        }
        function dr(t, e) {
          return cr(t, e) || Ja.has(t);
        }
        function mr(t) {
          return Xa.has(t);
        }
        function fr(t, e) {
          return dr(t, e) || mr(t);
        }
        function Ga(t) {
          return Wa.has(t);
        }
        function Ya(t, e, s) {
          return t === 64 && e === 64 && ke(s);
        }
        var Qa = /* @__PURE__ */ new Set(["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete", "implements", "interface", "let", "package", "private", "protected", "public", "static", "yield", "eval", "arguments", "enum", "await"]);
        function Za(t) {
          return Qa.has(t);
        }
        var Xe = 0, Ge = 1, De = 2, ss = 4, yr = 8, Tt = 16, xr = 32, _e = 64, Et = 128, Ye = 256, Ct = Ge | De | Et | Ye, Se = 1, ze = 2, gr = 4, He = 8, vt = 16, Pr = 64, St = 128, rs = 256, is = 512, as = 1024, ns = 2048, at = 4096, wt = 8192, Ar = Se | ze | He | St | wt, Qe = Se | 0 | He | wt, en = Se | 0 | He | 0, It = Se | 0 | gr | 0, br = Se | 0 | vt | 0, tn = 0 | ze | 0 | St, sn = 0 | ze | 0 | 0, Tr = Se | ze | He | rs | wt, Er = 0 | as, Oe = 0 | Pr, rn = Se | 0 | 0 | Pr, an = Tr | is, nn = 0 | as, Cr = 0 | ze | 0 | at, on = ns, Nt = 4, os = 2, hs = 1, ls = os | hs, hn = os | Nt, ln = hs | Nt, pn = os, un = hs, ps = 0, us = class {
          constructor(t) {
            this.var = /* @__PURE__ */ new Set(), this.lexical = /* @__PURE__ */ new Set(), this.functions = /* @__PURE__ */ new Set(), this.flags = t;
          }
        }, cs = class {
          constructor(t, e) {
            this.parser = void 0, this.scopeStack = [], this.inModule = void 0, this.undefinedExports = /* @__PURE__ */ new Map(), this.parser = t, this.inModule = e;
          }
          get inTopLevel() {
            return (this.currentScope().flags & Ge) > 0;
          }
          get inFunction() {
            return (this.currentVarScopeFlags() & De) > 0;
          }
          get allowSuper() {
            return (this.currentThisScopeFlags() & Tt) > 0;
          }
          get allowDirectSuper() {
            return (this.currentThisScopeFlags() & xr) > 0;
          }
          get inClass() {
            return (this.currentThisScopeFlags() & _e) > 0;
          }
          get inClassAndNotInNonArrowFunction() {
            let t = this.currentThisScopeFlags();
            return (t & _e) > 0 && (t & De) === 0;
          }
          get inStaticBlock() {
            for (let t = this.scopeStack.length - 1; ; t--) {
              let { flags: e } = this.scopeStack[t];
              if (e & Et)
                return !0;
              if (e & (Ct | _e))
                return !1;
            }
          }
          get inNonArrowFunction() {
            return (this.currentThisScopeFlags() & De) > 0;
          }
          get treatFunctionsAsVar() {
            return this.treatFunctionsAsVarInScope(this.currentScope());
          }
          createScope(t) {
            return new us(t);
          }
          enter(t) {
            this.scopeStack.push(this.createScope(t));
          }
          exit() {
            return this.scopeStack.pop().flags;
          }
          treatFunctionsAsVarInScope(t) {
            return !!(t.flags & (De | Et) || !this.parser.inModule && t.flags & Ge);
          }
          declareName(t, e, s) {
            let r = this.currentScope();
            if (e & He || e & vt)
              this.checkRedeclarationInScope(r, t, e, s), e & vt ? r.functions.add(t) : r.lexical.add(t), e & He && this.maybeExportDefined(r, t);
            else if (e & gr)
              for (let i = this.scopeStack.length - 1; i >= 0 && (r = this.scopeStack[i], this.checkRedeclarationInScope(r, t, e, s), r.var.add(t), this.maybeExportDefined(r, t), !(r.flags & Ct)); --i)
                ;
            this.parser.inModule && r.flags & Ge && this.undefinedExports.delete(t);
          }
          maybeExportDefined(t, e) {
            this.parser.inModule && t.flags & Ge && this.undefinedExports.delete(e);
          }
          checkRedeclarationInScope(t, e, s, r) {
            this.isRedeclaredInScope(t, e, s) && this.parser.raise(p.VarRedeclaration, { at: r, identifierName: e });
          }
          isRedeclaredInScope(t, e, s) {
            return s & Se ? s & He ? t.lexical.has(e) || t.functions.has(e) || t.var.has(e) : s & vt ? t.lexical.has(e) || !this.treatFunctionsAsVarInScope(t) && t.var.has(e) : t.lexical.has(e) && !(t.flags & yr && t.lexical.values().next().value === e) || !this.treatFunctionsAsVarInScope(t) && t.functions.has(e) : !1;
          }
          checkLocalExport(t) {
            let { name: e } = t, s = this.scopeStack[0];
            !s.lexical.has(e) && !s.var.has(e) && !s.functions.has(e) && this.undefinedExports.set(e, t.loc.start);
          }
          currentScope() {
            return this.scopeStack[this.scopeStack.length - 1];
          }
          currentVarScopeFlags() {
            for (let t = this.scopeStack.length - 1; ; t--) {
              let { flags: e } = this.scopeStack[t];
              if (e & Ct)
                return e;
            }
          }
          currentThisScopeFlags() {
            for (let t = this.scopeStack.length - 1; ; t--) {
              let { flags: e } = this.scopeStack[t];
              if (e & (Ct | _e) && !(e & ss))
                return e;
            }
          }
        }, cn = class extends us {
          constructor() {
            super(...arguments), this.declareFunctions = /* @__PURE__ */ new Set();
          }
        }, dn = class extends cs {
          createScope(t) {
            return new cn(t);
          }
          declareName(t, e, s) {
            let r = this.currentScope();
            if (e & ns) {
              this.checkRedeclarationInScope(r, t, e, s), this.maybeExportDefined(r, t), r.declareFunctions.add(t);
              return;
            }
            super.declareName(t, e, s);
          }
          isRedeclaredInScope(t, e, s) {
            return super.isRedeclaredInScope(t, e, s) ? !0 : s & ns ? !t.declareFunctions.has(e) && (t.lexical.has(e) || t.functions.has(e)) : !1;
          }
          checkLocalExport(t) {
            this.scopeStack[0].declareFunctions.has(t.name) || super.checkLocalExport(t);
          }
        }, mn = class {
          constructor() {
            this.sawUnambiguousESM = !1, this.ambiguousScriptDifferentAst = !1;
          }
          hasPlugin(t) {
            if (typeof t == "string")
              return this.plugins.has(t);
            {
              let [e, s] = t;
              if (!this.hasPlugin(e))
                return !1;
              let r = this.plugins.get(e);
              for (let i of Object.keys(s))
                if ((r == null ? void 0 : r[i]) !== s[i])
                  return !1;
              return !0;
            }
          }
          getPluginOption(t, e) {
            var s;
            return (s = this.plugins.get(t)) == null ? void 0 : s[e];
          }
        };
        function vr(t, e) {
          t.trailingComments === void 0 ? t.trailingComments = e : t.trailingComments.unshift(...e);
        }
        function fn(t, e) {
          t.leadingComments === void 0 ? t.leadingComments = e : t.leadingComments.unshift(...e);
        }
        function nt(t, e) {
          t.innerComments === void 0 ? t.innerComments = e : t.innerComments.unshift(...e);
        }
        function ot(t, e, s) {
          let r = null, i = e.length;
          for (; r === null && i > 0; )
            r = e[--i];
          r === null || r.start > s.start ? nt(t, s.comments) : vr(r, s.comments);
        }
        var yn = class extends mn {
          addComment(t) {
            this.filename && (t.loc.filename = this.filename), this.state.comments.push(t);
          }
          processComment(t) {
            let { commentStack: e } = this.state, s = e.length;
            if (s === 0)
              return;
            let r = s - 1, i = e[r];
            i.start === t.end && (i.leadingNode = t, r--);
            let { start: a } = t;
            for (; r >= 0; r--) {
              let n = e[r], o = n.end;
              if (o > a)
                n.containingNode = t, this.finalizeComment(n), e.splice(r, 1);
              else {
                o === a && (n.trailingNode = t);
                break;
              }
            }
          }
          finalizeComment(t) {
            let { comments: e } = t;
            if (t.leadingNode !== null || t.trailingNode !== null)
              t.leadingNode !== null && vr(t.leadingNode, e), t.trailingNode !== null && fn(t.trailingNode, e);
            else {
              let { containingNode: s, start: r } = t;
              if (this.input.charCodeAt(r - 1) === 44)
                switch (s.type) {
                  case "ObjectExpression":
                  case "ObjectPattern":
                  case "RecordExpression":
                    ot(s, s.properties, t);
                    break;
                  case "CallExpression":
                  case "OptionalCallExpression":
                    ot(s, s.arguments, t);
                    break;
                  case "FunctionDeclaration":
                  case "FunctionExpression":
                  case "ArrowFunctionExpression":
                  case "ObjectMethod":
                  case "ClassMethod":
                  case "ClassPrivateMethod":
                    ot(s, s.params, t);
                    break;
                  case "ArrayExpression":
                  case "ArrayPattern":
                  case "TupleExpression":
                    ot(s, s.elements, t);
                    break;
                  case "ExportNamedDeclaration":
                  case "ImportDeclaration":
                    ot(s, s.specifiers, t);
                    break;
                  default:
                    nt(s, e);
                }
              else
                nt(s, e);
            }
          }
          finalizeRemainingComments() {
            let { commentStack: t } = this.state;
            for (let e = t.length - 1; e >= 0; e--)
              this.finalizeComment(t[e]);
            this.state.commentStack = [];
          }
          resetPreviousNodeTrailingComments(t) {
            let { commentStack: e } = this.state, { length: s } = e;
            if (s === 0)
              return;
            let r = e[s - 1];
            r.leadingNode === t && (r.leadingNode = null);
          }
          takeSurroundingComments(t, e, s) {
            let { commentStack: r } = this.state, i = r.length;
            if (i === 0)
              return;
            let a = i - 1;
            for (; a >= 0; a--) {
              let n = r[a], o = n.end;
              if (n.start === s)
                n.leadingNode = t;
              else if (o === e)
                n.trailingNode = t;
              else if (o < e)
                break;
            }
          }
        }, ds = /\r\n?|[\n\u2028\u2029]/, kt = new RegExp(ds.source, "g");
        function ht(t) {
          switch (t) {
            case 10:
            case 13:
            case 8232:
            case 8233:
              return !0;
            default:
              return !1;
          }
        }
        var ms = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, xn = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/y, Sr = new RegExp("(?=(" + xn.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source, "y");
        function gn(t) {
          switch (t) {
            case 9:
            case 11:
            case 12:
            case 32:
            case 160:
            case 5760:
            case 8192:
            case 8193:
            case 8194:
            case 8195:
            case 8196:
            case 8197:
            case 8198:
            case 8199:
            case 8200:
            case 8201:
            case 8202:
            case 8239:
            case 8287:
            case 12288:
            case 65279:
              return !0;
            default:
              return !1;
          }
        }
        var wr = class {
          constructor() {
            this.strict = void 0, this.curLine = void 0, this.lineStart = void 0, this.startLoc = void 0, this.endLoc = void 0, this.errors = [], this.potentialArrowAt = -1, this.noArrowAt = [], this.noArrowParamsConversionAt = [], this.maybeInArrowParameters = !1, this.inType = !1, this.noAnonFunctionType = !1, this.hasFlowComment = !1, this.isAmbientContext = !1, this.inAbstractClass = !1, this.inDisallowConditionalTypesContext = !1, this.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null }, this.soloAwait = !1, this.inFSharpPipelineDirectBody = !1, this.labels = [], this.comments = [], this.commentStack = [], this.pos = 0, this.type = 137, this.value = null, this.start = 0, this.end = 0, this.lastTokEndLoc = null, this.lastTokStartLoc = null, this.lastTokStart = 0, this.context = [g.brace], this.canStartJSXElement = !0, this.containsEsc = !1, this.firstInvalidTemplateEscapePos = null, this.strictErrors = /* @__PURE__ */ new Map(), this.tokensLength = 0;
          }
          init(t) {
            let { strictMode: e, sourceType: s, startLine: r, startColumn: i } = t;
            this.strict = e === !1 ? !1 : e === !0 ? !0 : s === "module", this.curLine = r, this.lineStart = -i, this.startLoc = this.endLoc = new Me(r, i, 0);
          }
          curPosition() {
            return new Me(this.curLine, this.pos - this.lineStart, this.pos);
          }
          clone(t) {
            let e = new wr(), s = Object.keys(this);
            for (let r = 0, i = s.length; r < i; r++) {
              let a = s[r], n = this[a];
              !t && Array.isArray(n) && (n = n.slice()), e[a] = n;
            }
            return e;
          }
        }, Pn = function(t) {
          return t >= 48 && t <= 57;
        }, Ir = { decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]), hex: /* @__PURE__ */ new Set([46, 88, 95, 120]) }, Dt = { bin: (t) => t === 48 || t === 49, oct: (t) => t >= 48 && t <= 55, dec: (t) => t >= 48 && t <= 57, hex: (t) => t >= 48 && t <= 57 || t >= 65 && t <= 70 || t >= 97 && t <= 102 };
        function Nr(t, e, s, r, i, a) {
          let n = s, o = r, h = i, l = "", f = null, T = s, { length: R } = e;
          for (; ; ) {
            if (s >= R) {
              a.unterminated(n, o, h), l += e.slice(T, s);
              break;
            }
            let B = e.charCodeAt(s);
            if (An(t, B, e, s)) {
              l += e.slice(T, s);
              break;
            }
            if (B === 92) {
              l += e.slice(T, s);
              let se = bn(e, s, r, i, t === "template", a);
              se.ch === null && !f ? f = { pos: s, lineStart: r, curLine: i } : l += se.ch, { pos: s, lineStart: r, curLine: i } = se, T = s;
            } else
              B === 8232 || B === 8233 ? (++s, ++i, r = s) : B === 10 || B === 13 ? t === "template" ? (l += e.slice(T, s) + `
`, ++s, B === 13 && e.charCodeAt(s) === 10 && ++s, ++i, T = r = s) : a.unterminated(n, o, h) : ++s;
          }
          return { pos: s, str: l, firstInvalidLoc: f, lineStart: r, curLine: i, containsInvalid: !!f };
        }
        function An(t, e, s, r) {
          return t === "template" ? e === 96 || e === 36 && s.charCodeAt(r + 1) === 123 : e === (t === "double" ? 34 : 39);
        }
        function bn(t, e, s, r, i, a) {
          let n = !i;
          e++;
          let o = (l) => ({ pos: e, ch: l, lineStart: s, curLine: r }), h = t.charCodeAt(e++);
          switch (h) {
            case 110:
              return o(`
`);
            case 114:
              return o("\r");
            case 120: {
              let l;
              return { code: l, pos: e } = fs(t, e, s, r, 2, !1, n, a), o(l === null ? null : String.fromCharCode(l));
            }
            case 117: {
              let l;
              return { code: l, pos: e } = Dr(t, e, s, r, n, a), o(l === null ? null : String.fromCodePoint(l));
            }
            case 116:
              return o("	");
            case 98:
              return o("\b");
            case 118:
              return o("\v");
            case 102:
              return o("\f");
            case 13:
              t.charCodeAt(e) === 10 && ++e;
            case 10:
              s = e, ++r;
            case 8232:
            case 8233:
              return o("");
            case 56:
            case 57:
              if (i)
                return o(null);
              a.strictNumericEscape(e - 1, s, r);
            default:
              if (h >= 48 && h <= 55) {
                let l = e - 1, f = t.slice(l, e + 2).match(/^[0-7]+/)[0], T = parseInt(f, 8);
                T > 255 && (f = f.slice(0, -1), T = parseInt(f, 8)), e += f.length - 1;
                let R = t.charCodeAt(e);
                if (f !== "0" || R === 56 || R === 57) {
                  if (i)
                    return o(null);
                  a.strictNumericEscape(l, s, r);
                }
                return o(String.fromCharCode(T));
              }
              return o(String.fromCharCode(h));
          }
        }
        function fs(t, e, s, r, i, a, n, o) {
          let h = e, l;
          return { n: l, pos: e } = kr(t, e, s, r, 16, i, a, !1, o, !n), l === null && (n ? o.invalidEscapeSequence(h, s, r) : e = h - 1), { code: l, pos: e };
        }
        function kr(t, e, s, r, i, a, n, o, h, l) {
          let f = e, T = i === 16 ? Ir.hex : Ir.decBinOct, R = i === 16 ? Dt.hex : i === 10 ? Dt.dec : i === 8 ? Dt.oct : Dt.bin, B = !1, se = 0;
          for (let re = 0, ce = a ?? 1 / 0; re < ce; ++re) {
            let de = t.charCodeAt(e), oe;
            if (de === 95 && o !== "bail") {
              let jt = t.charCodeAt(e - 1), ut = t.charCodeAt(e + 1);
              if (o) {
                if (Number.isNaN(ut) || !R(ut) || T.has(jt) || T.has(ut)) {
                  if (l)
                    return { n: null, pos: e };
                  h.unexpectedNumericSeparator(e, s, r);
                }
              } else {
                if (l)
                  return { n: null, pos: e };
                h.numericSeparatorInEscapeSequence(e, s, r);
              }
              ++e;
              continue;
            }
            if (de >= 97 ? oe = de - 97 + 10 : de >= 65 ? oe = de - 65 + 10 : Pn(de) ? oe = de - 48 : oe = 1 / 0, oe >= i) {
              if (oe <= 9 && l)
                return { n: null, pos: e };
              if (oe <= 9 && h.invalidDigit(e, s, r, i))
                oe = 0;
              else if (n)
                oe = 0, B = !0;
              else
                break;
            }
            ++e, se = se * i + oe;
          }
          return e === f || a != null && e - f !== a || B ? { n: null, pos: e } : { n: se, pos: e };
        }
        function Dr(t, e, s, r, i, a) {
          let n = t.charCodeAt(e), o;
          if (n === 123) {
            if (++e, { code: o, pos: e } = fs(t, e, s, r, t.indexOf("}", e) - e, !0, i, a), ++e, o !== null && o > 1114111)
              if (i)
                a.invalidCodePoint(e, s, r);
              else
                return { code: null, pos: e };
          } else
            ({ code: o, pos: e } = fs(t, e, s, r, 4, !1, i, a));
          return { code: o, pos: e };
        }
        var Tn = ["at"], En = ["at"];
        function lt(t, e, s) {
          return new Me(s, t - e, t);
        }
        var Cn = /* @__PURE__ */ new Set([103, 109, 115, 105, 121, 117, 100, 118]), je = class {
          constructor(t) {
            this.type = t.type, this.value = t.value, this.start = t.start, this.end = t.end, this.loc = new bt(t.startLoc, t.endLoc);
          }
        }, vn = class extends yn {
          constructor(t, e) {
            super(), this.isLookahead = void 0, this.tokens = [], this.errorHandlers_readInt = { invalidDigit: (s, r, i, a) => this.options.errorRecovery ? (this.raise(p.InvalidDigit, { at: lt(s, r, i), radix: a }), !0) : !1, numericSeparatorInEscapeSequence: this.errorBuilder(p.NumericSeparatorInEscapeSequence), unexpectedNumericSeparator: this.errorBuilder(p.UnexpectedNumericSeparator) }, this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, { invalidEscapeSequence: this.errorBuilder(p.InvalidEscapeSequence), invalidCodePoint: this.errorBuilder(p.InvalidCodePoint) }), this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: (s, r, i) => {
              this.recordStrictModeErrors(p.StrictNumericEscape, { at: lt(s, r, i) });
            }, unterminated: (s, r, i) => {
              throw this.raise(p.UnterminatedString, { at: lt(s - 1, r, i) });
            } }), this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: this.errorBuilder(p.StrictNumericEscape), unterminated: (s, r, i) => {
              throw this.raise(p.UnterminatedTemplate, { at: lt(s, r, i) });
            } }), this.state = new wr(), this.state.init(t), this.input = e, this.length = e.length, this.isLookahead = !1;
          }
          pushToken(t) {
            this.tokens.length = this.state.tokensLength, this.tokens.push(t), ++this.state.tokensLength;
          }
          next() {
            this.checkKeywordEscapes(), this.options.tokens && this.pushToken(new je(this.state)), this.state.lastTokStart = this.state.start, this.state.lastTokEndLoc = this.state.endLoc, this.state.lastTokStartLoc = this.state.startLoc, this.nextToken();
          }
          eat(t) {
            return this.match(t) ? (this.next(), !0) : !1;
          }
          match(t) {
            return this.state.type === t;
          }
          createLookaheadState(t) {
            return { pos: t.pos, value: null, type: t.type, start: t.start, end: t.end, context: [this.curContext()], inType: t.inType, startLoc: t.startLoc, lastTokEndLoc: t.lastTokEndLoc, curLine: t.curLine, lineStart: t.lineStart, curPosition: t.curPosition };
          }
          lookahead() {
            let t = this.state;
            this.state = this.createLookaheadState(t), this.isLookahead = !0, this.nextToken(), this.isLookahead = !1;
            let e = this.state;
            return this.state = t, e;
          }
          nextTokenStart() {
            return this.nextTokenStartSince(this.state.pos);
          }
          nextTokenStartSince(t) {
            return ms.lastIndex = t, ms.test(this.input) ? ms.lastIndex : t;
          }
          lookaheadCharCode() {
            return this.input.charCodeAt(this.nextTokenStart());
          }
          codePointAtPos(t) {
            let e = this.input.charCodeAt(t);
            if ((e & 64512) === 55296 && ++t < this.input.length) {
              let s = this.input.charCodeAt(t);
              (s & 64512) === 56320 && (e = 65536 + ((e & 1023) << 10) + (s & 1023));
            }
            return e;
          }
          setStrict(t) {
            this.state.strict = t, t && (this.state.strictErrors.forEach((e) => {
              let [s, r] = e;
              return this.raise(s, { at: r });
            }), this.state.strictErrors.clear());
          }
          curContext() {
            return this.state.context[this.state.context.length - 1];
          }
          nextToken() {
            if (this.skipSpace(), this.state.start = this.state.pos, this.isLookahead || (this.state.startLoc = this.state.curPosition()), this.state.pos >= this.length) {
              this.finishToken(137);
              return;
            }
            this.getTokenFromCode(this.codePointAtPos(this.state.pos));
          }
          skipBlockComment(t) {
            let e;
            this.isLookahead || (e = this.state.curPosition());
            let s = this.state.pos, r = this.input.indexOf(t, s + 2);
            if (r === -1)
              throw this.raise(p.UnterminatedComment, { at: this.state.curPosition() });
            for (this.state.pos = r + t.length, kt.lastIndex = s + 2; kt.test(this.input) && kt.lastIndex <= r; )
              ++this.state.curLine, this.state.lineStart = kt.lastIndex;
            if (this.isLookahead)
              return;
            let i = { type: "CommentBlock", value: this.input.slice(s + 2, r), start: s, end: r + t.length, loc: new bt(e, this.state.curPosition()) };
            return this.options.tokens && this.pushToken(i), i;
          }
          skipLineComment(t) {
            let e = this.state.pos, s;
            this.isLookahead || (s = this.state.curPosition());
            let r = this.input.charCodeAt(this.state.pos += t);
            if (this.state.pos < this.length)
              for (; !ht(r) && ++this.state.pos < this.length; )
                r = this.input.charCodeAt(this.state.pos);
            if (this.isLookahead)
              return;
            let i = this.state.pos, a = { type: "CommentLine", value: this.input.slice(e + t, i), start: e, end: i, loc: new bt(s, this.state.curPosition()) };
            return this.options.tokens && this.pushToken(a), a;
          }
          skipSpace() {
            let t = this.state.pos, e = [];
            e:
              for (; this.state.pos < this.length; ) {
                let s = this.input.charCodeAt(this.state.pos);
                switch (s) {
                  case 32:
                  case 160:
                  case 9:
                    ++this.state.pos;
                    break;
                  case 13:
                    this.input.charCodeAt(this.state.pos + 1) === 10 && ++this.state.pos;
                  case 10:
                  case 8232:
                  case 8233:
                    ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;
                    break;
                  case 47:
                    switch (this.input.charCodeAt(this.state.pos + 1)) {
                      case 42: {
                        let r = this.skipBlockComment("*/");
                        r !== void 0 && (this.addComment(r), this.options.attachComment && e.push(r));
                        break;
                      }
                      case 47: {
                        let r = this.skipLineComment(2);
                        r !== void 0 && (this.addComment(r), this.options.attachComment && e.push(r));
                        break;
                      }
                      default:
                        break e;
                    }
                    break;
                  default:
                    if (gn(s))
                      ++this.state.pos;
                    else if (s === 45 && !this.inModule && this.options.annexB) {
                      let r = this.state.pos;
                      if (this.input.charCodeAt(r + 1) === 45 && this.input.charCodeAt(r + 2) === 62 && (t === 0 || this.state.lineStart > t)) {
                        let i = this.skipLineComment(3);
                        i !== void 0 && (this.addComment(i), this.options.attachComment && e.push(i));
                      } else
                        break e;
                    } else if (s === 60 && !this.inModule && this.options.annexB) {
                      let r = this.state.pos;
                      if (this.input.charCodeAt(r + 1) === 33 && this.input.charCodeAt(r + 2) === 45 && this.input.charCodeAt(r + 3) === 45) {
                        let i = this.skipLineComment(4);
                        i !== void 0 && (this.addComment(i), this.options.attachComment && e.push(i));
                      } else
                        break e;
                    } else
                      break e;
                }
              }
            if (e.length > 0) {
              let s = this.state.pos, r = { start: t, end: s, comments: e, leadingNode: null, trailingNode: null, containingNode: null };
              this.state.commentStack.push(r);
            }
          }
          finishToken(t, e) {
            this.state.end = this.state.pos, this.state.endLoc = this.state.curPosition();
            let s = this.state.type;
            this.state.type = t, this.state.value = e, this.isLookahead || this.updateContext(s);
          }
          replaceToken(t) {
            this.state.type = t, this.updateContext();
          }
          readToken_numberSign() {
            if (this.state.pos === 0 && this.readToken_interpreter())
              return;
            let t = this.state.pos + 1, e = this.codePointAtPos(t);
            if (e >= 48 && e <= 57)
              throw this.raise(p.UnexpectedDigitAfterHash, { at: this.state.curPosition() });
            if (e === 123 || e === 91 && this.hasPlugin("recordAndTuple")) {
              if (this.expectPlugin("recordAndTuple"), this.getPluginOption("recordAndTuple", "syntaxType") === "bar")
                throw this.raise(e === 123 ? p.RecordExpressionHashIncorrectStartSyntaxType : p.TupleExpressionHashIncorrectStartSyntaxType, { at: this.state.curPosition() });
              this.state.pos += 2, e === 123 ? this.finishToken(7) : this.finishToken(1);
            } else
              ke(e) ? (++this.state.pos, this.finishToken(136, this.readWord1(e))) : e === 92 ? (++this.state.pos, this.finishToken(136, this.readWord1())) : this.finishOp(27, 1);
          }
          readToken_dot() {
            let t = this.input.charCodeAt(this.state.pos + 1);
            if (t >= 48 && t <= 57) {
              this.readNumber(!0);
              return;
            }
            t === 46 && this.input.charCodeAt(this.state.pos + 2) === 46 ? (this.state.pos += 3, this.finishToken(21)) : (++this.state.pos, this.finishToken(16));
          }
          readToken_slash() {
            this.input.charCodeAt(this.state.pos + 1) === 61 ? this.finishOp(31, 2) : this.finishOp(56, 1);
          }
          readToken_interpreter() {
            if (this.state.pos !== 0 || this.length < 2)
              return !1;
            let t = this.input.charCodeAt(this.state.pos + 1);
            if (t !== 33)
              return !1;
            let e = this.state.pos;
            for (this.state.pos += 1; !ht(t) && ++this.state.pos < this.length; )
              t = this.input.charCodeAt(this.state.pos);
            let s = this.input.slice(e + 2, this.state.pos);
            return this.finishToken(28, s), !0;
          }
          readToken_mult_modulo(t) {
            let e = t === 42 ? 55 : 54, s = 1, r = this.input.charCodeAt(this.state.pos + 1);
            t === 42 && r === 42 && (s++, r = this.input.charCodeAt(this.state.pos + 2), e = 57), r === 61 && !this.state.inType && (s++, e = t === 37 ? 33 : 30), this.finishOp(e, s);
          }
          readToken_pipe_amp(t) {
            let e = this.input.charCodeAt(this.state.pos + 1);
            if (e === t) {
              this.input.charCodeAt(this.state.pos + 2) === 61 ? this.finishOp(30, 3) : this.finishOp(t === 124 ? 41 : 42, 2);
              return;
            }
            if (t === 124) {
              if (e === 62) {
                this.finishOp(39, 2);
                return;
              }
              if (this.hasPlugin("recordAndTuple") && e === 125) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                  throw this.raise(p.RecordExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                this.state.pos += 2, this.finishToken(9);
                return;
              }
              if (this.hasPlugin("recordAndTuple") && e === 93) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                  throw this.raise(p.TupleExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                this.state.pos += 2, this.finishToken(4);
                return;
              }
            }
            if (e === 61) {
              this.finishOp(30, 2);
              return;
            }
            this.finishOp(t === 124 ? 43 : 45, 1);
          }
          readToken_caret() {
            let t = this.input.charCodeAt(this.state.pos + 1);
            t === 61 && !this.state.inType ? this.finishOp(32, 2) : t === 94 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "^^" }]) ? (this.finishOp(37, 2), this.input.codePointAt(this.state.pos) === 94 && this.unexpected()) : this.finishOp(44, 1);
          }
          readToken_atSign() {
            this.input.charCodeAt(this.state.pos + 1) === 64 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "@@" }]) ? this.finishOp(38, 2) : this.finishOp(26, 1);
          }
          readToken_plus_min(t) {
            let e = this.input.charCodeAt(this.state.pos + 1);
            if (e === t) {
              this.finishOp(34, 2);
              return;
            }
            e === 61 ? this.finishOp(30, 2) : this.finishOp(53, 1);
          }
          readToken_lt() {
            let { pos: t } = this.state, e = this.input.charCodeAt(t + 1);
            if (e === 60) {
              if (this.input.charCodeAt(t + 2) === 61) {
                this.finishOp(30, 3);
                return;
              }
              this.finishOp(51, 2);
              return;
            }
            if (e === 61) {
              this.finishOp(49, 2);
              return;
            }
            this.finishOp(47, 1);
          }
          readToken_gt() {
            let { pos: t } = this.state, e = this.input.charCodeAt(t + 1);
            if (e === 62) {
              let s = this.input.charCodeAt(t + 2) === 62 ? 3 : 2;
              if (this.input.charCodeAt(t + s) === 61) {
                this.finishOp(30, s + 1);
                return;
              }
              this.finishOp(52, s);
              return;
            }
            if (e === 61) {
              this.finishOp(49, 2);
              return;
            }
            this.finishOp(48, 1);
          }
          readToken_eq_excl(t) {
            let e = this.input.charCodeAt(this.state.pos + 1);
            if (e === 61) {
              this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
              return;
            }
            if (t === 61 && e === 62) {
              this.state.pos += 2, this.finishToken(19);
              return;
            }
            this.finishOp(t === 61 ? 29 : 35, 1);
          }
          readToken_question() {
            let t = this.input.charCodeAt(this.state.pos + 1), e = this.input.charCodeAt(this.state.pos + 2);
            t === 63 ? e === 61 ? this.finishOp(30, 3) : this.finishOp(40, 2) : t === 46 && !(e >= 48 && e <= 57) ? (this.state.pos += 2, this.finishToken(18)) : (++this.state.pos, this.finishToken(17));
          }
          getTokenFromCode(t) {
            switch (t) {
              case 46:
                this.readToken_dot();
                return;
              case 40:
                ++this.state.pos, this.finishToken(10);
                return;
              case 41:
                ++this.state.pos, this.finishToken(11);
                return;
              case 59:
                ++this.state.pos, this.finishToken(13);
                return;
              case 44:
                ++this.state.pos, this.finishToken(12);
                return;
              case 91:
                if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                  if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                    throw this.raise(p.TupleExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                  this.state.pos += 2, this.finishToken(2);
                } else
                  ++this.state.pos, this.finishToken(0);
                return;
              case 93:
                ++this.state.pos, this.finishToken(3);
                return;
              case 123:
                if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                  if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                    throw this.raise(p.RecordExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                  this.state.pos += 2, this.finishToken(6);
                } else
                  ++this.state.pos, this.finishToken(5);
                return;
              case 125:
                ++this.state.pos, this.finishToken(8);
                return;
              case 58:
                this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58 ? this.finishOp(15, 2) : (++this.state.pos, this.finishToken(14));
                return;
              case 63:
                this.readToken_question();
                return;
              case 96:
                this.readTemplateToken();
                return;
              case 48: {
                let e = this.input.charCodeAt(this.state.pos + 1);
                if (e === 120 || e === 88) {
                  this.readRadixNumber(16);
                  return;
                }
                if (e === 111 || e === 79) {
                  this.readRadixNumber(8);
                  return;
                }
                if (e === 98 || e === 66) {
                  this.readRadixNumber(2);
                  return;
                }
              }
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                this.readNumber(!1);
                return;
              case 34:
              case 39:
                this.readString(t);
                return;
              case 47:
                this.readToken_slash();
                return;
              case 37:
              case 42:
                this.readToken_mult_modulo(t);
                return;
              case 124:
              case 38:
                this.readToken_pipe_amp(t);
                return;
              case 94:
                this.readToken_caret();
                return;
              case 43:
              case 45:
                this.readToken_plus_min(t);
                return;
              case 60:
                this.readToken_lt();
                return;
              case 62:
                this.readToken_gt();
                return;
              case 61:
              case 33:
                this.readToken_eq_excl(t);
                return;
              case 126:
                this.finishOp(36, 1);
                return;
              case 64:
                this.readToken_atSign();
                return;
              case 35:
                this.readToken_numberSign();
                return;
              case 92:
                this.readWord();
                return;
              default:
                if (ke(t)) {
                  this.readWord(t);
                  return;
                }
            }
            throw this.raise(p.InvalidOrUnexpectedToken, { at: this.state.curPosition(), unexpected: String.fromCodePoint(t) });
          }
          finishOp(t, e) {
            let s = this.input.slice(this.state.pos, this.state.pos + e);
            this.state.pos += e, this.finishToken(t, s);
          }
          readRegexp() {
            let t = this.state.startLoc, e = this.state.start + 1, s, r, { pos: i } = this.state;
            for (; ; ++i) {
              if (i >= this.length)
                throw this.raise(p.UnterminatedRegExp, { at: fe(t, 1) });
              let h = this.input.charCodeAt(i);
              if (ht(h))
                throw this.raise(p.UnterminatedRegExp, { at: fe(t, 1) });
              if (s)
                s = !1;
              else {
                if (h === 91)
                  r = !0;
                else if (h === 93 && r)
                  r = !1;
                else if (h === 47 && !r)
                  break;
                s = h === 92;
              }
            }
            let a = this.input.slice(e, i);
            ++i;
            let n = "", o = () => fe(t, i + 2 - e);
            for (; i < this.length; ) {
              let h = this.codePointAtPos(i), l = String.fromCharCode(h);
              if (Cn.has(h))
                h === 118 ? (this.expectPlugin("regexpUnicodeSets", o()), n.includes("u") && this.raise(p.IncompatibleRegExpUVFlags, { at: o() })) : h === 117 && n.includes("v") && this.raise(p.IncompatibleRegExpUVFlags, { at: o() }), n.includes(l) && this.raise(p.DuplicateRegExpFlags, { at: o() });
              else if (Je(h) || h === 92)
                this.raise(p.MalformedRegExpFlags, { at: o() });
              else
                break;
              ++i, n += l;
            }
            this.state.pos = i, this.finishToken(135, { pattern: a, flags: n });
          }
          readInt(t, e) {
            let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, { n: i, pos: a } = kr(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t, e, s, r, this.errorHandlers_readInt, !1);
            return this.state.pos = a, i;
          }
          readRadixNumber(t) {
            let e = this.state.curPosition(), s = !1;
            this.state.pos += 2;
            let r = this.readInt(t);
            r == null && this.raise(p.InvalidDigit, { at: fe(e, 2), radix: t });
            let i = this.input.charCodeAt(this.state.pos);
            if (i === 110)
              ++this.state.pos, s = !0;
            else if (i === 109)
              throw this.raise(p.InvalidDecimal, { at: e });
            if (ke(this.codePointAtPos(this.state.pos)))
              throw this.raise(p.NumberIdentifier, { at: this.state.curPosition() });
            if (s) {
              let a = this.input.slice(e.index, this.state.pos).replace(/[_n]/g, "");
              this.finishToken(133, a);
              return;
            }
            this.finishToken(132, r);
          }
          readNumber(t) {
            let e = this.state.pos, s = this.state.curPosition(), r = !1, i = !1, a = !1, n = !1, o = !1;
            !t && this.readInt(10) === null && this.raise(p.InvalidNumber, { at: this.state.curPosition() });
            let h = this.state.pos - e >= 2 && this.input.charCodeAt(e) === 48;
            if (h) {
              let R = this.input.slice(e, this.state.pos);
              if (this.recordStrictModeErrors(p.StrictOctalLiteral, { at: s }), !this.state.strict) {
                let B = R.indexOf("_");
                B > 0 && this.raise(p.ZeroDigitNumericSeparator, { at: fe(s, B) });
              }
              o = h && !/[89]/.test(R);
            }
            let l = this.input.charCodeAt(this.state.pos);
            if (l === 46 && !o && (++this.state.pos, this.readInt(10), r = !0, l = this.input.charCodeAt(this.state.pos)), (l === 69 || l === 101) && !o && (l = this.input.charCodeAt(++this.state.pos), (l === 43 || l === 45) && ++this.state.pos, this.readInt(10) === null && this.raise(p.InvalidOrMissingExponent, { at: s }), r = !0, n = !0, l = this.input.charCodeAt(this.state.pos)), l === 110 && ((r || h) && this.raise(p.InvalidBigIntLiteral, { at: s }), ++this.state.pos, i = !0), l === 109 && (this.expectPlugin("decimal", this.state.curPosition()), (n || h) && this.raise(p.InvalidDecimal, { at: s }), ++this.state.pos, a = !0), ke(this.codePointAtPos(this.state.pos)))
              throw this.raise(p.NumberIdentifier, { at: this.state.curPosition() });
            let f = this.input.slice(e, this.state.pos).replace(/[_mn]/g, "");
            if (i) {
              this.finishToken(133, f);
              return;
            }
            if (a) {
              this.finishToken(134, f);
              return;
            }
            let T = o ? parseInt(f, 8) : parseFloat(f);
            this.finishToken(132, T);
          }
          readCodePoint(t) {
            let { code: e, pos: s } = Dr(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t, this.errorHandlers_readCodePoint);
            return this.state.pos = s, e;
          }
          readString(t) {
            let { str: e, pos: s, curLine: r, lineStart: i } = Nr(t === 34 ? "double" : "single", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_string);
            this.state.pos = s + 1, this.state.lineStart = i, this.state.curLine = r, this.finishToken(131, e);
          }
          readTemplateContinuation() {
            this.match(8) || this.unexpected(null, 8), this.state.pos--, this.readTemplateToken();
          }
          readTemplateToken() {
            let t = this.input[this.state.pos], { str: e, firstInvalidLoc: s, pos: r, curLine: i, lineStart: a } = Nr("template", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_template);
            this.state.pos = r + 1, this.state.lineStart = a, this.state.curLine = i, s && (this.state.firstInvalidTemplateEscapePos = new Me(s.curLine, s.pos - s.lineStart, s.pos)), this.input.codePointAt(r) === 96 ? this.finishToken(24, s ? null : t + e + "`") : (this.state.pos++, this.finishToken(25, s ? null : t + e + "${"));
          }
          recordStrictModeErrors(t, e) {
            let { at: s } = e, r = s.index;
            this.state.strict && !this.state.strictErrors.has(r) ? this.raise(t, { at: s }) : this.state.strictErrors.set(r, [t, s]);
          }
          readWord1(t) {
            this.state.containsEsc = !1;
            let e = "", s = this.state.pos, r = this.state.pos;
            for (t !== void 0 && (this.state.pos += t <= 65535 ? 1 : 2); this.state.pos < this.length; ) {
              let i = this.codePointAtPos(this.state.pos);
              if (Je(i))
                this.state.pos += i <= 65535 ? 1 : 2;
              else if (i === 92) {
                this.state.containsEsc = !0, e += this.input.slice(r, this.state.pos);
                let a = this.state.curPosition(), n = this.state.pos === s ? ke : Je;
                if (this.input.charCodeAt(++this.state.pos) !== 117) {
                  this.raise(p.MissingUnicodeEscape, { at: this.state.curPosition() }), r = this.state.pos - 1;
                  continue;
                }
                ++this.state.pos;
                let o = this.readCodePoint(!0);
                o !== null && (n(o) || this.raise(p.EscapedCharNotAnIdentifier, { at: a }), e += String.fromCodePoint(o)), r = this.state.pos;
              } else
                break;
            }
            return e + this.input.slice(r, this.state.pos);
          }
          readWord(t) {
            let e = this.readWord1(t), s = W.get(e);
            s !== void 0 ? this.finishToken(s, Be(s)) : this.finishToken(130, e);
          }
          checkKeywordEscapes() {
            let { type: t } = this.state;
            Gt(t) && this.state.containsEsc && this.raise(p.InvalidEscapedReservedWord, { at: this.state.startLoc, reservedWord: Be(t) });
          }
          raise(t, e) {
            let { at: s } = e, r = At(e, Tn), i = s instanceof Me ? s : s.loc.start, a = t({ loc: i, details: r });
            if (!this.options.errorRecovery)
              throw a;
            return this.isLookahead || this.state.errors.push(a), a;
          }
          raiseOverwrite(t, e) {
            let { at: s } = e, r = At(e, En), i = s instanceof Me ? s : s.loc.start, a = i.index, n = this.state.errors;
            for (let o = n.length - 1; o >= 0; o--) {
              let h = n[o];
              if (h.loc.index === a)
                return n[o] = t({ loc: i, details: r });
              if (h.loc.index < a)
                break;
            }
            return this.raise(t, e);
          }
          updateContext(t) {
          }
          unexpected(t, e) {
            throw this.raise(p.UnexpectedToken, { expected: e ? Be(e) : null, at: t ?? this.state.startLoc });
          }
          expectPlugin(t, e) {
            if (this.hasPlugin(t))
              return !0;
            throw this.raise(p.MissingPlugin, { at: e ?? this.state.startLoc, missingPlugin: [t] });
          }
          expectOnePlugin(t) {
            if (!t.some((e) => this.hasPlugin(e)))
              throw this.raise(p.MissingOneOfPlugins, { at: this.state.startLoc, missingPlugin: t });
          }
          errorBuilder(t) {
            return (e, s, r) => {
              this.raise(t, { at: lt(e, s, r) });
            };
          }
        }, Sn = class {
          constructor() {
            this.privateNames = /* @__PURE__ */ new Set(), this.loneAccessors = /* @__PURE__ */ new Map(), this.undefinedPrivateNames = /* @__PURE__ */ new Map();
          }
        }, wn = class {
          constructor(t) {
            this.parser = void 0, this.stack = [], this.undefinedPrivateNames = /* @__PURE__ */ new Map(), this.parser = t;
          }
          current() {
            return this.stack[this.stack.length - 1];
          }
          enter() {
            this.stack.push(new Sn());
          }
          exit() {
            let t = this.stack.pop(), e = this.current();
            for (let [s, r] of Array.from(t.undefinedPrivateNames))
              e ? e.undefinedPrivateNames.has(s) || e.undefinedPrivateNames.set(s, r) : this.parser.raise(p.InvalidPrivateFieldResolution, { at: r, identifierName: s });
          }
          declarePrivateName(t, e, s) {
            let { privateNames: r, loneAccessors: i, undefinedPrivateNames: a } = this.current(), n = r.has(t);
            if (e & ls) {
              let o = n && i.get(t);
              if (o) {
                let h = o & Nt, l = e & Nt, f = o & ls, T = e & ls;
                n = f === T || h !== l, n || i.delete(t);
              } else
                n || i.set(t, e);
            }
            n && this.parser.raise(p.PrivateNameRedeclaration, { at: s, identifierName: t }), r.add(t), a.delete(t);
          }
          usePrivateName(t, e) {
            let s;
            for (s of this.stack)
              if (s.privateNames.has(t))
                return;
            s ? s.undefinedPrivateNames.set(t, e) : this.parser.raise(p.InvalidPrivateFieldResolution, { at: e, identifierName: t });
          }
        }, In = 0, Fr = 1, ys = 2, Lr = 3, Ft = class {
          constructor() {
            let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : In;
            this.type = void 0, this.type = t;
          }
          canBeArrowParameterDeclaration() {
            return this.type === ys || this.type === Fr;
          }
          isCertainlyParameterDeclaration() {
            return this.type === Lr;
          }
        }, Br = class extends Ft {
          constructor(t) {
            super(t), this.declarationErrors = /* @__PURE__ */ new Map();
          }
          recordDeclarationError(t, e) {
            let { at: s } = e, r = s.index;
            this.declarationErrors.set(r, [t, s]);
          }
          clearDeclarationError(t) {
            this.declarationErrors.delete(t);
          }
          iterateErrors(t) {
            this.declarationErrors.forEach(t);
          }
        }, Nn = class {
          constructor(t) {
            this.parser = void 0, this.stack = [new Ft()], this.parser = t;
          }
          enter(t) {
            this.stack.push(t);
          }
          exit() {
            this.stack.pop();
          }
          recordParameterInitializerError(t, e) {
            let { at: s } = e, r = { at: s.loc.start }, { stack: i } = this, a = i.length - 1, n = i[a];
            for (; !n.isCertainlyParameterDeclaration(); ) {
              if (n.canBeArrowParameterDeclaration())
                n.recordDeclarationError(t, r);
              else
                return;
              n = i[--a];
            }
            this.parser.raise(t, r);
          }
          recordArrowParameterBindingError(t, e) {
            let { at: s } = e, { stack: r } = this, i = r[r.length - 1], a = { at: s.loc.start };
            if (i.isCertainlyParameterDeclaration())
              this.parser.raise(t, a);
            else if (i.canBeArrowParameterDeclaration())
              i.recordDeclarationError(t, a);
            else
              return;
          }
          recordAsyncArrowParametersError(t) {
            let { at: e } = t, { stack: s } = this, r = s.length - 1, i = s[r];
            for (; i.canBeArrowParameterDeclaration(); )
              i.type === ys && i.recordDeclarationError(p.AwaitBindingIdentifier, { at: e }), i = s[--r];
          }
          validateAsPattern() {
            let { stack: t } = this, e = t[t.length - 1];
            e.canBeArrowParameterDeclaration() && e.iterateErrors((s) => {
              let [r, i] = s;
              this.parser.raise(r, { at: i });
              let a = t.length - 2, n = t[a];
              for (; n.canBeArrowParameterDeclaration(); )
                n.clearDeclarationError(i.index), n = t[--a];
            });
          }
        };
        function kn() {
          return new Ft(Lr);
        }
        function Dn() {
          return new Br(Fr);
        }
        function Fn() {
          return new Br(ys);
        }
        function Mr() {
          return new Ft();
        }
        var Ze = 0, Or = 1, Lt = 2, jr = 4, et = 8, Ln = class {
          constructor() {
            this.stacks = [];
          }
          enter(t) {
            this.stacks.push(t);
          }
          exit() {
            this.stacks.pop();
          }
          currentFlags() {
            return this.stacks[this.stacks.length - 1];
          }
          get hasAwait() {
            return (this.currentFlags() & Lt) > 0;
          }
          get hasYield() {
            return (this.currentFlags() & Or) > 0;
          }
          get hasReturn() {
            return (this.currentFlags() & jr) > 0;
          }
          get hasIn() {
            return (this.currentFlags() & et) > 0;
          }
        };
        function Bt(t, e) {
          return (t ? Lt : 0) | (e ? Or : 0);
        }
        var Bn = class extends vn {
          addExtra(t, e, s) {
            let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
            if (!t)
              return;
            let i = t.extra = t.extra || {};
            r ? i[e] = s : Object.defineProperty(i, e, { enumerable: r, value: s });
          }
          isContextual(t) {
            return this.state.type === t && !this.state.containsEsc;
          }
          isUnparsedContextual(t, e) {
            let s = t + e.length;
            if (this.input.slice(t, s) === e) {
              let r = this.input.charCodeAt(s);
              return !(Je(r) || (r & 64512) === 55296);
            }
            return !1;
          }
          isLookaheadContextual(t) {
            let e = this.nextTokenStart();
            return this.isUnparsedContextual(e, t);
          }
          eatContextual(t) {
            return this.isContextual(t) ? (this.next(), !0) : !1;
          }
          expectContextual(t, e) {
            if (!this.eatContextual(t)) {
              if (e != null)
                throw this.raise(e, { at: this.state.startLoc });
              this.unexpected(null, t);
            }
          }
          canInsertSemicolon() {
            return this.match(137) || this.match(8) || this.hasPrecedingLineBreak();
          }
          hasPrecedingLineBreak() {
            return ds.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
          }
          hasFollowingLineBreak() {
            return Sr.lastIndex = this.state.end, Sr.test(this.input);
          }
          isLineTerminator() {
            return this.eat(13) || this.canInsertSemicolon();
          }
          semicolon() {
            (!(arguments.length > 0 && arguments[0] !== void 0) || arguments[0] ? this.isLineTerminator() : this.eat(13)) || this.raise(p.MissingSemicolon, { at: this.state.lastTokEndLoc });
          }
          expect(t, e) {
            this.eat(t) || this.unexpected(e, t);
          }
          tryParse(t) {
            let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.clone(), s = { node: null };
            try {
              let r = t(function() {
                let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                throw s.node = i, s;
              });
              if (this.state.errors.length > e.errors.length) {
                let i = this.state;
                return this.state = e, this.state.tokensLength = i.tokensLength, { node: r, error: i.errors[e.errors.length], thrown: !1, aborted: !1, failState: i };
              }
              return { node: r, error: null, thrown: !1, aborted: !1, failState: null };
            } catch (r) {
              let i = this.state;
              if (this.state = e, r instanceof SyntaxError)
                return { node: null, error: r, thrown: !0, aborted: !1, failState: i };
              if (r === s)
                return { node: s.node, error: null, thrown: !1, aborted: !0, failState: i };
              throw r;
            }
          }
          checkExpressionErrors(t, e) {
            if (!t)
              return !1;
            let { shorthandAssignLoc: s, doubleProtoLoc: r, privateKeyLoc: i, optionalParametersLoc: a } = t, n = !!s || !!r || !!a || !!i;
            if (!e)
              return n;
            s != null && this.raise(p.InvalidCoverInitializedName, { at: s }), r != null && this.raise(p.DuplicateProto, { at: r }), i != null && this.raise(p.UnexpectedPrivateField, { at: i }), a != null && this.unexpected(a);
          }
          isLiteralPropertyName() {
            return xt(this.state.type);
          }
          isPrivateName(t) {
            return t.type === "PrivateName";
          }
          getPrivateNameSV(t) {
            return t.id.name;
          }
          hasPropertyAsPrivateName(t) {
            return (t.type === "MemberExpression" || t.type === "OptionalMemberExpression") && this.isPrivateName(t.property);
          }
          isObjectProperty(t) {
            return t.type === "ObjectProperty";
          }
          isObjectMethod(t) {
            return t.type === "ObjectMethod";
          }
          initializeScopes() {
            let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.sourceType === "module", e = this.state.labels;
            this.state.labels = [];
            let s = this.exportedIdentifiers;
            this.exportedIdentifiers = /* @__PURE__ */ new Set();
            let r = this.inModule;
            this.inModule = t;
            let i = this.scope, a = this.getScopeHandler();
            this.scope = new a(this, t);
            let n = this.prodParam;
            this.prodParam = new Ln();
            let o = this.classScope;
            this.classScope = new wn(this);
            let h = this.expressionScope;
            return this.expressionScope = new Nn(this), () => {
              this.state.labels = e, this.exportedIdentifiers = s, this.inModule = r, this.scope = i, this.prodParam = n, this.classScope = o, this.expressionScope = h;
            };
          }
          enterInitialScopes() {
            let t = Ze;
            this.inModule && (t |= Lt), this.scope.enter(Ge), this.prodParam.enter(t);
          }
          checkDestructuringPrivate(t) {
            let { privateKeyLoc: e } = t;
            e !== null && this.expectPlugin("destructuringPrivate", e);
          }
        }, Mt = class {
          constructor() {
            this.shorthandAssignLoc = null, this.doubleProtoLoc = null, this.privateKeyLoc = null, this.optionalParametersLoc = null;
          }
        }, Ot = class {
          constructor(t, e, s) {
            this.type = "", this.start = e, this.end = 0, this.loc = new bt(s), t != null && t.options.ranges && (this.range = [e, 0]), t != null && t.filename && (this.loc.filename = t.filename);
          }
        }, xs = Ot.prototype;
        xs.__clone = function() {
          let t = new Ot(void 0, this.start, this.loc.start), e = Object.keys(this);
          for (let s = 0, r = e.length; s < r; s++) {
            let i = e[s];
            i !== "leadingComments" && i !== "trailingComments" && i !== "innerComments" && (t[i] = this[i]);
          }
          return t;
        };
        function Mn(t) {
          return Fe(t);
        }
        function Fe(t) {
          let { type: e, start: s, end: r, loc: i, range: a, extra: n, name: o } = t, h = Object.create(xs);
          return h.type = e, h.start = s, h.end = r, h.loc = i, h.range = a, h.extra = n, h.name = o, e === "Placeholder" && (h.expectedNode = t.expectedNode), h;
        }
        function On(t) {
          let { type: e, start: s, end: r, loc: i, range: a, extra: n } = t;
          if (e === "Placeholder")
            return Mn(t);
          let o = Object.create(xs);
          return o.type = e, o.start = s, o.end = r, o.loc = i, o.range = a, t.raw !== void 0 ? o.raw = t.raw : o.extra = n, o.value = t.value, o;
        }
        var jn = class extends Bn {
          startNode() {
            return new Ot(this, this.state.start, this.state.startLoc);
          }
          startNodeAt(t) {
            return new Ot(this, t.index, t);
          }
          startNodeAtNode(t) {
            return this.startNodeAt(t.loc.start);
          }
          finishNode(t, e) {
            return this.finishNodeAt(t, e, this.state.lastTokEndLoc);
          }
          finishNodeAt(t, e, s) {
            return t.type = e, t.end = s.index, t.loc.end = s, this.options.ranges && (t.range[1] = s.index), this.options.attachComment && this.processComment(t), t;
          }
          resetStartLocation(t, e) {
            t.start = e.index, t.loc.start = e, this.options.ranges && (t.range[0] = e.index);
          }
          resetEndLocation(t) {
            let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
            t.end = e.index, t.loc.end = e, this.options.ranges && (t.range[1] = e.index);
          }
          resetStartLocationFromNode(t, e) {
            this.resetStartLocation(t, e.loc.start);
          }
        }, Rn = /* @__PURE__ */ new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]), $ = Ne`flow`({ AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.", AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.", AssignReservedType: (t) => {
          let { reservedType: e } = t;
          return `Cannot overwrite reserved type ${e}.`;
        }, DeclareClassElement: "The `declare` modifier can only appear on class fields.", DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.", DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.", EnumBooleanMemberNotInitialized: (t) => {
          let { memberName: e, enumName: s } = t;
          return `Boolean enum members need to be initialized. Use either \`${e} = true,\` or \`${e} = false,\` in enum \`${s}\`.`;
        }, EnumDuplicateMemberName: (t) => {
          let { memberName: e, enumName: s } = t;
          return `Enum member names need to be unique, but the name \`${e}\` has already been used before in enum \`${s}\`.`;
        }, EnumInconsistentMemberValues: (t) => {
          let { enumName: e } = t;
          return `Enum \`${e}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`;
        }, EnumInvalidExplicitType: (t) => {
          let { invalidEnumType: e, enumName: s } = t;
          return `Enum type \`${e}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${s}\`.`;
        }, EnumInvalidExplicitTypeUnknownSupplied: (t) => {
          let { enumName: e } = t;
          return `Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${e}\`.`;
        }, EnumInvalidMemberInitializerPrimaryType: (t) => {
          let { enumName: e, memberName: s, explicitType: r } = t;
          return `Enum \`${e}\` has type \`${r}\`, so the initializer of \`${s}\` needs to be a ${r} literal.`;
        }, EnumInvalidMemberInitializerSymbolType: (t) => {
          let { enumName: e, memberName: s } = t;
          return `Symbol enum members cannot be initialized. Use \`${s},\` in enum \`${e}\`.`;
        }, EnumInvalidMemberInitializerUnknownType: (t) => {
          let { enumName: e, memberName: s } = t;
          return `The enum member initializer for \`${s}\` needs to be a literal (either a boolean, number, or string) in enum \`${e}\`.`;
        }, EnumInvalidMemberName: (t) => {
          let { enumName: e, memberName: s, suggestion: r } = t;
          return `Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${s}\`, consider using \`${r}\`, in enum \`${e}\`.`;
        }, EnumNumberMemberNotInitialized: (t) => {
          let { enumName: e, memberName: s } = t;
          return `Number enum members need to be initialized, e.g. \`${s} = 1\` in enum \`${e}\`.`;
        }, EnumStringMemberInconsistentlyInitailized: (t) => {
          let { enumName: e } = t;
          return `String enum members need to consistently either all use initializers, or use no initializers, in enum \`${e}\`.`;
        }, GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.", ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.", InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.", InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.", InexactVariance: "Explicit inexact syntax cannot have variance.", InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.", MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.", NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.", NestedFlowComment: "Cannot have a flow comment inside another flow comment.", PatternIsOptional: Object.assign({ message: "A binding pattern parameter cannot be optional in an implementation signature." }, { reasonCode: "OptionalBindingPattern" }), SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.", SpreadVariance: "Spread properties cannot have variance.", ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.", ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.", ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.", ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.", ThisParamNoDefault: "The `this` parameter may not have a default value.", TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.", UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.", UnexpectedReservedType: (t) => {
          let { reservedType: e } = t;
          return `Unexpected reserved type ${e}.`;
        }, UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.", UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.", UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.", UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".', UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.", UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.", UnsupportedDeclareExportKind: (t) => {
          let { unsupportedExportKind: e, suggestion: s } = t;
          return `\`declare export ${e}\` is not supported. Use \`${s}\` instead.`;
        }, UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.", UnterminatedFlowComment: "Unterminated flow-comment." });
        function Un(t) {
          return t.type === "DeclareExportAllDeclaration" || t.type === "DeclareExportDeclaration" && (!t.declaration || t.declaration.type !== "TypeAlias" && t.declaration.type !== "InterfaceDeclaration");
        }
        function gs(t) {
          return t.importKind === "type" || t.importKind === "typeof";
        }
        function Rr(t) {
          return Ae(t) && t !== 97;
        }
        var _n = { const: "declare export var", let: "declare export var", type: "export type", interface: "export interface" };
        function zn(t, e) {
          let s = [], r = [];
          for (let i = 0; i < t.length; i++)
            (e(t[i], i, t) ? s : r).push(t[i]);
          return [s, r];
        }
        var Hn = /\*?\s*@((?:no)?flow)\b/, $n = (t) => class extends t {
          constructor() {
            super(...arguments), this.flowPragma = void 0;
          }
          getScopeHandler() {
            return dn;
          }
          shouldParseTypes() {
            return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
          }
          shouldParseEnums() {
            return !!this.getPluginOption("flow", "enums");
          }
          finishToken(e, s) {
            e !== 131 && e !== 13 && e !== 28 && this.flowPragma === void 0 && (this.flowPragma = null), super.finishToken(e, s);
          }
          addComment(e) {
            if (this.flowPragma === void 0) {
              let s = Hn.exec(e.value);
              if (s)
                if (s[1] === "flow")
                  this.flowPragma = "flow";
                else if (s[1] === "noflow")
                  this.flowPragma = "noflow";
                else
                  throw new Error("Unexpected flow pragma");
            }
            super.addComment(e);
          }
          flowParseTypeInitialiser(e) {
            let s = this.state.inType;
            this.state.inType = !0, this.expect(e || 14);
            let r = this.flowParseType();
            return this.state.inType = s, r;
          }
          flowParsePredicate() {
            let e = this.startNode(), s = this.state.startLoc;
            return this.next(), this.expectContextual(108), this.state.lastTokStart > s.index + 1 && this.raise($.UnexpectedSpaceBetweenModuloChecks, { at: s }), this.eat(10) ? (e.value = super.parseExpression(), this.expect(11), this.finishNode(e, "DeclaredPredicate")) : this.finishNode(e, "InferredPredicate");
          }
          flowParseTypeAndPredicateInitialiser() {
            let e = this.state.inType;
            this.state.inType = !0, this.expect(14);
            let s = null, r = null;
            return this.match(54) ? (this.state.inType = e, r = this.flowParsePredicate()) : (s = this.flowParseType(), this.state.inType = e, this.match(54) && (r = this.flowParsePredicate())), [s, r];
          }
          flowParseDeclareClass(e) {
            return this.next(), this.flowParseInterfaceish(e, !0), this.finishNode(e, "DeclareClass");
          }
          flowParseDeclareFunction(e) {
            this.next();
            let s = e.id = this.parseIdentifier(), r = this.startNode(), i = this.startNode();
            this.match(47) ? r.typeParameters = this.flowParseTypeParameterDeclaration() : r.typeParameters = null, this.expect(10);
            let a = this.flowParseFunctionTypeParams();
            return r.params = a.params, r.rest = a.rest, r.this = a._this, this.expect(11), [r.returnType, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), i.typeAnnotation = this.finishNode(r, "FunctionTypeAnnotation"), s.typeAnnotation = this.finishNode(i, "TypeAnnotation"), this.resetEndLocation(s), this.semicolon(), this.scope.declareName(e.id.name, on, e.id.loc.start), this.finishNode(e, "DeclareFunction");
          }
          flowParseDeclare(e, s) {
            if (this.match(80))
              return this.flowParseDeclareClass(e);
            if (this.match(68))
              return this.flowParseDeclareFunction(e);
            if (this.match(74))
              return this.flowParseDeclareVariable(e);
            if (this.eatContextual(125))
              return this.match(16) ? this.flowParseDeclareModuleExports(e) : (s && this.raise($.NestedDeclareModule, { at: this.state.lastTokStartLoc }), this.flowParseDeclareModule(e));
            if (this.isContextual(128))
              return this.flowParseDeclareTypeAlias(e);
            if (this.isContextual(129))
              return this.flowParseDeclareOpaqueType(e);
            if (this.isContextual(127))
              return this.flowParseDeclareInterface(e);
            if (this.match(82))
              return this.flowParseDeclareExportDeclaration(e, s);
            this.unexpected();
          }
          flowParseDeclareVariable(e) {
            return this.next(), e.id = this.flowParseTypeAnnotatableIdentifier(!0), this.scope.declareName(e.id.name, It, e.id.loc.start), this.semicolon(), this.finishNode(e, "DeclareVariable");
          }
          flowParseDeclareModule(e) {
            this.scope.enter(Xe), this.match(131) ? e.id = super.parseExprAtom() : e.id = this.parseIdentifier();
            let s = e.body = this.startNode(), r = s.body = [];
            for (this.expect(5); !this.match(8); ) {
              let n = this.startNode();
              this.match(83) ? (this.next(), !this.isContextual(128) && !this.match(87) && this.raise($.InvalidNonTypeImportInDeclareModule, { at: this.state.lastTokStartLoc }), super.parseImport(n)) : (this.expectContextual(123, $.UnsupportedStatementInDeclareModule), n = this.flowParseDeclare(n, !0)), r.push(n);
            }
            this.scope.exit(), this.expect(8), this.finishNode(s, "BlockStatement");
            let i = null, a = !1;
            return r.forEach((n) => {
              Un(n) ? (i === "CommonJS" && this.raise($.AmbiguousDeclareModuleKind, { at: n }), i = "ES") : n.type === "DeclareModuleExports" && (a && this.raise($.DuplicateDeclareModuleExports, { at: n }), i === "ES" && this.raise($.AmbiguousDeclareModuleKind, { at: n }), i = "CommonJS", a = !0);
            }), e.kind = i || "CommonJS", this.finishNode(e, "DeclareModule");
          }
          flowParseDeclareExportDeclaration(e, s) {
            if (this.expect(82), this.eat(65))
              return this.match(68) || this.match(80) ? e.declaration = this.flowParseDeclare(this.startNode()) : (e.declaration = this.flowParseType(), this.semicolon()), e.default = !0, this.finishNode(e, "DeclareExportDeclaration");
            if (this.match(75) || this.isLet() || (this.isContextual(128) || this.isContextual(127)) && !s) {
              let r = this.state.value;
              throw this.raise($.UnsupportedDeclareExportKind, { at: this.state.startLoc, unsupportedExportKind: r, suggestion: _n[r] });
            }
            if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(129))
              return e.declaration = this.flowParseDeclare(this.startNode()), e.default = !1, this.finishNode(e, "DeclareExportDeclaration");
            if (this.match(55) || this.match(5) || this.isContextual(127) || this.isContextual(128) || this.isContextual(129))
              return e = this.parseExport(e, null), e.type === "ExportNamedDeclaration" && (e.type = "ExportDeclaration", e.default = !1, delete e.exportKind), e.type = "Declare" + e.type, e;
            this.unexpected();
          }
          flowParseDeclareModuleExports(e) {
            return this.next(), this.expectContextual(109), e.typeAnnotation = this.flowParseTypeAnnotation(), this.semicolon(), this.finishNode(e, "DeclareModuleExports");
          }
          flowParseDeclareTypeAlias(e) {
            this.next();
            let s = this.flowParseTypeAlias(e);
            return s.type = "DeclareTypeAlias", s;
          }
          flowParseDeclareOpaqueType(e) {
            this.next();
            let s = this.flowParseOpaqueType(e, !0);
            return s.type = "DeclareOpaqueType", s;
          }
          flowParseDeclareInterface(e) {
            return this.next(), this.flowParseInterfaceish(e, !1), this.finishNode(e, "DeclareInterface");
          }
          flowParseInterfaceish(e, s) {
            if (e.id = this.flowParseRestrictedIdentifier(!s, !0), this.scope.declareName(e.id.name, s ? br : Qe, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.extends = [], e.implements = [], e.mixins = [], this.eat(81))
              do
                e.extends.push(this.flowParseInterfaceExtends());
              while (!s && this.eat(12));
            if (s) {
              if (this.eatContextual(115))
                do
                  e.mixins.push(this.flowParseInterfaceExtends());
                while (this.eat(12));
              if (this.eatContextual(111))
                do
                  e.implements.push(this.flowParseInterfaceExtends());
                while (this.eat(12));
            }
            e.body = this.flowParseObjectType({ allowStatic: s, allowExact: !1, allowSpread: !1, allowProto: s, allowInexact: !1 });
          }
          flowParseInterfaceExtends() {
            let e = this.startNode();
            return e.id = this.flowParseQualifiedTypeIdentifier(), this.match(47) ? e.typeParameters = this.flowParseTypeParameterInstantiation() : e.typeParameters = null, this.finishNode(e, "InterfaceExtends");
          }
          flowParseInterface(e) {
            return this.flowParseInterfaceish(e, !1), this.finishNode(e, "InterfaceDeclaration");
          }
          checkNotUnderscore(e) {
            e === "_" && this.raise($.UnexpectedReservedUnderscore, { at: this.state.startLoc });
          }
          checkReservedType(e, s, r) {
            Rn.has(e) && this.raise(r ? $.AssignReservedType : $.UnexpectedReservedType, { at: s, reservedType: e });
          }
          flowParseRestrictedIdentifier(e, s) {
            return this.checkReservedType(this.state.value, this.state.startLoc, s), this.parseIdentifier(e);
          }
          flowParseTypeAlias(e) {
            return e.id = this.flowParseRestrictedIdentifier(!1, !0), this.scope.declareName(e.id.name, Qe, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.right = this.flowParseTypeInitialiser(29), this.semicolon(), this.finishNode(e, "TypeAlias");
          }
          flowParseOpaqueType(e, s) {
            return this.expectContextual(128), e.id = this.flowParseRestrictedIdentifier(!0, !0), this.scope.declareName(e.id.name, Qe, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.supertype = null, this.match(14) && (e.supertype = this.flowParseTypeInitialiser(14)), e.impltype = null, s || (e.impltype = this.flowParseTypeInitialiser(29)), this.semicolon(), this.finishNode(e, "OpaqueType");
          }
          flowParseTypeParameter() {
            let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, s = this.state.startLoc, r = this.startNode(), i = this.flowParseVariance(), a = this.flowParseTypeAnnotatableIdentifier();
            return r.name = a.name, r.variance = i, r.bound = a.typeAnnotation, this.match(29) ? (this.eat(29), r.default = this.flowParseType()) : e && this.raise($.MissingTypeParamDefault, { at: s }), this.finishNode(r, "TypeParameter");
          }
          flowParseTypeParameterDeclaration() {
            let e = this.state.inType, s = this.startNode();
            s.params = [], this.state.inType = !0, this.match(47) || this.match(140) ? this.next() : this.unexpected();
            let r = !1;
            do {
              let i = this.flowParseTypeParameter(r);
              s.params.push(i), i.default && (r = !0), this.match(48) || this.expect(12);
            } while (!this.match(48));
            return this.expect(48), this.state.inType = e, this.finishNode(s, "TypeParameterDeclaration");
          }
          flowParseTypeParameterInstantiation() {
            let e = this.startNode(), s = this.state.inType;
            e.params = [], this.state.inType = !0, this.expect(47);
            let r = this.state.noAnonFunctionType;
            for (this.state.noAnonFunctionType = !1; !this.match(48); )
              e.params.push(this.flowParseType()), this.match(48) || this.expect(12);
            return this.state.noAnonFunctionType = r, this.expect(48), this.state.inType = s, this.finishNode(e, "TypeParameterInstantiation");
          }
          flowParseTypeParameterInstantiationCallOrNew() {
            let e = this.startNode(), s = this.state.inType;
            for (e.params = [], this.state.inType = !0, this.expect(47); !this.match(48); )
              e.params.push(this.flowParseTypeOrImplicitInstantiation()), this.match(48) || this.expect(12);
            return this.expect(48), this.state.inType = s, this.finishNode(e, "TypeParameterInstantiation");
          }
          flowParseInterfaceType() {
            let e = this.startNode();
            if (this.expectContextual(127), e.extends = [], this.eat(81))
              do
                e.extends.push(this.flowParseInterfaceExtends());
              while (this.eat(12));
            return e.body = this.flowParseObjectType({ allowStatic: !1, allowExact: !1, allowSpread: !1, allowProto: !1, allowInexact: !1 }), this.finishNode(e, "InterfaceTypeAnnotation");
          }
          flowParseObjectPropertyKey() {
            return this.match(132) || this.match(131) ? super.parseExprAtom() : this.parseIdentifier(!0);
          }
          flowParseObjectTypeIndexer(e, s, r) {
            return e.static = s, this.lookahead().type === 14 ? (e.id = this.flowParseObjectPropertyKey(), e.key = this.flowParseTypeInitialiser()) : (e.id = null, e.key = this.flowParseType()), this.expect(3), e.value = this.flowParseTypeInitialiser(), e.variance = r, this.finishNode(e, "ObjectTypeIndexer");
          }
          flowParseObjectTypeInternalSlot(e, s) {
            return e.static = s, e.id = this.flowParseObjectPropertyKey(), this.expect(3), this.expect(3), this.match(47) || this.match(10) ? (e.method = !0, e.optional = !1, e.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e.loc.start))) : (e.method = !1, this.eat(17) && (e.optional = !0), e.value = this.flowParseTypeInitialiser()), this.finishNode(e, "ObjectTypeInternalSlot");
          }
          flowParseObjectTypeMethodish(e) {
            for (e.params = [], e.rest = null, e.typeParameters = null, e.this = null, this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration()), this.expect(10), this.match(78) && (e.this = this.flowParseFunctionTypeParam(!0), e.this.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
              e.params.push(this.flowParseFunctionTypeParam(!1)), this.match(11) || this.expect(12);
            return this.eat(21) && (e.rest = this.flowParseFunctionTypeParam(!1)), this.expect(11), e.returnType = this.flowParseTypeInitialiser(), this.finishNode(e, "FunctionTypeAnnotation");
          }
          flowParseObjectTypeCallProperty(e, s) {
            let r = this.startNode();
            return e.static = s, e.value = this.flowParseObjectTypeMethodish(r), this.finishNode(e, "ObjectTypeCallProperty");
          }
          flowParseObjectType(e) {
            let { allowStatic: s, allowExact: r, allowSpread: i, allowProto: a, allowInexact: n } = e, o = this.state.inType;
            this.state.inType = !0;
            let h = this.startNode();
            h.callProperties = [], h.properties = [], h.indexers = [], h.internalSlots = [];
            let l, f, T = !1;
            for (r && this.match(6) ? (this.expect(6), l = 9, f = !0) : (this.expect(5), l = 8, f = !1), h.exact = f; !this.match(l); ) {
              let B = !1, se = null, re = null, ce = this.startNode();
              if (a && this.isContextual(116)) {
                let oe = this.lookahead();
                oe.type !== 14 && oe.type !== 17 && (this.next(), se = this.state.startLoc, s = !1);
              }
              if (s && this.isContextual(104)) {
                let oe = this.lookahead();
                oe.type !== 14 && oe.type !== 17 && (this.next(), B = !0);
              }
              let de = this.flowParseVariance();
              if (this.eat(0))
                se != null && this.unexpected(se), this.eat(0) ? (de && this.unexpected(de.loc.start), h.internalSlots.push(this.flowParseObjectTypeInternalSlot(ce, B))) : h.indexers.push(this.flowParseObjectTypeIndexer(ce, B, de));
              else if (this.match(10) || this.match(47))
                se != null && this.unexpected(se), de && this.unexpected(de.loc.start), h.callProperties.push(this.flowParseObjectTypeCallProperty(ce, B));
              else {
                let oe = "init";
                if (this.isContextual(98) || this.isContextual(103)) {
                  let ut = this.lookahead();
                  xt(ut.type) && (oe = this.state.value, this.next());
                }
                let jt = this.flowParseObjectTypeProperty(ce, B, se, de, oe, i, n ?? !f);
                jt === null ? (T = !0, re = this.state.lastTokStartLoc) : h.properties.push(jt);
              }
              this.flowObjectTypeSemicolon(), re && !this.match(8) && !this.match(9) && this.raise($.UnexpectedExplicitInexactInObject, { at: re });
            }
            this.expect(l), i && (h.inexact = T);
            let R = this.finishNode(h, "ObjectTypeAnnotation");
            return this.state.inType = o, R;
          }
          flowParseObjectTypeProperty(e, s, r, i, a, n, o) {
            if (this.eat(21))
              return this.match(12) || this.match(13) || this.match(8) || this.match(9) ? (n ? o || this.raise($.InexactInsideExact, { at: this.state.lastTokStartLoc }) : this.raise($.InexactInsideNonObject, { at: this.state.lastTokStartLoc }), i && this.raise($.InexactVariance, { at: i }), null) : (n || this.raise($.UnexpectedSpreadType, { at: this.state.lastTokStartLoc }), r != null && this.unexpected(r), i && this.raise($.SpreadVariance, { at: i }), e.argument = this.flowParseType(), this.finishNode(e, "ObjectTypeSpreadProperty"));
            {
              e.key = this.flowParseObjectPropertyKey(), e.static = s, e.proto = r != null, e.kind = a;
              let h = !1;
              return this.match(47) || this.match(10) ? (e.method = !0, r != null && this.unexpected(r), i && this.unexpected(i.loc.start), e.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e.loc.start)), (a === "get" || a === "set") && this.flowCheckGetterSetterParams(e), !n && e.key.name === "constructor" && e.value.this && this.raise($.ThisParamBannedInConstructor, { at: e.value.this })) : (a !== "init" && this.unexpected(), e.method = !1, this.eat(17) && (h = !0), e.value = this.flowParseTypeInitialiser(), e.variance = i), e.optional = h, this.finishNode(e, "ObjectTypeProperty");
            }
          }
          flowCheckGetterSetterParams(e) {
            let s = e.kind === "get" ? 0 : 1, r = e.value.params.length + (e.value.rest ? 1 : 0);
            e.value.this && this.raise(e.kind === "get" ? $.GetterMayNotHaveThisParam : $.SetterMayNotHaveThisParam, { at: e.value.this }), r !== s && this.raise(e.kind === "get" ? p.BadGetterArity : p.BadSetterArity, { at: e }), e.kind === "set" && e.value.rest && this.raise(p.BadSetterRestParameter, { at: e });
          }
          flowObjectTypeSemicolon() {
            !this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9) && this.unexpected();
          }
          flowParseQualifiedTypeIdentifier(e, s) {
            e != null || (e = this.state.startLoc);
            let r = s || this.flowParseRestrictedIdentifier(!0);
            for (; this.eat(16); ) {
              let i = this.startNodeAt(e);
              i.qualification = r, i.id = this.flowParseRestrictedIdentifier(!0), r = this.finishNode(i, "QualifiedTypeIdentifier");
            }
            return r;
          }
          flowParseGenericType(e, s) {
            let r = this.startNodeAt(e);
            return r.typeParameters = null, r.id = this.flowParseQualifiedTypeIdentifier(e, s), this.match(47) && (r.typeParameters = this.flowParseTypeParameterInstantiation()), this.finishNode(r, "GenericTypeAnnotation");
          }
          flowParseTypeofType() {
            let e = this.startNode();
            return this.expect(87), e.argument = this.flowParsePrimaryType(), this.finishNode(e, "TypeofTypeAnnotation");
          }
          flowParseTupleType() {
            let e = this.startNode();
            for (e.types = [], this.expect(0); this.state.pos < this.length && !this.match(3) && (e.types.push(this.flowParseType()), !this.match(3)); )
              this.expect(12);
            return this.expect(3), this.finishNode(e, "TupleTypeAnnotation");
          }
          flowParseFunctionTypeParam(e) {
            let s = null, r = !1, i = null, a = this.startNode(), n = this.lookahead(), o = this.state.type === 78;
            return n.type === 14 || n.type === 17 ? (o && !e && this.raise($.ThisParamMustBeFirst, { at: a }), s = this.parseIdentifier(o), this.eat(17) && (r = !0, o && this.raise($.ThisParamMayNotBeOptional, { at: a })), i = this.flowParseTypeInitialiser()) : i = this.flowParseType(), a.name = s, a.optional = r, a.typeAnnotation = i, this.finishNode(a, "FunctionTypeParam");
          }
          reinterpretTypeAsFunctionTypeParam(e) {
            let s = this.startNodeAt(e.loc.start);
            return s.name = null, s.optional = !1, s.typeAnnotation = e, this.finishNode(s, "FunctionTypeParam");
          }
          flowParseFunctionTypeParams() {
            let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = null, r = null;
            for (this.match(78) && (r = this.flowParseFunctionTypeParam(!0), r.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
              e.push(this.flowParseFunctionTypeParam(!1)), this.match(11) || this.expect(12);
            return this.eat(21) && (s = this.flowParseFunctionTypeParam(!1)), { params: e, rest: s, _this: r };
          }
          flowIdentToTypeAnnotation(e, s, r) {
            switch (r.name) {
              case "any":
                return this.finishNode(s, "AnyTypeAnnotation");
              case "bool":
              case "boolean":
                return this.finishNode(s, "BooleanTypeAnnotation");
              case "mixed":
                return this.finishNode(s, "MixedTypeAnnotation");
              case "empty":
                return this.finishNode(s, "EmptyTypeAnnotation");
              case "number":
                return this.finishNode(s, "NumberTypeAnnotation");
              case "string":
                return this.finishNode(s, "StringTypeAnnotation");
              case "symbol":
                return this.finishNode(s, "SymbolTypeAnnotation");
              default:
                return this.checkNotUnderscore(r.name), this.flowParseGenericType(e, r);
            }
          }
          flowParsePrimaryType() {
            let e = this.state.startLoc, s = this.startNode(), r, i, a = !1, n = this.state.noAnonFunctionType;
            switch (this.state.type) {
              case 5:
                return this.flowParseObjectType({ allowStatic: !1, allowExact: !1, allowSpread: !0, allowProto: !1, allowInexact: !0 });
              case 6:
                return this.flowParseObjectType({ allowStatic: !1, allowExact: !0, allowSpread: !0, allowProto: !1, allowInexact: !1 });
              case 0:
                return this.state.noAnonFunctionType = !1, i = this.flowParseTupleType(), this.state.noAnonFunctionType = n, i;
              case 47:
                return s.typeParameters = this.flowParseTypeParameterDeclaration(), this.expect(10), r = this.flowParseFunctionTypeParams(), s.params = r.params, s.rest = r.rest, s.this = r._this, this.expect(11), this.expect(19), s.returnType = this.flowParseType(), this.finishNode(s, "FunctionTypeAnnotation");
              case 10:
                if (this.next(), !this.match(11) && !this.match(21))
                  if (te(this.state.type) || this.match(78)) {
                    let o = this.lookahead().type;
                    a = o !== 17 && o !== 14;
                  } else
                    a = !0;
                if (a) {
                  if (this.state.noAnonFunctionType = !1, i = this.flowParseType(), this.state.noAnonFunctionType = n, this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19))
                    return this.expect(11), i;
                  this.eat(12);
                }
                return i ? r = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(i)]) : r = this.flowParseFunctionTypeParams(), s.params = r.params, s.rest = r.rest, s.this = r._this, this.expect(11), this.expect(19), s.returnType = this.flowParseType(), s.typeParameters = null, this.finishNode(s, "FunctionTypeAnnotation");
              case 131:
                return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
              case 85:
              case 86:
                return s.value = this.match(85), this.next(), this.finishNode(s, "BooleanLiteralTypeAnnotation");
              case 53:
                if (this.state.value === "-") {
                  if (this.next(), this.match(132))
                    return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", s);
                  if (this.match(133))
                    return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", s);
                  throw this.raise($.UnexpectedSubtractionOperand, { at: this.state.startLoc });
                }
                this.unexpected();
                return;
              case 132:
                return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
              case 133:
                return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
              case 88:
                return this.next(), this.finishNode(s, "VoidTypeAnnotation");
              case 84:
                return this.next(), this.finishNode(s, "NullLiteralTypeAnnotation");
              case 78:
                return this.next(), this.finishNode(s, "ThisTypeAnnotation");
              case 55:
                return this.next(), this.finishNode(s, "ExistsTypeAnnotation");
              case 87:
                return this.flowParseTypeofType();
              default:
                if (Gt(this.state.type)) {
                  let o = Be(this.state.type);
                  return this.next(), super.createIdentifier(s, o);
                } else if (te(this.state.type))
                  return this.isContextual(127) ? this.flowParseInterfaceType() : this.flowIdentToTypeAnnotation(e, s, this.parseIdentifier());
            }
            this.unexpected();
          }
          flowParsePostfixType() {
            let e = this.state.startLoc, s = this.flowParsePrimaryType(), r = !1;
            for (; (this.match(0) || this.match(18)) && !this.canInsertSemicolon(); ) {
              let i = this.startNodeAt(e), a = this.eat(18);
              r = r || a, this.expect(0), !a && this.match(3) ? (i.elementType = s, this.next(), s = this.finishNode(i, "ArrayTypeAnnotation")) : (i.objectType = s, i.indexType = this.flowParseType(), this.expect(3), r ? (i.optional = a, s = this.finishNode(i, "OptionalIndexedAccessType")) : s = this.finishNode(i, "IndexedAccessType"));
            }
            return s;
          }
          flowParsePrefixType() {
            let e = this.startNode();
            return this.eat(17) ? (e.typeAnnotation = this.flowParsePrefixType(), this.finishNode(e, "NullableTypeAnnotation")) : this.flowParsePostfixType();
          }
          flowParseAnonFunctionWithoutParens() {
            let e = this.flowParsePrefixType();
            if (!this.state.noAnonFunctionType && this.eat(19)) {
              let s = this.startNodeAt(e.loc.start);
              return s.params = [this.reinterpretTypeAsFunctionTypeParam(e)], s.rest = null, s.this = null, s.returnType = this.flowParseType(), s.typeParameters = null, this.finishNode(s, "FunctionTypeAnnotation");
            }
            return e;
          }
          flowParseIntersectionType() {
            let e = this.startNode();
            this.eat(45);
            let s = this.flowParseAnonFunctionWithoutParens();
            for (e.types = [s]; this.eat(45); )
              e.types.push(this.flowParseAnonFunctionWithoutParens());
            return e.types.length === 1 ? s : this.finishNode(e, "IntersectionTypeAnnotation");
          }
          flowParseUnionType() {
            let e = this.startNode();
            this.eat(43);
            let s = this.flowParseIntersectionType();
            for (e.types = [s]; this.eat(43); )
              e.types.push(this.flowParseIntersectionType());
            return e.types.length === 1 ? s : this.finishNode(e, "UnionTypeAnnotation");
          }
          flowParseType() {
            let e = this.state.inType;
            this.state.inType = !0;
            let s = this.flowParseUnionType();
            return this.state.inType = e, s;
          }
          flowParseTypeOrImplicitInstantiation() {
            if (this.state.type === 130 && this.state.value === "_") {
              let e = this.state.startLoc, s = this.parseIdentifier();
              return this.flowParseGenericType(e, s);
            } else
              return this.flowParseType();
          }
          flowParseTypeAnnotation() {
            let e = this.startNode();
            return e.typeAnnotation = this.flowParseTypeInitialiser(), this.finishNode(e, "TypeAnnotation");
          }
          flowParseTypeAnnotatableIdentifier(e) {
            let s = e ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
            return this.match(14) && (s.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(s)), s;
          }
          typeCastToParameter(e) {
            return e.expression.typeAnnotation = e.typeAnnotation, this.resetEndLocation(e.expression, e.typeAnnotation.loc.end), e.expression;
          }
          flowParseVariance() {
            let e = null;
            return this.match(53) ? (e = this.startNode(), this.state.value === "+" ? e.kind = "plus" : e.kind = "minus", this.next(), this.finishNode(e, "Variance")) : e;
          }
          parseFunctionBody(e, s) {
            let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            if (s) {
              this.forwardNoArrowParamsConversionAt(e, () => super.parseFunctionBody(e, !0, r));
              return;
            }
            super.parseFunctionBody(e, !1, r);
          }
          parseFunctionBodyAndFinish(e, s) {
            let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            if (this.match(14)) {
              let i = this.startNode();
              [i.typeAnnotation, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), e.returnType = i.typeAnnotation ? this.finishNode(i, "TypeAnnotation") : null;
            }
            return super.parseFunctionBodyAndFinish(e, s, r);
          }
          parseStatementLike(e) {
            if (this.state.strict && this.isContextual(127)) {
              let r = this.lookahead();
              if (Ae(r.type)) {
                let i = this.startNode();
                return this.next(), this.flowParseInterface(i);
              }
            } else if (this.shouldParseEnums() && this.isContextual(124)) {
              let r = this.startNode();
              return this.next(), this.flowParseEnumDeclaration(r);
            }
            let s = super.parseStatementLike(e);
            return this.flowPragma === void 0 && !this.isValidDirective(s) && (this.flowPragma = null), s;
          }
          parseExpressionStatement(e, s, r) {
            if (s.type === "Identifier") {
              if (s.name === "declare") {
                if (this.match(80) || te(this.state.type) || this.match(68) || this.match(74) || this.match(82))
                  return this.flowParseDeclare(e);
              } else if (te(this.state.type)) {
                if (s.name === "interface")
                  return this.flowParseInterface(e);
                if (s.name === "type")
                  return this.flowParseTypeAlias(e);
                if (s.name === "opaque")
                  return this.flowParseOpaqueType(e, !1);
              }
            }
            return super.parseExpressionStatement(e, s, r);
          }
          shouldParseExportDeclaration() {
            let { type: e } = this.state;
            return or(e) || this.shouldParseEnums() && e === 124 ? !this.state.containsEsc : super.shouldParseExportDeclaration();
          }
          isExportDefaultSpecifier() {
            let { type: e } = this.state;
            return or(e) || this.shouldParseEnums() && e === 124 ? this.state.containsEsc : super.isExportDefaultSpecifier();
          }
          parseExportDefaultExpression() {
            if (this.shouldParseEnums() && this.isContextual(124)) {
              let e = this.startNode();
              return this.next(), this.flowParseEnumDeclaration(e);
            }
            return super.parseExportDefaultExpression();
          }
          parseConditional(e, s, r) {
            if (!this.match(17))
              return e;
            if (this.state.maybeInArrowParameters) {
              let T = this.lookaheadCharCode();
              if (T === 44 || T === 61 || T === 58 || T === 41)
                return this.setOptionalParametersError(r), e;
            }
            this.expect(17);
            let i = this.state.clone(), a = this.state.noArrowAt, n = this.startNodeAt(s), { consequent: o, failed: h } = this.tryParseConditionalConsequent(), [l, f] = this.getArrowLikeExpressions(o);
            if (h || f.length > 0) {
              let T = [...a];
              if (f.length > 0) {
                this.state = i, this.state.noArrowAt = T;
                for (let R = 0; R < f.length; R++)
                  T.push(f[R].start);
                ({ consequent: o, failed: h } = this.tryParseConditionalConsequent()), [l, f] = this.getArrowLikeExpressions(o);
              }
              h && l.length > 1 && this.raise($.AmbiguousConditionalArrow, { at: i.startLoc }), h && l.length === 1 && (this.state = i, T.push(l[0].start), this.state.noArrowAt = T, { consequent: o, failed: h } = this.tryParseConditionalConsequent());
            }
            return this.getArrowLikeExpressions(o, !0), this.state.noArrowAt = a, this.expect(14), n.test = e, n.consequent = o, n.alternate = this.forwardNoArrowParamsConversionAt(n, () => this.parseMaybeAssign(void 0, void 0)), this.finishNode(n, "ConditionalExpression");
          }
          tryParseConditionalConsequent() {
            this.state.noArrowParamsConversionAt.push(this.state.start);
            let e = this.parseMaybeAssignAllowIn(), s = !this.match(14);
            return this.state.noArrowParamsConversionAt.pop(), { consequent: e, failed: s };
          }
          getArrowLikeExpressions(e, s) {
            let r = [e], i = [];
            for (; r.length !== 0; ) {
              let a = r.pop();
              a.type === "ArrowFunctionExpression" ? (a.typeParameters || !a.returnType ? this.finishArrowValidation(a) : i.push(a), r.push(a.body)) : a.type === "ConditionalExpression" && (r.push(a.consequent), r.push(a.alternate));
            }
            return s ? (i.forEach((a) => this.finishArrowValidation(a)), [i, []]) : zn(i, (a) => a.params.every((n) => this.isAssignable(n, !0)));
          }
          finishArrowValidation(e) {
            var s;
            this.toAssignableList(e.params, (s = e.extra) == null ? void 0 : s.trailingCommaLoc, !1), this.scope.enter(De | ss), super.checkParams(e, !1, !0), this.scope.exit();
          }
          forwardNoArrowParamsConversionAt(e, s) {
            let r;
            return this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1 ? (this.state.noArrowParamsConversionAt.push(this.state.start), r = s(), this.state.noArrowParamsConversionAt.pop()) : r = s(), r;
          }
          parseParenItem(e, s) {
            if (e = super.parseParenItem(e, s), this.eat(17) && (e.optional = !0, this.resetEndLocation(e)), this.match(14)) {
              let r = this.startNodeAt(s);
              return r.expression = e, r.typeAnnotation = this.flowParseTypeAnnotation(), this.finishNode(r, "TypeCastExpression");
            }
            return e;
          }
          assertModuleNodeAllowed(e) {
            e.type === "ImportDeclaration" && (e.importKind === "type" || e.importKind === "typeof") || e.type === "ExportNamedDeclaration" && e.exportKind === "type" || e.type === "ExportAllDeclaration" && e.exportKind === "type" || super.assertModuleNodeAllowed(e);
          }
          parseExport(e, s) {
            let r = super.parseExport(e, s);
            return (r.type === "ExportNamedDeclaration" || r.type === "ExportAllDeclaration") && (r.exportKind = r.exportKind || "value"), r;
          }
          parseExportDeclaration(e) {
            if (this.isContextual(128)) {
              e.exportKind = "type";
              let s = this.startNode();
              return this.next(), this.match(5) ? (e.specifiers = this.parseExportSpecifiers(!0), super.parseExportFrom(e), null) : this.flowParseTypeAlias(s);
            } else if (this.isContextual(129)) {
              e.exportKind = "type";
              let s = this.startNode();
              return this.next(), this.flowParseOpaqueType(s, !1);
            } else if (this.isContextual(127)) {
              e.exportKind = "type";
              let s = this.startNode();
              return this.next(), this.flowParseInterface(s);
            } else if (this.shouldParseEnums() && this.isContextual(124)) {
              e.exportKind = "value";
              let s = this.startNode();
              return this.next(), this.flowParseEnumDeclaration(s);
            } else
              return super.parseExportDeclaration(e);
          }
          eatExportStar(e) {
            return super.eatExportStar(e) ? !0 : this.isContextual(128) && this.lookahead().type === 55 ? (e.exportKind = "type", this.next(), this.next(), !0) : !1;
          }
          maybeParseExportNamespaceSpecifier(e) {
            let { startLoc: s } = this.state, r = super.maybeParseExportNamespaceSpecifier(e);
            return r && e.exportKind === "type" && this.unexpected(s), r;
          }
          parseClassId(e, s, r) {
            super.parseClassId(e, s, r), this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration());
          }
          parseClassMember(e, s, r) {
            let { startLoc: i } = this.state;
            if (this.isContextual(123)) {
              if (super.parseClassMemberFromModifier(e, s))
                return;
              s.declare = !0;
            }
            super.parseClassMember(e, s, r), s.declare && (s.type !== "ClassProperty" && s.type !== "ClassPrivateProperty" && s.type !== "PropertyDefinition" ? this.raise($.DeclareClassElement, { at: i }) : s.value && this.raise($.DeclareClassFieldInitializer, { at: s.value }));
          }
          isIterator(e) {
            return e === "iterator" || e === "asyncIterator";
          }
          readIterator() {
            let e = super.readWord1(), s = "@@" + e;
            (!this.isIterator(e) || !this.state.inType) && this.raise(p.InvalidIdentifier, { at: this.state.curPosition(), identifierName: s }), this.finishToken(130, s);
          }
          getTokenFromCode(e) {
            let s = this.input.charCodeAt(this.state.pos + 1);
            e === 123 && s === 124 ? this.finishOp(6, 2) : this.state.inType && (e === 62 || e === 60) ? this.finishOp(e === 62 ? 48 : 47, 1) : this.state.inType && e === 63 ? s === 46 ? this.finishOp(18, 2) : this.finishOp(17, 1) : Ya(e, s, this.input.charCodeAt(this.state.pos + 2)) ? (this.state.pos += 2, this.readIterator()) : super.getTokenFromCode(e);
          }
          isAssignable(e, s) {
            return e.type === "TypeCastExpression" ? this.isAssignable(e.expression, s) : super.isAssignable(e, s);
          }
          toAssignable(e) {
            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            !s && e.type === "AssignmentExpression" && e.left.type === "TypeCastExpression" && (e.left = this.typeCastToParameter(e.left)), super.toAssignable(e, s);
          }
          toAssignableList(e, s, r) {
            for (let i = 0; i < e.length; i++) {
              let a = e[i];
              (a == null ? void 0 : a.type) === "TypeCastExpression" && (e[i] = this.typeCastToParameter(a));
            }
            super.toAssignableList(e, s, r);
          }
          toReferencedList(e, s) {
            for (let i = 0; i < e.length; i++) {
              var r;
              let a = e[i];
              a && a.type === "TypeCastExpression" && !((r = a.extra) != null && r.parenthesized) && (e.length > 1 || !s) && this.raise($.TypeCastInPattern, { at: a.typeAnnotation });
            }
            return e;
          }
          parseArrayLike(e, s, r, i) {
            let a = super.parseArrayLike(e, s, r, i);
            return s && !this.state.maybeInArrowParameters && this.toReferencedList(a.elements), a;
          }
          isValidLVal(e, s, r) {
            return e === "TypeCastExpression" || super.isValidLVal(e, s, r);
          }
          parseClassProperty(e) {
            return this.match(14) && (e.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassProperty(e);
          }
          parseClassPrivateProperty(e) {
            return this.match(14) && (e.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassPrivateProperty(e);
          }
          isClassMethod() {
            return this.match(47) || super.isClassMethod();
          }
          isClassProperty() {
            return this.match(14) || super.isClassProperty();
          }
          isNonstaticConstructor(e) {
            return !this.match(14) && super.isNonstaticConstructor(e);
          }
          pushClassMethod(e, s, r, i, a, n) {
            if (s.variance && this.unexpected(s.variance.loc.start), delete s.variance, this.match(47) && (s.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassMethod(e, s, r, i, a, n), s.params && a) {
              let o = s.params;
              o.length > 0 && this.isThisParam(o[0]) && this.raise($.ThisParamBannedInConstructor, { at: s });
            } else if (s.type === "MethodDefinition" && a && s.value.params) {
              let o = s.value.params;
              o.length > 0 && this.isThisParam(o[0]) && this.raise($.ThisParamBannedInConstructor, { at: s });
            }
          }
          pushClassPrivateMethod(e, s, r, i) {
            s.variance && this.unexpected(s.variance.loc.start), delete s.variance, this.match(47) && (s.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassPrivateMethod(e, s, r, i);
          }
          parseClassSuper(e) {
            if (super.parseClassSuper(e), e.superClass && this.match(47) && (e.superTypeParameters = this.flowParseTypeParameterInstantiation()), this.isContextual(111)) {
              this.next();
              let s = e.implements = [];
              do {
                let r = this.startNode();
                r.id = this.flowParseRestrictedIdentifier(!0), this.match(47) ? r.typeParameters = this.flowParseTypeParameterInstantiation() : r.typeParameters = null, s.push(this.finishNode(r, "ClassImplements"));
              } while (this.eat(12));
            }
          }
          checkGetterSetterParams(e) {
            super.checkGetterSetterParams(e);
            let s = this.getObjectOrClassMethodParams(e);
            if (s.length > 0) {
              let r = s[0];
              this.isThisParam(r) && e.kind === "get" ? this.raise($.GetterMayNotHaveThisParam, { at: r }) : this.isThisParam(r) && this.raise($.SetterMayNotHaveThisParam, { at: r });
            }
          }
          parsePropertyNamePrefixOperator(e) {
            e.variance = this.flowParseVariance();
          }
          parseObjPropValue(e, s, r, i, a, n, o) {
            e.variance && this.unexpected(e.variance.loc.start), delete e.variance;
            let h;
            this.match(47) && !n && (h = this.flowParseTypeParameterDeclaration(), this.match(10) || this.unexpected());
            let l = super.parseObjPropValue(e, s, r, i, a, n, o);
            return h && ((l.value || l).typeParameters = h), l;
          }
          parseAssignableListItemTypes(e) {
            return this.eat(17) && (e.type !== "Identifier" && this.raise($.PatternIsOptional, { at: e }), this.isThisParam(e) && this.raise($.ThisParamMayNotBeOptional, { at: e }), e.optional = !0), this.match(14) ? e.typeAnnotation = this.flowParseTypeAnnotation() : this.isThisParam(e) && this.raise($.ThisParamAnnotationRequired, { at: e }), this.match(29) && this.isThisParam(e) && this.raise($.ThisParamNoDefault, { at: e }), this.resetEndLocation(e), e;
          }
          parseMaybeDefault(e, s) {
            let r = super.parseMaybeDefault(e, s);
            return r.type === "AssignmentPattern" && r.typeAnnotation && r.right.start < r.typeAnnotation.start && this.raise($.TypeBeforeInitializer, { at: r.typeAnnotation }), r;
          }
          shouldParseDefaultImport(e) {
            return gs(e) ? Rr(this.state.type) : super.shouldParseDefaultImport(e);
          }
          checkImportReflection(e) {
            super.checkImportReflection(e), e.module && e.importKind !== "value" && this.raise($.ImportReflectionHasImportType, { at: e.specifiers[0].loc.start });
          }
          parseImportSpecifierLocal(e, s, r) {
            s.local = gs(e) ? this.flowParseRestrictedIdentifier(!0, !0) : this.parseIdentifier(), e.specifiers.push(this.finishImportSpecifier(s, r));
          }
          maybeParseDefaultImportSpecifier(e) {
            e.importKind = "value";
            let s = null;
            if (this.match(87) ? s = "typeof" : this.isContextual(128) && (s = "type"), s) {
              let r = this.lookahead(), { type: i } = r;
              s === "type" && i === 55 && this.unexpected(null, r.type), (Rr(i) || i === 5 || i === 55) && (this.next(), e.importKind = s);
            }
            return super.maybeParseDefaultImportSpecifier(e);
          }
          parseImportSpecifier(e, s, r, i, a) {
            let n = e.imported, o = null;
            n.type === "Identifier" && (n.name === "type" ? o = "type" : n.name === "typeof" && (o = "typeof"));
            let h = !1;
            if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
              let f = this.parseIdentifier(!0);
              o !== null && !Ae(this.state.type) ? (e.imported = f, e.importKind = o, e.local = Fe(f)) : (e.imported = n, e.importKind = null, e.local = this.parseIdentifier());
            } else {
              if (o !== null && Ae(this.state.type))
                e.imported = this.parseIdentifier(!0), e.importKind = o;
              else {
                if (s)
                  throw this.raise(p.ImportBindingIsString, { at: e, importName: n.value });
                e.imported = n, e.importKind = null;
              }
              this.eatContextual(93) ? e.local = this.parseIdentifier() : (h = !0, e.local = Fe(e.imported));
            }
            let l = gs(e);
            return r && l && this.raise($.ImportTypeShorthandOnlyInPureImport, { at: e }), (r || l) && this.checkReservedType(e.local.name, e.local.loc.start, !0), h && !r && !l && this.checkReservedWord(e.local.name, e.loc.start, !0, !0), this.finishImportSpecifier(e, "ImportSpecifier");
          }
          parseBindingAtom() {
            switch (this.state.type) {
              case 78:
                return this.parseIdentifier(!0);
              default:
                return super.parseBindingAtom();
            }
          }
          parseFunctionParams(e, s) {
            let r = e.kind;
            r !== "get" && r !== "set" && this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration()), super.parseFunctionParams(e, s);
          }
          parseVarId(e, s) {
            super.parseVarId(e, s), this.match(14) && (e.id.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(e.id));
          }
          parseAsyncArrowFromCallExpression(e, s) {
            if (this.match(14)) {
              let r = this.state.noAnonFunctionType;
              this.state.noAnonFunctionType = !0, e.returnType = this.flowParseTypeAnnotation(), this.state.noAnonFunctionType = r;
            }
            return super.parseAsyncArrowFromCallExpression(e, s);
          }
          shouldParseAsyncArrow() {
            return this.match(14) || super.shouldParseAsyncArrow();
          }
          parseMaybeAssign(e, s) {
            var r;
            let i = null, a;
            if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
              if (i = this.state.clone(), a = this.tryParse(() => super.parseMaybeAssign(e, s), i), !a.error)
                return a.node;
              let { context: h } = this.state, l = h[h.length - 1];
              (l === g.j_oTag || l === g.j_expr) && h.pop();
            }
            if ((r = a) != null && r.error || this.match(47)) {
              var n, o;
              i = i || this.state.clone();
              let h, l = this.tryParse((T) => {
                var R;
                h = this.flowParseTypeParameterDeclaration();
                let B = this.forwardNoArrowParamsConversionAt(h, () => {
                  let re = super.parseMaybeAssign(e, s);
                  return this.resetStartLocationFromNode(re, h), re;
                });
                (R = B.extra) != null && R.parenthesized && T();
                let se = this.maybeUnwrapTypeCastExpression(B);
                return se.type !== "ArrowFunctionExpression" && T(), se.typeParameters = h, this.resetStartLocationFromNode(se, h), B;
              }, i), f = null;
              if (l.node && this.maybeUnwrapTypeCastExpression(l.node).type === "ArrowFunctionExpression") {
                if (!l.error && !l.aborted)
                  return l.node.async && this.raise($.UnexpectedTypeParameterBeforeAsyncArrowFunction, { at: h }), l.node;
                f = l.node;
              }
              if ((n = a) != null && n.node)
                return this.state = a.failState, a.node;
              if (f)
                return this.state = l.failState, f;
              throw (o = a) != null && o.thrown ? a.error : l.thrown ? l.error : this.raise($.UnexpectedTokenAfterTypeParameter, { at: h });
            }
            return super.parseMaybeAssign(e, s);
          }
          parseArrow(e) {
            if (this.match(14)) {
              let s = this.tryParse(() => {
                let r = this.state.noAnonFunctionType;
                this.state.noAnonFunctionType = !0;
                let i = this.startNode();
                return [i.typeAnnotation, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), this.state.noAnonFunctionType = r, this.canInsertSemicolon() && this.unexpected(), this.match(19) || this.unexpected(), i;
              });
              if (s.thrown)
                return null;
              s.error && (this.state = s.failState), e.returnType = s.node.typeAnnotation ? this.finishNode(s.node, "TypeAnnotation") : null;
            }
            return super.parseArrow(e);
          }
          shouldParseArrow(e) {
            return this.match(14) || super.shouldParseArrow(e);
          }
          setArrowFunctionParameters(e, s) {
            this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1 ? e.params = s : super.setArrowFunctionParameters(e, s);
          }
          checkParams(e, s, r) {
            let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
            if (!(r && this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1)) {
              for (let a = 0; a < e.params.length; a++)
                this.isThisParam(e.params[a]) && a > 0 && this.raise($.ThisParamMustBeFirst, { at: e.params[a] });
              super.checkParams(e, s, r, i);
            }
          }
          parseParenAndDistinguishExpression(e) {
            return super.parseParenAndDistinguishExpression(e && this.state.noArrowAt.indexOf(this.state.start) === -1);
          }
          parseSubscripts(e, s, r) {
            if (e.type === "Identifier" && e.name === "async" && this.state.noArrowAt.indexOf(s.index) !== -1) {
              this.next();
              let i = this.startNodeAt(s);
              i.callee = e, i.arguments = super.parseCallExpressionArguments(11, !1), e = this.finishNode(i, "CallExpression");
            } else if (e.type === "Identifier" && e.name === "async" && this.match(47)) {
              let i = this.state.clone(), a = this.tryParse((o) => this.parseAsyncArrowWithTypeParameters(s) || o(), i);
              if (!a.error && !a.aborted)
                return a.node;
              let n = this.tryParse(() => super.parseSubscripts(e, s, r), i);
              if (n.node && !n.error)
                return n.node;
              if (a.node)
                return this.state = a.failState, a.node;
              if (n.node)
                return this.state = n.failState, n.node;
              throw a.error || n.error;
            }
            return super.parseSubscripts(e, s, r);
          }
          parseSubscript(e, s, r, i) {
            if (this.match(18) && this.isLookaheadToken_lt()) {
              if (i.optionalChainMember = !0, r)
                return i.stop = !0, e;
              this.next();
              let a = this.startNodeAt(s);
              return a.callee = e, a.typeArguments = this.flowParseTypeParameterInstantiation(), this.expect(10), a.arguments = this.parseCallExpressionArguments(11, !1), a.optional = !0, this.finishCallExpression(a, !0);
            } else if (!r && this.shouldParseTypes() && this.match(47)) {
              let a = this.startNodeAt(s);
              a.callee = e;
              let n = this.tryParse(() => (a.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew(), this.expect(10), a.arguments = super.parseCallExpressionArguments(11, !1), i.optionalChainMember && (a.optional = !1), this.finishCallExpression(a, i.optionalChainMember)));
              if (n.node)
                return n.error && (this.state = n.failState), n.node;
            }
            return super.parseSubscript(e, s, r, i);
          }
          parseNewCallee(e) {
            super.parseNewCallee(e);
            let s = null;
            this.shouldParseTypes() && this.match(47) && (s = this.tryParse(() => this.flowParseTypeParameterInstantiationCallOrNew()).node), e.typeArguments = s;
          }
          parseAsyncArrowWithTypeParameters(e) {
            let s = this.startNodeAt(e);
            if (this.parseFunctionParams(s, !1), !!this.parseArrow(s))
              return super.parseArrowExpression(s, void 0, !0);
          }
          readToken_mult_modulo(e) {
            let s = this.input.charCodeAt(this.state.pos + 1);
            if (e === 42 && s === 47 && this.state.hasFlowComment) {
              this.state.hasFlowComment = !1, this.state.pos += 2, this.nextToken();
              return;
            }
            super.readToken_mult_modulo(e);
          }
          readToken_pipe_amp(e) {
            let s = this.input.charCodeAt(this.state.pos + 1);
            if (e === 124 && s === 125) {
              this.finishOp(9, 2);
              return;
            }
            super.readToken_pipe_amp(e);
          }
          parseTopLevel(e, s) {
            let r = super.parseTopLevel(e, s);
            return this.state.hasFlowComment && this.raise($.UnterminatedFlowComment, { at: this.state.curPosition() }), r;
          }
          skipBlockComment() {
            if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
              if (this.state.hasFlowComment)
                throw this.raise($.NestedFlowComment, { at: this.state.startLoc });
              this.hasFlowCommentCompletion();
              let e = this.skipFlowComment();
              e && (this.state.pos += e, this.state.hasFlowComment = !0);
              return;
            }
            return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
          }
          skipFlowComment() {
            let { pos: e } = this.state, s = 2;
            for (; [32, 9].includes(this.input.charCodeAt(e + s)); )
              s++;
            let r = this.input.charCodeAt(s + e), i = this.input.charCodeAt(s + e + 1);
            return r === 58 && i === 58 ? s + 2 : this.input.slice(s + e, s + e + 12) === "flow-include" ? s + 12 : r === 58 && i !== 58 ? s : !1;
          }
          hasFlowCommentCompletion() {
            if (this.input.indexOf("*/", this.state.pos) === -1)
              throw this.raise(p.UnterminatedComment, { at: this.state.curPosition() });
          }
          flowEnumErrorBooleanMemberNotInitialized(e, s) {
            let { enumName: r, memberName: i } = s;
            this.raise($.EnumBooleanMemberNotInitialized, { at: e, memberName: i, enumName: r });
          }
          flowEnumErrorInvalidMemberInitializer(e, s) {
            return this.raise(s.explicitType ? s.explicitType === "symbol" ? $.EnumInvalidMemberInitializerSymbolType : $.EnumInvalidMemberInitializerPrimaryType : $.EnumInvalidMemberInitializerUnknownType, Object.assign({ at: e }, s));
          }
          flowEnumErrorNumberMemberNotInitialized(e, s) {
            let { enumName: r, memberName: i } = s;
            this.raise($.EnumNumberMemberNotInitialized, { at: e, enumName: r, memberName: i });
          }
          flowEnumErrorStringMemberInconsistentlyInitailized(e, s) {
            let { enumName: r } = s;
            this.raise($.EnumStringMemberInconsistentlyInitailized, { at: e, enumName: r });
          }
          flowEnumMemberInit() {
            let e = this.state.startLoc, s = () => this.match(12) || this.match(8);
            switch (this.state.type) {
              case 132: {
                let r = this.parseNumericLiteral(this.state.value);
                return s() ? { type: "number", loc: r.loc.start, value: r } : { type: "invalid", loc: e };
              }
              case 131: {
                let r = this.parseStringLiteral(this.state.value);
                return s() ? { type: "string", loc: r.loc.start, value: r } : { type: "invalid", loc: e };
              }
              case 85:
              case 86: {
                let r = this.parseBooleanLiteral(this.match(85));
                return s() ? { type: "boolean", loc: r.loc.start, value: r } : { type: "invalid", loc: e };
              }
              default:
                return { type: "invalid", loc: e };
            }
          }
          flowEnumMemberRaw() {
            let e = this.state.startLoc, s = this.parseIdentifier(!0), r = this.eat(29) ? this.flowEnumMemberInit() : { type: "none", loc: e };
            return { id: s, init: r };
          }
          flowEnumCheckExplicitTypeMismatch(e, s, r) {
            let { explicitType: i } = s;
            i !== null && i !== r && this.flowEnumErrorInvalidMemberInitializer(e, s);
          }
          flowEnumMembers(e) {
            let { enumName: s, explicitType: r } = e, i = /* @__PURE__ */ new Set(), a = { booleanMembers: [], numberMembers: [], stringMembers: [], defaultedMembers: [] }, n = !1;
            for (; !this.match(8); ) {
              if (this.eat(21)) {
                n = !0;
                break;
              }
              let o = this.startNode(), { id: h, init: l } = this.flowEnumMemberRaw(), f = h.name;
              if (f === "")
                continue;
              /^[a-z]/.test(f) && this.raise($.EnumInvalidMemberName, { at: h, memberName: f, suggestion: f[0].toUpperCase() + f.slice(1), enumName: s }), i.has(f) && this.raise($.EnumDuplicateMemberName, { at: h, memberName: f, enumName: s }), i.add(f);
              let T = { enumName: s, explicitType: r, memberName: f };
              switch (o.id = h, l.type) {
                case "boolean": {
                  this.flowEnumCheckExplicitTypeMismatch(l.loc, T, "boolean"), o.init = l.value, a.booleanMembers.push(this.finishNode(o, "EnumBooleanMember"));
                  break;
                }
                case "number": {
                  this.flowEnumCheckExplicitTypeMismatch(l.loc, T, "number"), o.init = l.value, a.numberMembers.push(this.finishNode(o, "EnumNumberMember"));
                  break;
                }
                case "string": {
                  this.flowEnumCheckExplicitTypeMismatch(l.loc, T, "string"), o.init = l.value, a.stringMembers.push(this.finishNode(o, "EnumStringMember"));
                  break;
                }
                case "invalid":
                  throw this.flowEnumErrorInvalidMemberInitializer(l.loc, T);
                case "none":
                  switch (r) {
                    case "boolean":
                      this.flowEnumErrorBooleanMemberNotInitialized(l.loc, T);
                      break;
                    case "number":
                      this.flowEnumErrorNumberMemberNotInitialized(l.loc, T);
                      break;
                    default:
                      a.defaultedMembers.push(this.finishNode(o, "EnumDefaultedMember"));
                  }
              }
              this.match(8) || this.expect(12);
            }
            return { members: a, hasUnknownMembers: n };
          }
          flowEnumStringMembers(e, s, r) {
            let { enumName: i } = r;
            if (e.length === 0)
              return s;
            if (s.length === 0)
              return e;
            if (s.length > e.length) {
              for (let a of e)
                this.flowEnumErrorStringMemberInconsistentlyInitailized(a, { enumName: i });
              return s;
            } else {
              for (let a of s)
                this.flowEnumErrorStringMemberInconsistentlyInitailized(a, { enumName: i });
              return e;
            }
          }
          flowEnumParseExplicitType(e) {
            let { enumName: s } = e;
            if (!this.eatContextual(101))
              return null;
            if (!te(this.state.type))
              throw this.raise($.EnumInvalidExplicitTypeUnknownSupplied, { at: this.state.startLoc, enumName: s });
            let { value: r } = this.state;
            return this.next(), r !== "boolean" && r !== "number" && r !== "string" && r !== "symbol" && this.raise($.EnumInvalidExplicitType, { at: this.state.startLoc, enumName: s, invalidEnumType: r }), r;
          }
          flowEnumBody(e, s) {
            let r = s.name, i = s.loc.start, a = this.flowEnumParseExplicitType({ enumName: r });
            this.expect(5);
            let { members: n, hasUnknownMembers: o } = this.flowEnumMembers({ enumName: r, explicitType: a });
            switch (e.hasUnknownMembers = o, a) {
              case "boolean":
                return e.explicitType = !0, e.members = n.booleanMembers, this.expect(8), this.finishNode(e, "EnumBooleanBody");
              case "number":
                return e.explicitType = !0, e.members = n.numberMembers, this.expect(8), this.finishNode(e, "EnumNumberBody");
              case "string":
                return e.explicitType = !0, e.members = this.flowEnumStringMembers(n.stringMembers, n.defaultedMembers, { enumName: r }), this.expect(8), this.finishNode(e, "EnumStringBody");
              case "symbol":
                return e.members = n.defaultedMembers, this.expect(8), this.finishNode(e, "EnumSymbolBody");
              default: {
                let h = () => (e.members = [], this.expect(8), this.finishNode(e, "EnumStringBody"));
                e.explicitType = !1;
                let l = n.booleanMembers.length, f = n.numberMembers.length, T = n.stringMembers.length, R = n.defaultedMembers.length;
                if (!l && !f && !T && !R)
                  return h();
                if (!l && !f)
                  return e.members = this.flowEnumStringMembers(n.stringMembers, n.defaultedMembers, { enumName: r }), this.expect(8), this.finishNode(e, "EnumStringBody");
                if (!f && !T && l >= R) {
                  for (let B of n.defaultedMembers)
                    this.flowEnumErrorBooleanMemberNotInitialized(B.loc.start, { enumName: r, memberName: B.id.name });
                  return e.members = n.booleanMembers, this.expect(8), this.finishNode(e, "EnumBooleanBody");
                } else if (!l && !T && f >= R) {
                  for (let B of n.defaultedMembers)
                    this.flowEnumErrorNumberMemberNotInitialized(B.loc.start, { enumName: r, memberName: B.id.name });
                  return e.members = n.numberMembers, this.expect(8), this.finishNode(e, "EnumNumberBody");
                } else
                  return this.raise($.EnumInconsistentMemberValues, { at: i, enumName: r }), h();
              }
            }
          }
          flowParseEnumDeclaration(e) {
            let s = this.parseIdentifier();
            return e.id = s, e.body = this.flowEnumBody(this.startNode(), s), this.finishNode(e, "EnumDeclaration");
          }
          isLookaheadToken_lt() {
            let e = this.nextTokenStart();
            if (this.input.charCodeAt(e) === 60) {
              let s = this.input.charCodeAt(e + 1);
              return s !== 60 && s !== 61;
            }
            return !1;
          }
          maybeUnwrapTypeCastExpression(e) {
            return e.type === "TypeCastExpression" ? e.expression : e;
          }
        }, Vn = { __proto__: null, quot: '"', amp: "&", apos: "'", lt: "<", gt: ">", nbsp: " ", iexcl: "¡", cent: "¢", pound: "£", curren: "¤", yen: "¥", brvbar: "¦", sect: "§", uml: "¨", copy: "©", ordf: "ª", laquo: "«", not: "¬", shy: "­", reg: "®", macr: "¯", deg: "°", plusmn: "±", sup2: "²", sup3: "³", acute: "´", micro: "µ", para: "¶", middot: "·", cedil: "¸", sup1: "¹", ordm: "º", raquo: "»", frac14: "¼", frac12: "½", frac34: "¾", iquest: "¿", Agrave: "À", Aacute: "Á", Acirc: "Â", Atilde: "Ã", Auml: "Ä", Aring: "Å", AElig: "Æ", Ccedil: "Ç", Egrave: "È", Eacute: "É", Ecirc: "Ê", Euml: "Ë", Igrave: "Ì", Iacute: "Í", Icirc: "Î", Iuml: "Ï", ETH: "Ð", Ntilde: "Ñ", Ograve: "Ò", Oacute: "Ó", Ocirc: "Ô", Otilde: "Õ", Ouml: "Ö", times: "×", Oslash: "Ø", Ugrave: "Ù", Uacute: "Ú", Ucirc: "Û", Uuml: "Ü", Yacute: "Ý", THORN: "Þ", szlig: "ß", agrave: "à", aacute: "á", acirc: "â", atilde: "ã", auml: "ä", aring: "å", aelig: "æ", ccedil: "ç", egrave: "è", eacute: "é", ecirc: "ê", euml: "ë", igrave: "ì", iacute: "í", icirc: "î", iuml: "ï", eth: "ð", ntilde: "ñ", ograve: "ò", oacute: "ó", ocirc: "ô", otilde: "õ", ouml: "ö", divide: "÷", oslash: "ø", ugrave: "ù", uacute: "ú", ucirc: "û", uuml: "ü", yacute: "ý", thorn: "þ", yuml: "ÿ", OElig: "Œ", oelig: "œ", Scaron: "Š", scaron: "š", Yuml: "Ÿ", fnof: "ƒ", circ: "ˆ", tilde: "˜", Alpha: "Α", Beta: "Β", Gamma: "Γ", Delta: "Δ", Epsilon: "Ε", Zeta: "Ζ", Eta: "Η", Theta: "Θ", Iota: "Ι", Kappa: "Κ", Lambda: "Λ", Mu: "Μ", Nu: "Ν", Xi: "Ξ", Omicron: "Ο", Pi: "Π", Rho: "Ρ", Sigma: "Σ", Tau: "Τ", Upsilon: "Υ", Phi: "Φ", Chi: "Χ", Psi: "Ψ", Omega: "Ω", alpha: "α", beta: "β", gamma: "γ", delta: "δ", epsilon: "ε", zeta: "ζ", eta: "η", theta: "θ", iota: "ι", kappa: "κ", lambda: "λ", mu: "μ", nu: "ν", xi: "ξ", omicron: "ο", pi: "π", rho: "ρ", sigmaf: "ς", sigma: "σ", tau: "τ", upsilon: "υ", phi: "φ", chi: "χ", psi: "ψ", omega: "ω", thetasym: "ϑ", upsih: "ϒ", piv: "ϖ", ensp: " ", emsp: " ", thinsp: " ", zwnj: "‌", zwj: "‍", lrm: "‎", rlm: "‏", ndash: "–", mdash: "—", lsquo: "‘", rsquo: "’", sbquo: "‚", ldquo: "“", rdquo: "”", bdquo: "„", dagger: "†", Dagger: "‡", bull: "•", hellip: "…", permil: "‰", prime: "′", Prime: "″", lsaquo: "‹", rsaquo: "›", oline: "‾", frasl: "⁄", euro: "€", image: "ℑ", weierp: "℘", real: "ℜ", trade: "™", alefsym: "ℵ", larr: "←", uarr: "↑", rarr: "→", darr: "↓", harr: "↔", crarr: "↵", lArr: "⇐", uArr: "⇑", rArr: "⇒", dArr: "⇓", hArr: "⇔", forall: "∀", part: "∂", exist: "∃", empty: "∅", nabla: "∇", isin: "∈", notin: "∉", ni: "∋", prod: "∏", sum: "∑", minus: "−", lowast: "∗", radic: "√", prop: "∝", infin: "∞", ang: "∠", and: "∧", or: "∨", cap: "∩", cup: "∪", int: "∫", there4: "∴", sim: "∼", cong: "≅", asymp: "≈", ne: "≠", equiv: "≡", le: "≤", ge: "≥", sub: "⊂", sup: "⊃", nsub: "⊄", sube: "⊆", supe: "⊇", oplus: "⊕", otimes: "⊗", perp: "⊥", sdot: "⋅", lceil: "⌈", rceil: "⌉", lfloor: "⌊", rfloor: "⌋", lang: "〈", rang: "〉", loz: "◊", spades: "♠", clubs: "♣", hearts: "♥", diams: "♦" }, $e = Ne`jsx`({ AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.", MissingClosingTagElement: (t) => {
          let { openingTagName: e } = t;
          return `Expected corresponding JSX closing tag for <${e}>.`;
        }, MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.", UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?", UnexpectedToken: (t) => {
          let { unexpected: e, HTMLEntity: s } = t;
          return `Unexpected token \`${e}\`. Did you mean \`${s}\` or \`{'${e}'}\`?`;
        }, UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.", UnterminatedJsxContent: "Unterminated JSX contents.", UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?" });
        function Re(t) {
          return t ? t.type === "JSXOpeningFragment" || t.type === "JSXClosingFragment" : !1;
        }
        function tt(t) {
          if (t.type === "JSXIdentifier")
            return t.name;
          if (t.type === "JSXNamespacedName")
            return t.namespace.name + ":" + t.name.name;
          if (t.type === "JSXMemberExpression")
            return tt(t.object) + "." + tt(t.property);
          throw new Error("Node had unexpected type: " + t.type);
        }
        var qn = (t) => class extends t {
          jsxReadToken() {
            let e = "", s = this.state.pos;
            for (; ; ) {
              if (this.state.pos >= this.length)
                throw this.raise($e.UnterminatedJsxContent, { at: this.state.startLoc });
              let r = this.input.charCodeAt(this.state.pos);
              switch (r) {
                case 60:
                case 123:
                  if (this.state.pos === this.state.start) {
                    r === 60 && this.state.canStartJSXElement ? (++this.state.pos, this.finishToken(140)) : super.getTokenFromCode(r);
                    return;
                  }
                  e += this.input.slice(s, this.state.pos), this.finishToken(139, e);
                  return;
                case 38:
                  e += this.input.slice(s, this.state.pos), e += this.jsxReadEntity(), s = this.state.pos;
                  break;
                case 62:
                case 125:
                default:
                  ht(r) ? (e += this.input.slice(s, this.state.pos), e += this.jsxReadNewLine(!0), s = this.state.pos) : ++this.state.pos;
              }
            }
          }
          jsxReadNewLine(e) {
            let s = this.input.charCodeAt(this.state.pos), r;
            return ++this.state.pos, s === 13 && this.input.charCodeAt(this.state.pos) === 10 ? (++this.state.pos, r = e ? `
` : `\r
`) : r = String.fromCharCode(s), ++this.state.curLine, this.state.lineStart = this.state.pos, r;
          }
          jsxReadString(e) {
            let s = "", r = ++this.state.pos;
            for (; ; ) {
              if (this.state.pos >= this.length)
                throw this.raise(p.UnterminatedString, { at: this.state.startLoc });
              let i = this.input.charCodeAt(this.state.pos);
              if (i === e)
                break;
              i === 38 ? (s += this.input.slice(r, this.state.pos), s += this.jsxReadEntity(), r = this.state.pos) : ht(i) ? (s += this.input.slice(r, this.state.pos), s += this.jsxReadNewLine(!1), r = this.state.pos) : ++this.state.pos;
            }
            s += this.input.slice(r, this.state.pos++), this.finishToken(131, s);
          }
          jsxReadEntity() {
            let e = ++this.state.pos;
            if (this.codePointAtPos(this.state.pos) === 35) {
              ++this.state.pos;
              let s = 10;
              this.codePointAtPos(this.state.pos) === 120 && (s = 16, ++this.state.pos);
              let r = this.readInt(s, void 0, !1, "bail");
              if (r !== null && this.codePointAtPos(this.state.pos) === 59)
                return ++this.state.pos, String.fromCodePoint(r);
            } else {
              let s = 0, r = !1;
              for (; s++ < 10 && this.state.pos < this.length && !(r = this.codePointAtPos(this.state.pos) == 59); )
                ++this.state.pos;
              if (r) {
                let i = this.input.slice(e, this.state.pos), a = Vn[i];
                if (++this.state.pos, a)
                  return a;
              }
            }
            return this.state.pos = e, "&";
          }
          jsxReadWord() {
            let e, s = this.state.pos;
            do
              e = this.input.charCodeAt(++this.state.pos);
            while (Je(e) || e === 45);
            this.finishToken(138, this.input.slice(s, this.state.pos));
          }
          jsxParseIdentifier() {
            let e = this.startNode();
            return this.match(138) ? e.name = this.state.value : Gt(this.state.type) ? e.name = Be(this.state.type) : this.unexpected(), this.next(), this.finishNode(e, "JSXIdentifier");
          }
          jsxParseNamespacedName() {
            let e = this.state.startLoc, s = this.jsxParseIdentifier();
            if (!this.eat(14))
              return s;
            let r = this.startNodeAt(e);
            return r.namespace = s, r.name = this.jsxParseIdentifier(), this.finishNode(r, "JSXNamespacedName");
          }
          jsxParseElementName() {
            let e = this.state.startLoc, s = this.jsxParseNamespacedName();
            if (s.type === "JSXNamespacedName")
              return s;
            for (; this.eat(16); ) {
              let r = this.startNodeAt(e);
              r.object = s, r.property = this.jsxParseIdentifier(), s = this.finishNode(r, "JSXMemberExpression");
            }
            return s;
          }
          jsxParseAttributeValue() {
            let e;
            switch (this.state.type) {
              case 5:
                return e = this.startNode(), this.setContext(g.brace), this.next(), e = this.jsxParseExpressionContainer(e, g.j_oTag), e.expression.type === "JSXEmptyExpression" && this.raise($e.AttributeIsEmpty, { at: e }), e;
              case 140:
              case 131:
                return this.parseExprAtom();
              default:
                throw this.raise($e.UnsupportedJsxValue, { at: this.state.startLoc });
            }
          }
          jsxParseEmptyExpression() {
            let e = this.startNodeAt(this.state.lastTokEndLoc);
            return this.finishNodeAt(e, "JSXEmptyExpression", this.state.startLoc);
          }
          jsxParseSpreadChild(e) {
            return this.next(), e.expression = this.parseExpression(), this.setContext(g.j_expr), this.state.canStartJSXElement = !0, this.expect(8), this.finishNode(e, "JSXSpreadChild");
          }
          jsxParseExpressionContainer(e, s) {
            if (this.match(8))
              e.expression = this.jsxParseEmptyExpression();
            else {
              let r = this.parseExpression();
              e.expression = r;
            }
            return this.setContext(s), this.state.canStartJSXElement = !0, this.expect(8), this.finishNode(e, "JSXExpressionContainer");
          }
          jsxParseAttribute() {
            let e = this.startNode();
            return this.match(5) ? (this.setContext(g.brace), this.next(), this.expect(21), e.argument = this.parseMaybeAssignAllowIn(), this.setContext(g.j_oTag), this.state.canStartJSXElement = !0, this.expect(8), this.finishNode(e, "JSXSpreadAttribute")) : (e.name = this.jsxParseNamespacedName(), e.value = this.eat(29) ? this.jsxParseAttributeValue() : null, this.finishNode(e, "JSXAttribute"));
          }
          jsxParseOpeningElementAt(e) {
            let s = this.startNodeAt(e);
            return this.eat(141) ? this.finishNode(s, "JSXOpeningFragment") : (s.name = this.jsxParseElementName(), this.jsxParseOpeningElementAfterName(s));
          }
          jsxParseOpeningElementAfterName(e) {
            let s = [];
            for (; !this.match(56) && !this.match(141); )
              s.push(this.jsxParseAttribute());
            return e.attributes = s, e.selfClosing = this.eat(56), this.expect(141), this.finishNode(e, "JSXOpeningElement");
          }
          jsxParseClosingElementAt(e) {
            let s = this.startNodeAt(e);
            return this.eat(141) ? this.finishNode(s, "JSXClosingFragment") : (s.name = this.jsxParseElementName(), this.expect(141), this.finishNode(s, "JSXClosingElement"));
          }
          jsxParseElementAt(e) {
            let s = this.startNodeAt(e), r = [], i = this.jsxParseOpeningElementAt(e), a = null;
            if (!i.selfClosing) {
              e:
                for (; ; )
                  switch (this.state.type) {
                    case 140:
                      if (e = this.state.startLoc, this.next(), this.eat(56)) {
                        a = this.jsxParseClosingElementAt(e);
                        break e;
                      }
                      r.push(this.jsxParseElementAt(e));
                      break;
                    case 139:
                      r.push(this.parseExprAtom());
                      break;
                    case 5: {
                      let n = this.startNode();
                      this.setContext(g.brace), this.next(), this.match(21) ? r.push(this.jsxParseSpreadChild(n)) : r.push(this.jsxParseExpressionContainer(n, g.j_expr));
                      break;
                    }
                    default:
                      this.unexpected();
                  }
              Re(i) && !Re(a) && a !== null ? this.raise($e.MissingClosingTagFragment, { at: a }) : !Re(i) && Re(a) ? this.raise($e.MissingClosingTagElement, { at: a, openingTagName: tt(i.name) }) : !Re(i) && !Re(a) && tt(a.name) !== tt(i.name) && this.raise($e.MissingClosingTagElement, { at: a, openingTagName: tt(i.name) });
            }
            if (Re(i) ? (s.openingFragment = i, s.closingFragment = a) : (s.openingElement = i, s.closingElement = a), s.children = r, this.match(47))
              throw this.raise($e.UnwrappedAdjacentJSXElements, { at: this.state.startLoc });
            return Re(i) ? this.finishNode(s, "JSXFragment") : this.finishNode(s, "JSXElement");
          }
          jsxParseElement() {
            let e = this.state.startLoc;
            return this.next(), this.jsxParseElementAt(e);
          }
          setContext(e) {
            let { context: s } = this.state;
            s[s.length - 1] = e;
          }
          parseExprAtom(e) {
            return this.match(139) ? this.parseLiteral(this.state.value, "JSXText") : this.match(140) ? this.jsxParseElement() : this.match(47) && this.input.charCodeAt(this.state.pos) !== 33 ? (this.replaceToken(140), this.jsxParseElement()) : super.parseExprAtom(e);
          }
          skipSpace() {
            this.curContext().preserveSpace || super.skipSpace();
          }
          getTokenFromCode(e) {
            let s = this.curContext();
            if (s === g.j_expr) {
              this.jsxReadToken();
              return;
            }
            if (s === g.j_oTag || s === g.j_cTag) {
              if (ke(e)) {
                this.jsxReadWord();
                return;
              }
              if (e === 62) {
                ++this.state.pos, this.finishToken(141);
                return;
              }
              if ((e === 34 || e === 39) && s === g.j_oTag) {
                this.jsxReadString(e);
                return;
              }
            }
            if (e === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33) {
              ++this.state.pos, this.finishToken(140);
              return;
            }
            super.getTokenFromCode(e);
          }
          updateContext(e) {
            let { context: s, type: r } = this.state;
            if (r === 56 && e === 140)
              s.splice(-2, 2, g.j_cTag), this.state.canStartJSXElement = !1;
            else if (r === 140)
              s.push(g.j_oTag);
            else if (r === 141) {
              let i = s[s.length - 1];
              i === g.j_oTag && e === 56 || i === g.j_cTag ? (s.pop(), this.state.canStartJSXElement = s[s.length - 1] === g.j_expr) : (this.setContext(g.j_expr), this.state.canStartJSXElement = !0);
            } else
              this.state.canStartJSXElement = be(r);
          }
        }, Kn = class extends us {
          constructor() {
            super(...arguments), this.types = /* @__PURE__ */ new Set(), this.enums = /* @__PURE__ */ new Set(), this.constEnums = /* @__PURE__ */ new Set(), this.classes = /* @__PURE__ */ new Set(), this.exportOnlyBindings = /* @__PURE__ */ new Set();
          }
        }, Wn = class extends cs {
          constructor() {
            super(...arguments), this.importsStack = [];
          }
          createScope(t) {
            return this.importsStack.push(/* @__PURE__ */ new Set()), new Kn(t);
          }
          enter(t) {
            t == Ye && this.importsStack.push(/* @__PURE__ */ new Set()), super.enter(t);
          }
          exit() {
            let t = super.exit();
            return t == Ye && this.importsStack.pop(), t;
          }
          hasImport(t, e) {
            let s = this.importsStack.length;
            if (this.importsStack[s - 1].has(t))
              return !0;
            if (!e && s > 1) {
              for (let r = 0; r < s - 1; r++)
                if (this.importsStack[r].has(t))
                  return !0;
            }
            return !1;
          }
          declareName(t, e, s) {
            if (e & at) {
              this.hasImport(t, !0) && this.parser.raise(p.VarRedeclaration, { at: s, identifierName: t }), this.importsStack[this.importsStack.length - 1].add(t);
              return;
            }
            let r = this.currentScope();
            if (e & as) {
              this.maybeExportDefined(r, t), r.exportOnlyBindings.add(t);
              return;
            }
            super.declareName(t, e, s), e & ze && (e & Se || (this.checkRedeclarationInScope(r, t, e, s), this.maybeExportDefined(r, t)), r.types.add(t)), e & rs && r.enums.add(t), e & is && r.constEnums.add(t), e & St && r.classes.add(t);
          }
          isRedeclaredInScope(t, e, s) {
            if (t.enums.has(e)) {
              if (s & rs) {
                let r = !!(s & is), i = t.constEnums.has(e);
                return r !== i;
              }
              return !0;
            }
            return s & St && t.classes.has(e) ? t.lexical.has(e) ? !!(s & Se) : !1 : s & ze && t.types.has(e) ? !0 : super.isRedeclaredInScope(t, e, s);
          }
          checkLocalExport(t) {
            let { name: e } = t;
            if (this.hasImport(e))
              return;
            let s = this.scopeStack.length;
            for (let r = s - 1; r >= 0; r--) {
              let i = this.scopeStack[r];
              if (i.types.has(e) || i.exportOnlyBindings.has(e))
                return;
            }
            super.checkLocalExport(t);
          }
        }, Jn = (t, e) => Object.hasOwnProperty.call(t, e) && t[e], Ur = (t) => t.type === "ParenthesizedExpression" ? Ur(t.expression) : t, Xn = class extends jn {
          toAssignable(t) {
            let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            var s, r;
            let i;
            switch ((t.type === "ParenthesizedExpression" || (s = t.extra) != null && s.parenthesized) && (i = Ur(t), e ? i.type === "Identifier" ? this.expressionScope.recordArrowParameterBindingError(p.InvalidParenthesizedAssignment, { at: t }) : i.type !== "MemberExpression" && this.raise(p.InvalidParenthesizedAssignment, { at: t }) : this.raise(p.InvalidParenthesizedAssignment, { at: t })), t.type) {
              case "Identifier":
              case "ObjectPattern":
              case "ArrayPattern":
              case "AssignmentPattern":
              case "RestElement":
                break;
              case "ObjectExpression":
                t.type = "ObjectPattern";
                for (let n = 0, o = t.properties.length, h = o - 1; n < o; n++) {
                  var a;
                  let l = t.properties[n], f = n === h;
                  this.toAssignableObjectExpressionProp(l, f, e), f && l.type === "RestElement" && (a = t.extra) != null && a.trailingCommaLoc && this.raise(p.RestTrailingComma, { at: t.extra.trailingCommaLoc });
                }
                break;
              case "ObjectProperty": {
                let { key: n, value: o } = t;
                this.isPrivateName(n) && this.classScope.usePrivateName(this.getPrivateNameSV(n), n.loc.start), this.toAssignable(o, e);
                break;
              }
              case "SpreadElement":
                throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
              case "ArrayExpression":
                t.type = "ArrayPattern", this.toAssignableList(t.elements, (r = t.extra) == null ? void 0 : r.trailingCommaLoc, e);
                break;
              case "AssignmentExpression":
                t.operator !== "=" && this.raise(p.MissingEqInAssignment, { at: t.left.loc.end }), t.type = "AssignmentPattern", delete t.operator, this.toAssignable(t.left, e);
                break;
              case "ParenthesizedExpression":
                this.toAssignable(i, e);
                break;
            }
          }
          toAssignableObjectExpressionProp(t, e, s) {
            if (t.type === "ObjectMethod")
              this.raise(t.kind === "get" || t.kind === "set" ? p.PatternHasAccessor : p.PatternHasMethod, { at: t.key });
            else if (t.type === "SpreadElement") {
              t.type = "RestElement";
              let r = t.argument;
              this.checkToRestConversion(r, !1), this.toAssignable(r, s), e || this.raise(p.RestTrailingComma, { at: t });
            } else
              this.toAssignable(t, s);
          }
          toAssignableList(t, e, s) {
            let r = t.length - 1;
            for (let i = 0; i <= r; i++) {
              let a = t[i];
              if (a) {
                if (a.type === "SpreadElement") {
                  a.type = "RestElement";
                  let n = a.argument;
                  this.checkToRestConversion(n, !0), this.toAssignable(n, s);
                } else
                  this.toAssignable(a, s);
                a.type === "RestElement" && (i < r ? this.raise(p.RestTrailingComma, { at: a }) : e && this.raise(p.RestTrailingComma, { at: e }));
              }
            }
          }
          isAssignable(t, e) {
            switch (t.type) {
              case "Identifier":
              case "ObjectPattern":
              case "ArrayPattern":
              case "AssignmentPattern":
              case "RestElement":
                return !0;
              case "ObjectExpression": {
                let s = t.properties.length - 1;
                return t.properties.every((r, i) => r.type !== "ObjectMethod" && (i === s || r.type !== "SpreadElement") && this.isAssignable(r));
              }
              case "ObjectProperty":
                return this.isAssignable(t.value);
              case "SpreadElement":
                return this.isAssignable(t.argument);
              case "ArrayExpression":
                return t.elements.every((s) => s === null || this.isAssignable(s));
              case "AssignmentExpression":
                return t.operator === "=";
              case "ParenthesizedExpression":
                return this.isAssignable(t.expression);
              case "MemberExpression":
              case "OptionalMemberExpression":
                return !e;
              default:
                return !1;
            }
          }
          toReferencedList(t, e) {
            return t;
          }
          toReferencedListDeep(t, e) {
            this.toReferencedList(t, e);
            for (let s of t)
              (s == null ? void 0 : s.type) === "ArrayExpression" && this.toReferencedListDeep(s.elements);
          }
          parseSpread(t) {
            let e = this.startNode();
            return this.next(), e.argument = this.parseMaybeAssignAllowIn(t, void 0), this.finishNode(e, "SpreadElement");
          }
          parseRestBinding() {
            let t = this.startNode();
            return this.next(), t.argument = this.parseBindingAtom(), this.finishNode(t, "RestElement");
          }
          parseBindingAtom() {
            switch (this.state.type) {
              case 0: {
                let t = this.startNode();
                return this.next(), t.elements = this.parseBindingList(3, 93, 1), this.finishNode(t, "ArrayPattern");
              }
              case 5:
                return this.parseObjectLike(8, !0);
            }
            return this.parseIdentifier();
          }
          parseBindingList(t, e, s) {
            let r = s & 1, i = [], a = !0;
            for (; !this.eat(t); )
              if (a ? a = !1 : this.expect(12), r && this.match(12))
                i.push(null);
              else {
                if (this.eat(t))
                  break;
                if (this.match(21)) {
                  if (i.push(this.parseAssignableListItemTypes(this.parseRestBinding(), s)), !this.checkCommaAfterRest(e)) {
                    this.expect(t);
                    break;
                  }
                } else {
                  let n = [];
                  for (this.match(26) && this.hasPlugin("decorators") && this.raise(p.UnsupportedParameterDecorator, { at: this.state.startLoc }); this.match(26); )
                    n.push(this.parseDecorator());
                  i.push(this.parseAssignableListItem(s, n));
                }
              }
            return i;
          }
          parseBindingRestProperty(t) {
            return this.next(), t.argument = this.parseIdentifier(), this.checkCommaAfterRest(125), this.finishNode(t, "RestElement");
          }
          parseBindingProperty() {
            let t = this.startNode(), { type: e, startLoc: s } = this.state;
            return e === 21 ? this.parseBindingRestProperty(t) : (e === 136 ? (this.expectPlugin("destructuringPrivate", s), this.classScope.usePrivateName(this.state.value, s), t.key = this.parsePrivateName()) : this.parsePropertyName(t), t.method = !1, this.parseObjPropValue(t, s, !1, !1, !0, !1));
          }
          parseAssignableListItem(t, e) {
            let s = this.parseMaybeDefault();
            this.parseAssignableListItemTypes(s, t);
            let r = this.parseMaybeDefault(s.loc.start, s);
            return e.length && (s.decorators = e), r;
          }
          parseAssignableListItemTypes(t, e) {
            return t;
          }
          parseMaybeDefault(t, e) {
            var s;
            if (t != null || (t = this.state.startLoc), e = (s = e) != null ? s : this.parseBindingAtom(), !this.eat(29))
              return e;
            let r = this.startNodeAt(t);
            return r.left = e, r.right = this.parseMaybeAssignAllowIn(), this.finishNode(r, "AssignmentPattern");
          }
          isValidLVal(t, e, s) {
            return Jn({ AssignmentPattern: "left", RestElement: "argument", ObjectProperty: "value", ParenthesizedExpression: "expression", ArrayPattern: "elements", ObjectPattern: "properties" }, t);
          }
          checkLVal(t, e) {
            let { in: s, binding: r = Oe, checkClashes: i = !1, strictModeChanged: a = !1, hasParenthesizedAncestor: n = !1 } = e;
            var o;
            let h = t.type;
            if (this.isObjectMethod(t))
              return;
            if (h === "MemberExpression") {
              r !== Oe && this.raise(p.InvalidPropertyBindingPattern, { at: t });
              return;
            }
            if (h === "Identifier") {
              this.checkIdentifier(t, r, a);
              let { name: B } = t;
              i && (i.has(B) ? this.raise(p.ParamDupe, { at: t }) : i.add(B));
              return;
            }
            let l = this.isValidLVal(h, !(n || (o = t.extra) != null && o.parenthesized) && s.type === "AssignmentExpression", r);
            if (l === !0)
              return;
            if (l === !1) {
              let B = r === Oe ? p.InvalidLhs : p.InvalidLhsBinding;
              this.raise(B, { at: t, ancestor: s });
              return;
            }
            let [f, T] = Array.isArray(l) ? l : [l, h === "ParenthesizedExpression"], R = h === "ArrayPattern" || h === "ObjectPattern" || h === "ParenthesizedExpression" ? { type: h } : s;
            for (let B of [].concat(t[f]))
              B && this.checkLVal(B, { in: R, binding: r, checkClashes: i, strictModeChanged: a, hasParenthesizedAncestor: T });
          }
          checkIdentifier(t, e) {
            let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            this.state.strict && (s ? fr(t.name, this.inModule) : mr(t.name)) && (e === Oe ? this.raise(p.StrictEvalArguments, { at: t, referenceName: t.name }) : this.raise(p.StrictEvalArgumentsBinding, { at: t, bindingName: t.name })), e & wt && t.name === "let" && this.raise(p.LetInLexicalBinding, { at: t }), e & Oe || this.declareNameFromIdentifier(t, e);
          }
          declareNameFromIdentifier(t, e) {
            this.scope.declareName(t.name, e, t.loc.start);
          }
          checkToRestConversion(t, e) {
            switch (t.type) {
              case "ParenthesizedExpression":
                this.checkToRestConversion(t.expression, e);
                break;
              case "Identifier":
              case "MemberExpression":
                break;
              case "ArrayExpression":
              case "ObjectExpression":
                if (e)
                  break;
              default:
                this.raise(p.InvalidRestAssignmentPattern, { at: t });
            }
          }
          checkCommaAfterRest(t) {
            return this.match(12) ? (this.raise(this.lookaheadCharCode() === t ? p.RestTrailingComma : p.ElementAfterRest, { at: this.state.startLoc }), !0) : !1;
          }
        }, Gn = (t, e) => Object.hasOwnProperty.call(t, e) && t[e];
        function Yn(t) {
          if (t == null)
            throw new Error(`Unexpected ${t} value.`);
          return t;
        }
        function _r(t) {
          if (!t)
            throw new Error("Assert fail");
        }
        var j = Ne`typescript`({ AbstractMethodHasImplementation: (t) => {
          let { methodName: e } = t;
          return `Method '${e}' cannot have an implementation because it is marked abstract.`;
        }, AbstractPropertyHasInitializer: (t) => {
          let { propertyName: e } = t;
          return `Property '${e}' cannot have an initializer because it is marked abstract.`;
        }, AccesorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.", AccesorCannotHaveTypeParameters: "An accessor cannot have type parameters.", AccessorCannotBeOptional: "An 'accessor' property cannot be declared optional.", ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.", ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.", ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.", ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.", DeclareAccessor: (t) => {
          let { kind: e } = t;
          return `'declare' is not allowed in ${e}ters.`;
        }, DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.", DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.", DuplicateAccessibilityModifier: (t) => "Accessibility modifier already seen.", DuplicateModifier: (t) => {
          let { modifier: e } = t;
          return `Duplicate modifier: '${e}'.`;
        }, EmptyHeritageClauseType: (t) => {
          let { token: e } = t;
          return `'${e}' list cannot be empty.`;
        }, EmptyTypeArguments: "Type argument list cannot be empty.", EmptyTypeParameters: "Type parameter list cannot be empty.", ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.", ImportAliasHasImportType: "An import alias can not use 'import type'.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier", IncompatibleModifiers: (t) => {
          let { modifiers: e } = t;
          return `'${e[0]}' modifier cannot be used with '${e[1]}' modifier.`;
        }, IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.", IndexSignatureHasAccessibility: (t) => {
          let { modifier: e } = t;
          return `Index signatures cannot have an accessibility modifier ('${e}').`;
        }, IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.", IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.", IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.", InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.", InvalidModifierOnTypeMember: (t) => {
          let { modifier: e } = t;
          return `'${e}' modifier cannot appear on a type member.`;
        }, InvalidModifierOnTypeParameter: (t) => {
          let { modifier: e } = t;
          return `'${e}' modifier cannot appear on a type parameter.`;
        }, InvalidModifierOnTypeParameterPositions: (t) => {
          let { modifier: e } = t;
          return `'${e}' modifier can only appear on a type parameter of a class, interface or type alias.`;
        }, InvalidModifiersOrder: (t) => {
          let { orderedModifiers: e } = t;
          return `'${e[0]}' modifier must precede '${e[1]}' modifier.`;
        }, InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.", InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.", MissingInterfaceName: "'interface' declarations must be followed by an identifier.", MixedLabeledAndUnlabeledElements: "Tuple members must all have names or all not have names.", NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.", NonClassMethodPropertyHasAbstractModifer: "'abstract' modifier can only appear on a class, method, or property declaration.", OptionalTypeBeforeRequired: "A required element cannot follow an optional element.", OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.", PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.", PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.", PrivateElementHasAccessibility: (t) => {
          let { modifier: e } = t;
          return `Private elements cannot have an accessibility modifier ('${e}').`;
        }, ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.", ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.", ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.", SetAccesorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.", SetAccesorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.", SetAccesorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.", SingleTypeParameterWithoutTrailingComma: (t) => {
          let { typeParameterName: e } = t;
          return `Single type parameter ${e} should have a trailing comma. Example usage: <${e},>.`;
        }, StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.", TupleOptionalAfterType: "A labeled tuple optional element must be declared using a question mark after the name and before the colon (`name?: type`), rather than after the type (`name: type?`).", TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.", TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.", TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.", UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.", UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.", UnexpectedTypeAnnotation: "Did not expect a type annotation here.", UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.", UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.", UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.", UnsupportedSignatureParameterKind: (t) => {
          let { type: e } = t;
          return `Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${e}.`;
        } });
        function Qn(t) {
          switch (t) {
            case "any":
              return "TSAnyKeyword";
            case "boolean":
              return "TSBooleanKeyword";
            case "bigint":
              return "TSBigIntKeyword";
            case "never":
              return "TSNeverKeyword";
            case "number":
              return "TSNumberKeyword";
            case "object":
              return "TSObjectKeyword";
            case "string":
              return "TSStringKeyword";
            case "symbol":
              return "TSSymbolKeyword";
            case "undefined":
              return "TSUndefinedKeyword";
            case "unknown":
              return "TSUnknownKeyword";
            default:
              return;
          }
        }
        function zr(t) {
          return t === "private" || t === "public" || t === "protected";
        }
        function Zn(t) {
          return t === "in" || t === "out";
        }
        var eo = (t) => class extends t {
          constructor() {
            super(...arguments), this.tsParseInOutModifiers = this.tsParseModifiers.bind(this, { allowedModifiers: ["in", "out"], disallowedModifiers: ["const", "public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: j.InvalidModifierOnTypeParameter }), this.tsParseConstModifier = this.tsParseModifiers.bind(this, { allowedModifiers: ["const"], disallowedModifiers: ["in", "out"], errorTemplate: j.InvalidModifierOnTypeParameterPositions }), this.tsParseInOutConstModifiers = this.tsParseModifiers.bind(this, { allowedModifiers: ["in", "out", "const"], disallowedModifiers: ["public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: j.InvalidModifierOnTypeParameter });
          }
          getScopeHandler() {
            return Wn;
          }
          tsIsIdentifier() {
            return te(this.state.type);
          }
          tsTokenCanFollowModifier() {
            return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(136) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
          }
          tsNextTokenCanFollowModifier() {
            return this.next(), this.tsTokenCanFollowModifier();
          }
          tsParseModifier(e, s) {
            if (!te(this.state.type) && this.state.type !== 58 && this.state.type !== 75)
              return;
            let r = this.state.value;
            if (e.indexOf(r) !== -1) {
              if (s && this.tsIsStartOfStaticBlocks())
                return;
              if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this)))
                return r;
            }
          }
          tsParseModifiers(e, s) {
            let { allowedModifiers: r, disallowedModifiers: i, stopOnStartOfClassStaticBlock: a, errorTemplate: n = j.InvalidModifierOnTypeMember } = e, o = (l, f, T, R) => {
              f === T && s[R] && this.raise(j.InvalidModifiersOrder, { at: l, orderedModifiers: [T, R] });
            }, h = (l, f, T, R) => {
              (s[T] && f === R || s[R] && f === T) && this.raise(j.IncompatibleModifiers, { at: l, modifiers: [T, R] });
            };
            for (; ; ) {
              let { startLoc: l } = this.state, f = this.tsParseModifier(r.concat(i ?? []), a);
              if (!f)
                break;
              zr(f) ? s.accessibility ? this.raise(j.DuplicateAccessibilityModifier, { at: l, modifier: f }) : (o(l, f, f, "override"), o(l, f, f, "static"), o(l, f, f, "readonly"), s.accessibility = f) : Zn(f) ? (s[f] && this.raise(j.DuplicateModifier, { at: l, modifier: f }), s[f] = !0, o(l, f, "in", "out")) : (Object.hasOwnProperty.call(s, f) ? this.raise(j.DuplicateModifier, { at: l, modifier: f }) : (o(l, f, "static", "readonly"), o(l, f, "static", "override"), o(l, f, "override", "readonly"), o(l, f, "abstract", "override"), h(l, f, "declare", "override"), h(l, f, "static", "abstract")), s[f] = !0), i != null && i.includes(f) && this.raise(n, { at: l, modifier: f });
            }
          }
          tsIsListTerminator(e) {
            switch (e) {
              case "EnumMembers":
              case "TypeMembers":
                return this.match(8);
              case "HeritageClauseElement":
                return this.match(5);
              case "TupleElementTypes":
                return this.match(3);
              case "TypeParametersOrArguments":
                return this.match(48);
            }
          }
          tsParseList(e, s) {
            let r = [];
            for (; !this.tsIsListTerminator(e); )
              r.push(s());
            return r;
          }
          tsParseDelimitedList(e, s, r) {
            return Yn(this.tsParseDelimitedListWorker(e, s, !0, r));
          }
          tsParseDelimitedListWorker(e, s, r, i) {
            let a = [], n = -1;
            for (; !this.tsIsListTerminator(e); ) {
              n = -1;
              let o = s();
              if (o == null)
                return;
              if (a.push(o), this.eat(12)) {
                n = this.state.lastTokStart;
                continue;
              }
              if (this.tsIsListTerminator(e))
                break;
              r && this.expect(12);
              return;
            }
            return i && (i.value = n), a;
          }
          tsParseBracketedList(e, s, r, i, a) {
            i || (r ? this.expect(0) : this.expect(47));
            let n = this.tsParseDelimitedList(e, s, a);
            return r ? this.expect(3) : this.expect(48), n;
          }
          tsParseImportType() {
            let e = this.startNode();
            return this.expect(83), this.expect(10), this.match(131) || this.raise(j.UnsupportedImportTypeArgument, { at: this.state.startLoc }), e.argument = super.parseExprAtom(), this.expect(11), this.eat(16) && (e.qualifier = this.tsParseEntityName()), this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSImportType");
          }
          tsParseEntityName() {
            let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, s = this.parseIdentifier(e);
            for (; this.eat(16); ) {
              let r = this.startNodeAtNode(s);
              r.left = s, r.right = this.parseIdentifier(e), s = this.finishNode(r, "TSQualifiedName");
            }
            return s;
          }
          tsParseTypeReference() {
            let e = this.startNode();
            return e.typeName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSTypeReference");
          }
          tsParseThisTypePredicate(e) {
            this.next();
            let s = this.startNodeAtNode(e);
            return s.parameterName = e, s.typeAnnotation = this.tsParseTypeAnnotation(!1), s.asserts = !1, this.finishNode(s, "TSTypePredicate");
          }
          tsParseThisTypeNode() {
            let e = this.startNode();
            return this.next(), this.finishNode(e, "TSThisType");
          }
          tsParseTypeQuery() {
            let e = this.startNode();
            return this.expect(87), this.match(83) ? e.exprName = this.tsParseImportType() : e.exprName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSTypeQuery");
          }
          tsParseTypeParameter(e) {
            let s = this.startNode();
            return e(s), s.name = this.tsParseTypeParameterName(), s.constraint = this.tsEatThenParseType(81), s.default = this.tsEatThenParseType(29), this.finishNode(s, "TSTypeParameter");
          }
          tsTryParseTypeParameters(e) {
            if (this.match(47))
              return this.tsParseTypeParameters(e);
          }
          tsParseTypeParameters(e) {
            let s = this.startNode();
            this.match(47) || this.match(140) ? this.next() : this.unexpected();
            let r = { value: -1 };
            return s.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this, e), !1, !0, r), s.params.length === 0 && this.raise(j.EmptyTypeParameters, { at: s }), r.value !== -1 && this.addExtra(s, "trailingComma", r.value), this.finishNode(s, "TSTypeParameterDeclaration");
          }
          tsFillSignature(e, s) {
            let r = e === 19, i = "parameters", a = "typeAnnotation";
            s.typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier), this.expect(10), s[i] = this.tsParseBindingListForSignature(), r ? s[a] = this.tsParseTypeOrTypePredicateAnnotation(e) : this.match(e) && (s[a] = this.tsParseTypeOrTypePredicateAnnotation(e));
          }
          tsParseBindingListForSignature() {
            return super.parseBindingList(11, 41, 2).map((e) => (e.type !== "Identifier" && e.type !== "RestElement" && e.type !== "ObjectPattern" && e.type !== "ArrayPattern" && this.raise(j.UnsupportedSignatureParameterKind, { at: e, type: e.type }), e));
          }
          tsParseTypeMemberSemicolon() {
            !this.eat(12) && !this.isLineTerminator() && this.expect(13);
          }
          tsParseSignatureMember(e, s) {
            return this.tsFillSignature(14, s), this.tsParseTypeMemberSemicolon(), this.finishNode(s, e);
          }
          tsIsUnambiguouslyIndexSignature() {
            return this.next(), te(this.state.type) ? (this.next(), this.match(14)) : !1;
          }
          tsTryParseIndexSignature(e) {
            if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this))))
              return;
            this.expect(0);
            let s = this.parseIdentifier();
            s.typeAnnotation = this.tsParseTypeAnnotation(), this.resetEndLocation(s), this.expect(3), e.parameters = [s];
            let r = this.tsTryParseTypeAnnotation();
            return r && (e.typeAnnotation = r), this.tsParseTypeMemberSemicolon(), this.finishNode(e, "TSIndexSignature");
          }
          tsParsePropertyOrMethodSignature(e, s) {
            this.eat(17) && (e.optional = !0);
            let r = e;
            if (this.match(10) || this.match(47)) {
              s && this.raise(j.ReadonlyForMethodSignature, { at: e });
              let i = r;
              i.kind && this.match(47) && this.raise(j.AccesorCannotHaveTypeParameters, { at: this.state.curPosition() }), this.tsFillSignature(14, i), this.tsParseTypeMemberSemicolon();
              let a = "parameters", n = "typeAnnotation";
              if (i.kind === "get")
                i[a].length > 0 && (this.raise(p.BadGetterArity, { at: this.state.curPosition() }), this.isThisParam(i[a][0]) && this.raise(j.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }));
              else if (i.kind === "set") {
                if (i[a].length !== 1)
                  this.raise(p.BadSetterArity, { at: this.state.curPosition() });
                else {
                  let o = i[a][0];
                  this.isThisParam(o) && this.raise(j.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }), o.type === "Identifier" && o.optional && this.raise(j.SetAccesorCannotHaveOptionalParameter, { at: this.state.curPosition() }), o.type === "RestElement" && this.raise(j.SetAccesorCannotHaveRestParameter, { at: this.state.curPosition() });
                }
                i[n] && this.raise(j.SetAccesorCannotHaveReturnType, { at: i[n] });
              } else
                i.kind = "method";
              return this.finishNode(i, "TSMethodSignature");
            } else {
              let i = r;
              s && (i.readonly = !0);
              let a = this.tsTryParseTypeAnnotation();
              return a && (i.typeAnnotation = a), this.tsParseTypeMemberSemicolon(), this.finishNode(i, "TSPropertySignature");
            }
          }
          tsParseTypeMember() {
            let e = this.startNode();
            if (this.match(10) || this.match(47))
              return this.tsParseSignatureMember("TSCallSignatureDeclaration", e);
            if (this.match(77)) {
              let r = this.startNode();
              return this.next(), this.match(10) || this.match(47) ? this.tsParseSignatureMember("TSConstructSignatureDeclaration", e) : (e.key = this.createIdentifier(r, "new"), this.tsParsePropertyOrMethodSignature(e, !1));
            }
            return this.tsParseModifiers({ allowedModifiers: ["readonly"], disallowedModifiers: ["declare", "abstract", "private", "protected", "public", "static", "override"] }, e), this.tsTryParseIndexSignature(e) || (super.parsePropertyName(e), !e.computed && e.key.type === "Identifier" && (e.key.name === "get" || e.key.name === "set") && this.tsTokenCanFollowModifier() && (e.kind = e.key.name, super.parsePropertyName(e)), this.tsParsePropertyOrMethodSignature(e, !!e.readonly));
          }
          tsParseTypeLiteral() {
            let e = this.startNode();
            return e.members = this.tsParseObjectTypeMembers(), this.finishNode(e, "TSTypeLiteral");
          }
          tsParseObjectTypeMembers() {
            this.expect(5);
            let e = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
            return this.expect(8), e;
          }
          tsIsStartOfMappedType() {
            return this.next(), this.eat(53) ? this.isContextual(120) : (this.isContextual(120) && this.next(), !this.match(0) || (this.next(), !this.tsIsIdentifier()) ? !1 : (this.next(), this.match(58)));
          }
          tsParseMappedTypeParameter() {
            let e = this.startNode();
            return e.name = this.tsParseTypeParameterName(), e.constraint = this.tsExpectThenParseType(58), this.finishNode(e, "TSTypeParameter");
          }
          tsParseMappedType() {
            let e = this.startNode();
            return this.expect(5), this.match(53) ? (e.readonly = this.state.value, this.next(), this.expectContextual(120)) : this.eatContextual(120) && (e.readonly = !0), this.expect(0), e.typeParameter = this.tsParseMappedTypeParameter(), e.nameType = this.eatContextual(93) ? this.tsParseType() : null, this.expect(3), this.match(53) ? (e.optional = this.state.value, this.next(), this.expect(17)) : this.eat(17) && (e.optional = !0), e.typeAnnotation = this.tsTryParseType(), this.semicolon(), this.expect(8), this.finishNode(e, "TSMappedType");
          }
          tsParseTupleType() {
            let e = this.startNode();
            e.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), !0, !1);
            let s = !1, r = null;
            return e.elementTypes.forEach((i) => {
              let { type: a } = i;
              s && a !== "TSRestType" && a !== "TSOptionalType" && !(a === "TSNamedTupleMember" && i.optional) && this.raise(j.OptionalTypeBeforeRequired, { at: i }), s || (s = a === "TSNamedTupleMember" && i.optional || a === "TSOptionalType");
              let n = a;
              a === "TSRestType" && (i = i.typeAnnotation, n = i.type);
              let o = n === "TSNamedTupleMember";
              r != null || (r = o), r !== o && this.raise(j.MixedLabeledAndUnlabeledElements, { at: i });
            }), this.finishNode(e, "TSTupleType");
          }
          tsParseTupleElementType() {
            let { startLoc: e } = this.state, s = this.eat(21), r, i, a, n, o = Ae(this.state.type) ? this.lookaheadCharCode() : null;
            if (o === 58)
              r = !0, a = !1, i = this.parseIdentifier(!0), this.expect(14), n = this.tsParseType();
            else if (o === 63) {
              a = !0;
              let h = this.state.startLoc, l = this.state.value, f = this.tsParseNonArrayType();
              this.lookaheadCharCode() === 58 ? (r = !0, i = this.createIdentifier(this.startNodeAt(h), l), this.expect(17), this.expect(14), n = this.tsParseType()) : (r = !1, n = f, this.expect(17));
            } else
              n = this.tsParseType(), a = this.eat(17), r = this.eat(14);
            if (r) {
              let h;
              i ? (h = this.startNodeAtNode(i), h.optional = a, h.label = i, h.elementType = n, this.eat(17) && (h.optional = !0, this.raise(j.TupleOptionalAfterType, { at: this.state.lastTokStartLoc }))) : (h = this.startNodeAtNode(n), h.optional = a, this.raise(j.InvalidTupleMemberLabel, { at: n }), h.label = n, h.elementType = this.tsParseType()), n = this.finishNode(h, "TSNamedTupleMember");
            } else if (a) {
              let h = this.startNodeAtNode(n);
              h.typeAnnotation = n, n = this.finishNode(h, "TSOptionalType");
            }
            if (s) {
              let h = this.startNodeAt(e);
              h.typeAnnotation = n, n = this.finishNode(h, "TSRestType");
            }
            return n;
          }
          tsParseParenthesizedType() {
            let e = this.startNode();
            return this.expect(10), e.typeAnnotation = this.tsParseType(), this.expect(11), this.finishNode(e, "TSParenthesizedType");
          }
          tsParseFunctionOrConstructorType(e, s) {
            let r = this.startNode();
            return e === "TSConstructorType" && (r.abstract = !!s, s && this.next(), this.next()), this.tsInAllowConditionalTypesContext(() => this.tsFillSignature(19, r)), this.finishNode(r, e);
          }
          tsParseLiteralTypeNode() {
            let e = this.startNode();
            return e.literal = (() => {
              switch (this.state.type) {
                case 132:
                case 133:
                case 131:
                case 85:
                case 86:
                  return super.parseExprAtom();
                default:
                  this.unexpected();
              }
            })(), this.finishNode(e, "TSLiteralType");
          }
          tsParseTemplateLiteralType() {
            let e = this.startNode();
            return e.literal = super.parseTemplate(!1), this.finishNode(e, "TSLiteralType");
          }
          parseTemplateSubstitution() {
            return this.state.inType ? this.tsParseType() : super.parseTemplateSubstitution();
          }
          tsParseThisTypeOrThisTypePredicate() {
            let e = this.tsParseThisTypeNode();
            return this.isContextual(114) && !this.hasPrecedingLineBreak() ? this.tsParseThisTypePredicate(e) : e;
          }
          tsParseNonArrayType() {
            switch (this.state.type) {
              case 131:
              case 132:
              case 133:
              case 85:
              case 86:
                return this.tsParseLiteralTypeNode();
              case 53:
                if (this.state.value === "-") {
                  let e = this.startNode(), s = this.lookahead();
                  return s.type !== 132 && s.type !== 133 && this.unexpected(), e.literal = this.parseMaybeUnary(), this.finishNode(e, "TSLiteralType");
                }
                break;
              case 78:
                return this.tsParseThisTypeOrThisTypePredicate();
              case 87:
                return this.tsParseTypeQuery();
              case 83:
                return this.tsParseImportType();
              case 5:
                return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
              case 0:
                return this.tsParseTupleType();
              case 10:
                return this.tsParseParenthesizedType();
              case 25:
              case 24:
                return this.tsParseTemplateLiteralType();
              default: {
                let { type: e } = this.state;
                if (te(e) || e === 88 || e === 84) {
                  let s = e === 88 ? "TSVoidKeyword" : e === 84 ? "TSNullKeyword" : Qn(this.state.value);
                  if (s !== void 0 && this.lookaheadCharCode() !== 46) {
                    let r = this.startNode();
                    return this.next(), this.finishNode(r, s);
                  }
                  return this.tsParseTypeReference();
                }
              }
            }
            this.unexpected();
          }
          tsParseArrayTypeOrHigher() {
            let e = this.tsParseNonArrayType();
            for (; !this.hasPrecedingLineBreak() && this.eat(0); )
              if (this.match(3)) {
                let s = this.startNodeAtNode(e);
                s.elementType = e, this.expect(3), e = this.finishNode(s, "TSArrayType");
              } else {
                let s = this.startNodeAtNode(e);
                s.objectType = e, s.indexType = this.tsParseType(), this.expect(3), e = this.finishNode(s, "TSIndexedAccessType");
              }
            return e;
          }
          tsParseTypeOperator() {
            let e = this.startNode(), s = this.state.value;
            return this.next(), e.operator = s, e.typeAnnotation = this.tsParseTypeOperatorOrHigher(), s === "readonly" && this.tsCheckTypeAnnotationForReadOnly(e), this.finishNode(e, "TSTypeOperator");
          }
          tsCheckTypeAnnotationForReadOnly(e) {
            switch (e.typeAnnotation.type) {
              case "TSTupleType":
              case "TSArrayType":
                return;
              default:
                this.raise(j.UnexpectedReadonly, { at: e });
            }
          }
          tsParseInferType() {
            let e = this.startNode();
            this.expectContextual(113);
            let s = this.startNode();
            return s.name = this.tsParseTypeParameterName(), s.constraint = this.tsTryParse(() => this.tsParseConstraintForInferType()), e.typeParameter = this.finishNode(s, "TSTypeParameter"), this.finishNode(e, "TSInferType");
          }
          tsParseConstraintForInferType() {
            if (this.eat(81)) {
              let e = this.tsInDisallowConditionalTypesContext(() => this.tsParseType());
              if (this.state.inDisallowConditionalTypesContext || !this.match(17))
                return e;
            }
          }
          tsParseTypeOperatorOrHigher() {
            return Na(this.state.type) && !this.state.containsEsc ? this.tsParseTypeOperator() : this.isContextual(113) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(() => this.tsParseArrayTypeOrHigher());
          }
          tsParseUnionOrIntersectionType(e, s, r) {
            let i = this.startNode(), a = this.eat(r), n = [];
            do
              n.push(s());
            while (this.eat(r));
            return n.length === 1 && !a ? n[0] : (i.types = n, this.finishNode(i, e));
          }
          tsParseIntersectionTypeOrHigher() {
            return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
          }
          tsParseUnionTypeOrHigher() {
            return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
          }
          tsIsStartOfFunctionType() {
            return this.match(47) ? !0 : this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
          }
          tsSkipParameterStart() {
            if (te(this.state.type) || this.match(78))
              return this.next(), !0;
            if (this.match(5)) {
              let { errors: e } = this.state, s = e.length;
              try {
                return this.parseObjectLike(8, !0), e.length === s;
              } catch {
                return !1;
              }
            }
            if (this.match(0)) {
              this.next();
              let { errors: e } = this.state, s = e.length;
              try {
                return super.parseBindingList(3, 93, 1), e.length === s;
              } catch {
                return !1;
              }
            }
            return !1;
          }
          tsIsUnambiguouslyStartOfFunctionType() {
            return this.next(), !!(this.match(11) || this.match(21) || this.tsSkipParameterStart() && (this.match(14) || this.match(12) || this.match(17) || this.match(29) || this.match(11) && (this.next(), this.match(19))));
          }
          tsParseTypeOrTypePredicateAnnotation(e) {
            return this.tsInType(() => {
              let s = this.startNode();
              this.expect(e);
              let r = this.startNode(), i = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
              if (i && this.match(78)) {
                let o = this.tsParseThisTypeOrThisTypePredicate();
                return o.type === "TSThisType" ? (r.parameterName = o, r.asserts = !0, r.typeAnnotation = null, o = this.finishNode(r, "TSTypePredicate")) : (this.resetStartLocationFromNode(o, r), o.asserts = !0), s.typeAnnotation = o, this.finishNode(s, "TSTypeAnnotation");
              }
              let a = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
              if (!a)
                return i ? (r.parameterName = this.parseIdentifier(), r.asserts = i, r.typeAnnotation = null, s.typeAnnotation = this.finishNode(r, "TSTypePredicate"), this.finishNode(s, "TSTypeAnnotation")) : this.tsParseTypeAnnotation(!1, s);
              let n = this.tsParseTypeAnnotation(!1);
              return r.parameterName = a, r.typeAnnotation = n, r.asserts = i, s.typeAnnotation = this.finishNode(r, "TSTypePredicate"), this.finishNode(s, "TSTypeAnnotation");
            });
          }
          tsTryParseTypeOrTypePredicateAnnotation() {
            return this.match(14) ? this.tsParseTypeOrTypePredicateAnnotation(14) : void 0;
          }
          tsTryParseTypeAnnotation() {
            return this.match(14) ? this.tsParseTypeAnnotation() : void 0;
          }
          tsTryParseType() {
            return this.tsEatThenParseType(14);
          }
          tsParseTypePredicatePrefix() {
            let e = this.parseIdentifier();
            if (this.isContextual(114) && !this.hasPrecedingLineBreak())
              return this.next(), e;
          }
          tsParseTypePredicateAsserts() {
            if (this.state.type !== 107)
              return !1;
            let e = this.state.containsEsc;
            return this.next(), !te(this.state.type) && !this.match(78) ? !1 : (e && this.raise(p.InvalidEscapedReservedWord, { at: this.state.lastTokStartLoc, reservedWord: "asserts" }), !0);
          }
          tsParseTypeAnnotation() {
            let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.startNode();
            return this.tsInType(() => {
              e && this.expect(14), s.typeAnnotation = this.tsParseType();
            }), this.finishNode(s, "TSTypeAnnotation");
          }
          tsParseType() {
            _r(this.state.inType);
            let e = this.tsParseNonConditionalType();
            if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81))
              return e;
            let s = this.startNodeAtNode(e);
            return s.checkType = e, s.extendsType = this.tsInDisallowConditionalTypesContext(() => this.tsParseNonConditionalType()), this.expect(17), s.trueType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.expect(14), s.falseType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.finishNode(s, "TSConditionalType");
          }
          isAbstractConstructorSignature() {
            return this.isContextual(122) && this.lookahead().type === 77;
          }
          tsParseNonConditionalType() {
            return this.tsIsStartOfFunctionType() ? this.tsParseFunctionOrConstructorType("TSFunctionType") : this.match(77) ? this.tsParseFunctionOrConstructorType("TSConstructorType") : this.isAbstractConstructorSignature() ? this.tsParseFunctionOrConstructorType("TSConstructorType", !0) : this.tsParseUnionTypeOrHigher();
          }
          tsParseTypeAssertion() {
            this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(j.ReservedTypeAssertion, { at: this.state.startLoc });
            let e = this.startNode();
            return e.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? this.tsParseTypeReference() : this.tsParseType())), this.expect(48), e.expression = this.parseMaybeUnary(), this.finishNode(e, "TSTypeAssertion");
          }
          tsParseHeritageClause(e) {
            let s = this.state.startLoc, r = this.tsParseDelimitedList("HeritageClauseElement", () => {
              let i = this.startNode();
              return i.expression = this.tsParseEntityName(), this.match(47) && (i.typeParameters = this.tsParseTypeArguments()), this.finishNode(i, "TSExpressionWithTypeArguments");
            });
            return r.length || this.raise(j.EmptyHeritageClauseType, { at: s, token: e }), r;
          }
          tsParseInterfaceDeclaration(e) {
            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (this.hasFollowingLineBreak())
              return null;
            this.expectContextual(127), s.declare && (e.declare = !0), te(this.state.type) ? (e.id = this.parseIdentifier(), this.checkIdentifier(e.id, tn)) : (e.id = null, this.raise(j.MissingInterfaceName, { at: this.state.startLoc })), e.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers), this.eat(81) && (e.extends = this.tsParseHeritageClause("extends"));
            let r = this.startNode();
            return r.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this)), e.body = this.finishNode(r, "TSInterfaceBody"), this.finishNode(e, "TSInterfaceDeclaration");
          }
          tsParseTypeAliasDeclaration(e) {
            return e.id = this.parseIdentifier(), this.checkIdentifier(e.id, sn), e.typeAnnotation = this.tsInType(() => {
              if (e.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers), this.expect(29), this.isContextual(112) && this.lookahead().type !== 16) {
                let s = this.startNode();
                return this.next(), this.finishNode(s, "TSIntrinsicKeyword");
              }
              return this.tsParseType();
            }), this.semicolon(), this.finishNode(e, "TSTypeAliasDeclaration");
          }
          tsInNoContext(e) {
            let s = this.state.context;
            this.state.context = [s[0]];
            try {
              return e();
            } finally {
              this.state.context = s;
            }
          }
          tsInType(e) {
            let s = this.state.inType;
            this.state.inType = !0;
            try {
              return e();
            } finally {
              this.state.inType = s;
            }
          }
          tsInDisallowConditionalTypesContext(e) {
            let s = this.state.inDisallowConditionalTypesContext;
            this.state.inDisallowConditionalTypesContext = !0;
            try {
              return e();
            } finally {
              this.state.inDisallowConditionalTypesContext = s;
            }
          }
          tsInAllowConditionalTypesContext(e) {
            let s = this.state.inDisallowConditionalTypesContext;
            this.state.inDisallowConditionalTypesContext = !1;
            try {
              return e();
            } finally {
              this.state.inDisallowConditionalTypesContext = s;
            }
          }
          tsEatThenParseType(e) {
            return this.match(e) ? this.tsNextThenParseType() : void 0;
          }
          tsExpectThenParseType(e) {
            return this.tsDoThenParseType(() => this.expect(e));
          }
          tsNextThenParseType() {
            return this.tsDoThenParseType(() => this.next());
          }
          tsDoThenParseType(e) {
            return this.tsInType(() => (e(), this.tsParseType()));
          }
          tsParseEnumMember() {
            let e = this.startNode();
            return e.id = this.match(131) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(!0), this.eat(29) && (e.initializer = super.parseMaybeAssignAllowIn()), this.finishNode(e, "TSEnumMember");
          }
          tsParseEnumDeclaration(e) {
            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return s.const && (e.const = !0), s.declare && (e.declare = !0), this.expectContextual(124), e.id = this.parseIdentifier(), this.checkIdentifier(e.id, e.const ? an : Tr), this.expect(5), e.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this)), this.expect(8), this.finishNode(e, "TSEnumDeclaration");
          }
          tsParseModuleBlock() {
            let e = this.startNode();
            return this.scope.enter(Xe), this.expect(5), super.parseBlockOrModuleBlockBody(e.body = [], void 0, !0, 8), this.scope.exit(), this.finishNode(e, "TSModuleBlock");
          }
          tsParseModuleOrNamespaceDeclaration(e) {
            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            if (e.id = this.parseIdentifier(), s || this.checkIdentifier(e.id, nn), this.eat(16)) {
              let r = this.startNode();
              this.tsParseModuleOrNamespaceDeclaration(r, !0), e.body = r;
            } else
              this.scope.enter(Ye), this.prodParam.enter(Ze), e.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit();
            return this.finishNode(e, "TSModuleDeclaration");
          }
          tsParseAmbientExternalModuleDeclaration(e) {
            return this.isContextual(110) ? (e.global = !0, e.id = this.parseIdentifier()) : this.match(131) ? e.id = super.parseStringLiteral(this.state.value) : this.unexpected(), this.match(5) ? (this.scope.enter(Ye), this.prodParam.enter(Ze), e.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit()) : this.semicolon(), this.finishNode(e, "TSModuleDeclaration");
          }
          tsParseImportEqualsDeclaration(e, s) {
            e.isExport = s || !1, e.id = this.parseIdentifier(), this.checkIdentifier(e.id, at), this.expect(29);
            let r = this.tsParseModuleReference();
            return e.importKind === "type" && r.type !== "TSExternalModuleReference" && this.raise(j.ImportAliasHasImportType, { at: r }), e.moduleReference = r, this.semicolon(), this.finishNode(e, "TSImportEqualsDeclaration");
          }
          tsIsExternalModuleReference() {
            return this.isContextual(117) && this.lookaheadCharCode() === 40;
          }
          tsParseModuleReference() {
            return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(!1);
          }
          tsParseExternalModuleReference() {
            let e = this.startNode();
            return this.expectContextual(117), this.expect(10), this.match(131) || this.unexpected(), e.expression = super.parseExprAtom(), this.expect(11), this.finishNode(e, "TSExternalModuleReference");
          }
          tsLookAhead(e) {
            let s = this.state.clone(), r = e();
            return this.state = s, r;
          }
          tsTryParseAndCatch(e) {
            let s = this.tryParse((r) => e() || r());
            if (!(s.aborted || !s.node))
              return s.error && (this.state = s.failState), s.node;
          }
          tsTryParse(e) {
            let s = this.state.clone(), r = e();
            if (r !== void 0 && r !== !1)
              return r;
            this.state = s;
          }
          tsTryParseDeclare(e) {
            if (this.isLineTerminator())
              return;
            let s = this.state.type, r;
            return this.isContextual(99) && (s = 74, r = "let"), this.tsInAmbientContext(() => {
              if (s === 68)
                return e.declare = !0, super.parseFunctionStatement(e, !1, !1);
              if (s === 80)
                return e.declare = !0, this.parseClass(e, !0, !1);
              if (s === 124)
                return this.tsParseEnumDeclaration(e, { declare: !0 });
              if (s === 110)
                return this.tsParseAmbientExternalModuleDeclaration(e);
              if (s === 75 || s === 74)
                return !this.match(75) || !this.isLookaheadContextual("enum") ? (e.declare = !0, this.parseVarStatement(e, r || this.state.value, !0)) : (this.expect(75), this.tsParseEnumDeclaration(e, { const: !0, declare: !0 }));
              if (s === 127) {
                let i = this.tsParseInterfaceDeclaration(e, { declare: !0 });
                if (i)
                  return i;
              }
              if (te(s))
                return this.tsParseDeclaration(e, this.state.value, !0, null);
            });
          }
          tsTryParseExportDeclaration() {
            return this.tsParseDeclaration(this.startNode(), this.state.value, !0, null);
          }
          tsParseExpressionStatement(e, s, r) {
            switch (s.name) {
              case "declare": {
                let i = this.tsTryParseDeclare(e);
                if (i)
                  return i.declare = !0, i;
                break;
              }
              case "global":
                if (this.match(5)) {
                  this.scope.enter(Ye), this.prodParam.enter(Ze);
                  let i = e;
                  return i.global = !0, i.id = s, i.body = this.tsParseModuleBlock(), this.scope.exit(), this.prodParam.exit(), this.finishNode(i, "TSModuleDeclaration");
                }
                break;
              default:
                return this.tsParseDeclaration(e, s.name, !1, r);
            }
          }
          tsParseDeclaration(e, s, r, i) {
            switch (s) {
              case "abstract":
                if (this.tsCheckLineTerminator(r) && (this.match(80) || te(this.state.type)))
                  return this.tsParseAbstractDeclaration(e, i);
                break;
              case "module":
                if (this.tsCheckLineTerminator(r)) {
                  if (this.match(131))
                    return this.tsParseAmbientExternalModuleDeclaration(e);
                  if (te(this.state.type))
                    return this.tsParseModuleOrNamespaceDeclaration(e);
                }
                break;
              case "namespace":
                if (this.tsCheckLineTerminator(r) && te(this.state.type))
                  return this.tsParseModuleOrNamespaceDeclaration(e);
                break;
              case "type":
                if (this.tsCheckLineTerminator(r) && te(this.state.type))
                  return this.tsParseTypeAliasDeclaration(e);
                break;
            }
          }
          tsCheckLineTerminator(e) {
            return e ? this.hasFollowingLineBreak() ? !1 : (this.next(), !0) : !this.isLineTerminator();
          }
          tsTryParseGenericAsyncArrowFunction(e) {
            if (!this.match(47))
              return;
            let s = this.state.maybeInArrowParameters;
            this.state.maybeInArrowParameters = !0;
            let r = this.tsTryParseAndCatch(() => {
              let i = this.startNodeAt(e);
              return i.typeParameters = this.tsParseTypeParameters(this.tsParseConstModifier), super.parseFunctionParams(i), i.returnType = this.tsTryParseTypeOrTypePredicateAnnotation(), this.expect(19), i;
            });
            if (this.state.maybeInArrowParameters = s, !!r)
              return super.parseArrowExpression(r, null, !0);
          }
          tsParseTypeArgumentsInExpression() {
            if (this.reScan_lt() === 47)
              return this.tsParseTypeArguments();
          }
          tsParseTypeArguments() {
            let e = this.startNode();
            return e.params = this.tsInType(() => this.tsInNoContext(() => (this.expect(47), this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this))))), e.params.length === 0 && this.raise(j.EmptyTypeArguments, { at: e }), this.expect(48), this.finishNode(e, "TSTypeParameterInstantiation");
          }
          tsIsDeclarationStart() {
            return ka(this.state.type);
          }
          isExportDefaultSpecifier() {
            return this.tsIsDeclarationStart() ? !1 : super.isExportDefaultSpecifier();
          }
          parseAssignableListItem(e, s) {
            let r = this.state.startLoc, i = {};
            this.tsParseModifiers({ allowedModifiers: ["public", "private", "protected", "override", "readonly"] }, i);
            let a = i.accessibility, n = i.override, o = i.readonly;
            !(e & 4) && (a || o || n) && this.raise(j.UnexpectedParameterModifier, { at: r });
            let h = this.parseMaybeDefault();
            this.parseAssignableListItemTypes(h, e);
            let l = this.parseMaybeDefault(h.loc.start, h);
            if (a || o || n) {
              let f = this.startNodeAt(r);
              return s.length && (f.decorators = s), a && (f.accessibility = a), o && (f.readonly = o), n && (f.override = n), l.type !== "Identifier" && l.type !== "AssignmentPattern" && this.raise(j.UnsupportedParameterPropertyKind, { at: f }), f.parameter = l, this.finishNode(f, "TSParameterProperty");
            }
            return s.length && (h.decorators = s), l;
          }
          isSimpleParameter(e) {
            return e.type === "TSParameterProperty" && super.isSimpleParameter(e.parameter) || super.isSimpleParameter(e);
          }
          tsDisallowOptionalPattern(e) {
            for (let s of e.params)
              s.type !== "Identifier" && s.optional && !this.state.isAmbientContext && this.raise(j.PatternIsOptional, { at: s });
          }
          setArrowFunctionParameters(e, s, r) {
            super.setArrowFunctionParameters(e, s, r), this.tsDisallowOptionalPattern(e);
          }
          parseFunctionBodyAndFinish(e, s) {
            let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            this.match(14) && (e.returnType = this.tsParseTypeOrTypePredicateAnnotation(14));
            let i = s === "FunctionDeclaration" ? "TSDeclareFunction" : s === "ClassMethod" || s === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
            return i && !this.match(5) && this.isLineTerminator() ? this.finishNode(e, i) : i === "TSDeclareFunction" && this.state.isAmbientContext && (this.raise(j.DeclareFunctionHasImplementation, { at: e }), e.declare) ? super.parseFunctionBodyAndFinish(e, i, r) : (this.tsDisallowOptionalPattern(e), super.parseFunctionBodyAndFinish(e, s, r));
          }
          registerFunctionStatementId(e) {
            !e.body && e.id ? this.checkIdentifier(e.id, Er) : super.registerFunctionStatementId(e);
          }
          tsCheckForInvalidTypeCasts(e) {
            e.forEach((s) => {
              (s == null ? void 0 : s.type) === "TSTypeCastExpression" && this.raise(j.UnexpectedTypeAnnotation, { at: s.typeAnnotation });
            });
          }
          toReferencedList(e, s) {
            return this.tsCheckForInvalidTypeCasts(e), e;
          }
          parseArrayLike(e, s, r, i) {
            let a = super.parseArrayLike(e, s, r, i);
            return a.type === "ArrayExpression" && this.tsCheckForInvalidTypeCasts(a.elements), a;
          }
          parseSubscript(e, s, r, i) {
            if (!this.hasPrecedingLineBreak() && this.match(35)) {
              this.state.canStartJSXElement = !1, this.next();
              let n = this.startNodeAt(s);
              return n.expression = e, this.finishNode(n, "TSNonNullExpression");
            }
            let a = !1;
            if (this.match(18) && this.lookaheadCharCode() === 60) {
              if (r)
                return i.stop = !0, e;
              i.optionalChainMember = a = !0, this.next();
            }
            if (this.match(47) || this.match(51)) {
              let n, o = this.tsTryParseAndCatch(() => {
                if (!r && this.atPossibleAsyncArrow(e)) {
                  let T = this.tsTryParseGenericAsyncArrowFunction(s);
                  if (T)
                    return T;
                }
                let h = this.tsParseTypeArgumentsInExpression();
                if (!h)
                  return;
                if (a && !this.match(10)) {
                  n = this.state.curPosition();
                  return;
                }
                if (Pt(this.state.type)) {
                  let T = super.parseTaggedTemplateExpression(e, s, i);
                  return T.typeParameters = h, T;
                }
                if (!r && this.eat(10)) {
                  let T = this.startNodeAt(s);
                  return T.callee = e, T.arguments = this.parseCallExpressionArguments(11, !1), this.tsCheckForInvalidTypeCasts(T.arguments), T.typeParameters = h, i.optionalChainMember && (T.optional = a), this.finishCallExpression(T, i.optionalChainMember);
                }
                let l = this.state.type;
                if (l === 48 || l === 52 || l !== 10 && rt(l) && !this.hasPrecedingLineBreak())
                  return;
                let f = this.startNodeAt(s);
                return f.expression = e, f.typeParameters = h, this.finishNode(f, "TSInstantiationExpression");
              });
              if (n && this.unexpected(n, 10), o)
                return o.type === "TSInstantiationExpression" && (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40) && this.raise(j.InvalidPropertyAccessAfterInstantiationExpression, { at: this.state.startLoc }), o;
            }
            return super.parseSubscript(e, s, r, i);
          }
          parseNewCallee(e) {
            var s;
            super.parseNewCallee(e);
            let { callee: r } = e;
            r.type === "TSInstantiationExpression" && !((s = r.extra) != null && s.parenthesized) && (e.typeParameters = r.typeParameters, e.callee = r.expression);
          }
          parseExprOp(e, s, r) {
            let i;
            if (gt(58) > r && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (i = this.isContextual(118)))) {
              let a = this.startNodeAt(s);
              return a.expression = e, a.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? (i && this.raise(p.UnexpectedKeyword, { at: this.state.startLoc, keyword: "const" }), this.tsParseTypeReference()) : this.tsParseType())), this.finishNode(a, i ? "TSSatisfiesExpression" : "TSAsExpression"), this.reScan_lt_gt(), this.parseExprOp(a, s, r);
            }
            return super.parseExprOp(e, s, r);
          }
          checkReservedWord(e, s, r, i) {
            this.state.isAmbientContext || super.checkReservedWord(e, s, r, i);
          }
          checkImportReflection(e) {
            super.checkImportReflection(e), e.module && e.importKind !== "value" && this.raise(j.ImportReflectionHasImportType, { at: e.specifiers[0].loc.start });
          }
          checkDuplicateExports() {
          }
          parseImport(e) {
            if (e.importKind = "value", te(this.state.type) || this.match(55) || this.match(5)) {
              let r = this.lookahead();
              if (this.isContextual(128) && r.type !== 12 && r.type !== 97 && r.type !== 29 && (e.importKind = "type", this.next(), r = this.lookahead()), te(this.state.type) && r.type === 29)
                return this.tsParseImportEqualsDeclaration(e);
            }
            let s = super.parseImport(e);
            return s.importKind === "type" && s.specifiers.length > 1 && s.specifiers[0].type === "ImportDefaultSpecifier" && this.raise(j.TypeImportCannotSpecifyDefaultAndNamed, { at: s }), s;
          }
          parseExport(e, s) {
            if (this.match(83))
              return this.next(), this.isContextual(128) && this.lookaheadCharCode() !== 61 ? (e.importKind = "type", this.next()) : e.importKind = "value", this.tsParseImportEqualsDeclaration(e, !0);
            if (this.eat(29)) {
              let r = e;
              return r.expression = super.parseExpression(), this.semicolon(), this.finishNode(r, "TSExportAssignment");
            } else if (this.eatContextual(93)) {
              let r = e;
              return this.expectContextual(126), r.id = this.parseIdentifier(), this.semicolon(), this.finishNode(r, "TSNamespaceExportDeclaration");
            } else {
              if (e.exportKind = "value", this.isContextual(128)) {
                let r = this.lookaheadCharCode();
                (r === 123 || r === 42) && (this.next(), e.exportKind = "type");
              }
              return super.parseExport(e, s);
            }
          }
          isAbstractClass() {
            return this.isContextual(122) && this.lookahead().type === 80;
          }
          parseExportDefaultExpression() {
            if (this.isAbstractClass()) {
              let e = this.startNode();
              return this.next(), e.abstract = !0, this.parseClass(e, !0, !0);
            }
            if (this.match(127)) {
              let e = this.tsParseInterfaceDeclaration(this.startNode());
              if (e)
                return e;
            }
            return super.parseExportDefaultExpression();
          }
          parseVarStatement(e, s) {
            let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, { isAmbientContext: i } = this.state, a = super.parseVarStatement(e, s, r || i);
            if (!i)
              return a;
            for (let { id: n, init: o } of a.declarations)
              o && (s !== "const" || n.typeAnnotation ? this.raise(j.InitializerNotAllowedInAmbientContext, { at: o }) : so(o, this.hasPlugin("estree")) || this.raise(j.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, { at: o }));
            return a;
          }
          parseStatementContent(e, s) {
            if (this.match(75) && this.isLookaheadContextual("enum")) {
              let r = this.startNode();
              return this.expect(75), this.tsParseEnumDeclaration(r, { const: !0 });
            }
            if (this.isContextual(124))
              return this.tsParseEnumDeclaration(this.startNode());
            if (this.isContextual(127)) {
              let r = this.tsParseInterfaceDeclaration(this.startNode());
              if (r)
                return r;
            }
            return super.parseStatementContent(e, s);
          }
          parseAccessModifier() {
            return this.tsParseModifier(["public", "protected", "private"]);
          }
          tsHasSomeModifiers(e, s) {
            return s.some((r) => zr(r) ? e.accessibility === r : !!e[r]);
          }
          tsIsStartOfStaticBlocks() {
            return this.isContextual(104) && this.lookaheadCharCode() === 123;
          }
          parseClassMember(e, s, r) {
            let i = ["declare", "private", "public", "protected", "override", "abstract", "readonly", "static"];
            this.tsParseModifiers({ allowedModifiers: i, disallowedModifiers: ["in", "out"], stopOnStartOfClassStaticBlock: !0, errorTemplate: j.InvalidModifierOnTypeParameterPositions }, s);
            let a = () => {
              this.tsIsStartOfStaticBlocks() ? (this.next(), this.next(), this.tsHasSomeModifiers(s, i) && this.raise(j.StaticBlockCannotHaveModifier, { at: this.state.curPosition() }), super.parseClassStaticBlock(e, s)) : this.parseClassMemberWithIsStatic(e, s, r, !!s.static);
            };
            s.declare ? this.tsInAmbientContext(a) : a();
          }
          parseClassMemberWithIsStatic(e, s, r, i) {
            let a = this.tsTryParseIndexSignature(s);
            if (a) {
              e.body.push(a), s.abstract && this.raise(j.IndexSignatureHasAbstract, { at: s }), s.accessibility && this.raise(j.IndexSignatureHasAccessibility, { at: s, modifier: s.accessibility }), s.declare && this.raise(j.IndexSignatureHasDeclare, { at: s }), s.override && this.raise(j.IndexSignatureHasOverride, { at: s });
              return;
            }
            !this.state.inAbstractClass && s.abstract && this.raise(j.NonAbstractClassHasAbstractMethod, { at: s }), s.override && (r.hadSuperClass || this.raise(j.OverrideNotInSubClass, { at: s })), super.parseClassMemberWithIsStatic(e, s, r, i);
          }
          parsePostMemberNameModifiers(e) {
            this.eat(17) && (e.optional = !0), e.readonly && this.match(10) && this.raise(j.ClassMethodHasReadonly, { at: e }), e.declare && this.match(10) && this.raise(j.ClassMethodHasDeclare, { at: e });
          }
          parseExpressionStatement(e, s, r) {
            return (s.type === "Identifier" ? this.tsParseExpressionStatement(e, s, r) : void 0) || super.parseExpressionStatement(e, s, r);
          }
          shouldParseExportDeclaration() {
            return this.tsIsDeclarationStart() ? !0 : super.shouldParseExportDeclaration();
          }
          parseConditional(e, s, r) {
            if (!this.state.maybeInArrowParameters || !this.match(17))
              return super.parseConditional(e, s, r);
            let i = this.tryParse(() => super.parseConditional(e, s));
            return i.node ? (i.error && (this.state = i.failState), i.node) : (i.error && super.setOptionalParametersError(r, i.error), e);
          }
          parseParenItem(e, s) {
            if (e = super.parseParenItem(e, s), this.eat(17) && (e.optional = !0, this.resetEndLocation(e)), this.match(14)) {
              let r = this.startNodeAt(s);
              return r.expression = e, r.typeAnnotation = this.tsParseTypeAnnotation(), this.finishNode(r, "TSTypeCastExpression");
            }
            return e;
          }
          parseExportDeclaration(e) {
            if (!this.state.isAmbientContext && this.isContextual(123))
              return this.tsInAmbientContext(() => this.parseExportDeclaration(e));
            let s = this.state.startLoc, r = this.eatContextual(123);
            if (r && (this.isContextual(123) || !this.shouldParseExportDeclaration()))
              throw this.raise(j.ExpectedAmbientAfterExportDeclare, { at: this.state.startLoc });
            let i = te(this.state.type) && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(e);
            return i ? ((i.type === "TSInterfaceDeclaration" || i.type === "TSTypeAliasDeclaration" || r) && (e.exportKind = "type"), r && (this.resetStartLocation(i, s), i.declare = !0), i) : null;
          }
          parseClassId(e, s, r, i) {
            if ((!s || r) && this.isContextual(111))
              return;
            super.parseClassId(e, s, r, e.declare ? Er : Ar);
            let a = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers);
            a && (e.typeParameters = a);
          }
          parseClassPropertyAnnotation(e) {
            e.optional || (this.eat(35) ? e.definite = !0 : this.eat(17) && (e.optional = !0));
            let s = this.tsTryParseTypeAnnotation();
            s && (e.typeAnnotation = s);
          }
          parseClassProperty(e) {
            if (this.parseClassPropertyAnnotation(e), this.state.isAmbientContext && !(e.readonly && !e.typeAnnotation) && this.match(29) && this.raise(j.DeclareClassFieldHasInitializer, { at: this.state.startLoc }), e.abstract && this.match(29)) {
              let { key: s } = e;
              this.raise(j.AbstractPropertyHasInitializer, { at: this.state.startLoc, propertyName: s.type === "Identifier" && !e.computed ? s.name : `[${this.input.slice(s.start, s.end)}]` });
            }
            return super.parseClassProperty(e);
          }
          parseClassPrivateProperty(e) {
            return e.abstract && this.raise(j.PrivateElementHasAbstract, { at: e }), e.accessibility && this.raise(j.PrivateElementHasAccessibility, { at: e, modifier: e.accessibility }), this.parseClassPropertyAnnotation(e), super.parseClassPrivateProperty(e);
          }
          parseClassAccessorProperty(e) {
            return this.parseClassPropertyAnnotation(e), e.optional && this.raise(j.AccessorCannotBeOptional, { at: e }), super.parseClassAccessorProperty(e);
          }
          pushClassMethod(e, s, r, i, a, n) {
            let o = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            o && a && this.raise(j.ConstructorHasTypeParameters, { at: o });
            let { declare: h = !1, kind: l } = s;
            h && (l === "get" || l === "set") && this.raise(j.DeclareAccessor, { at: s, kind: l }), o && (s.typeParameters = o), super.pushClassMethod(e, s, r, i, a, n);
          }
          pushClassPrivateMethod(e, s, r, i) {
            let a = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            a && (s.typeParameters = a), super.pushClassPrivateMethod(e, s, r, i);
          }
          declareClassPrivateMethodInScope(e, s) {
            e.type !== "TSDeclareMethod" && (e.type === "MethodDefinition" && !e.value.body || super.declareClassPrivateMethodInScope(e, s));
          }
          parseClassSuper(e) {
            super.parseClassSuper(e), e.superClass && (this.match(47) || this.match(51)) && (e.superTypeParameters = this.tsParseTypeArgumentsInExpression()), this.eatContextual(111) && (e.implements = this.tsParseHeritageClause("implements"));
          }
          parseObjPropValue(e, s, r, i, a, n, o) {
            let h = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            return h && (e.typeParameters = h), super.parseObjPropValue(e, s, r, i, a, n, o);
          }
          parseFunctionParams(e, s) {
            let r = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            r && (e.typeParameters = r), super.parseFunctionParams(e, s);
          }
          parseVarId(e, s) {
            super.parseVarId(e, s), e.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35) && (e.definite = !0);
            let r = this.tsTryParseTypeAnnotation();
            r && (e.id.typeAnnotation = r, this.resetEndLocation(e.id));
          }
          parseAsyncArrowFromCallExpression(e, s) {
            return this.match(14) && (e.returnType = this.tsParseTypeAnnotation()), super.parseAsyncArrowFromCallExpression(e, s);
          }
          parseMaybeAssign(e, s) {
            var r, i, a, n, o, h, l;
            let f, T, R;
            if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
              if (f = this.state.clone(), T = this.tryParse(() => super.parseMaybeAssign(e, s), f), !T.error)
                return T.node;
              let { context: re } = this.state, ce = re[re.length - 1];
              (ce === g.j_oTag || ce === g.j_expr) && re.pop();
            }
            if (!((r = T) != null && r.error) && !this.match(47))
              return super.parseMaybeAssign(e, s);
            (!f || f === this.state) && (f = this.state.clone());
            let B, se = this.tryParse((re) => {
              var ce, de;
              B = this.tsParseTypeParameters(this.tsParseConstModifier);
              let oe = super.parseMaybeAssign(e, s);
              return (oe.type !== "ArrowFunctionExpression" || (ce = oe.extra) != null && ce.parenthesized) && re(), ((de = B) == null ? void 0 : de.params.length) !== 0 && this.resetStartLocationFromNode(oe, B), oe.typeParameters = B, oe;
            }, f);
            if (!se.error && !se.aborted)
              return B && this.reportReservedArrowTypeParam(B), se.node;
            if (!T && (_r(!this.hasPlugin("jsx")), R = this.tryParse(() => super.parseMaybeAssign(e, s), f), !R.error))
              return R.node;
            if ((i = T) != null && i.node)
              return this.state = T.failState, T.node;
            if (se.node)
              return this.state = se.failState, B && this.reportReservedArrowTypeParam(B), se.node;
            if ((a = R) != null && a.node)
              return this.state = R.failState, R.node;
            throw (n = T) != null && n.thrown ? T.error : se.thrown ? se.error : (o = R) != null && o.thrown ? R.error : ((h = T) == null ? void 0 : h.error) || se.error || ((l = R) == null ? void 0 : l.error);
          }
          reportReservedArrowTypeParam(e) {
            var s;
            e.params.length === 1 && !e.params[0].constraint && !((s = e.extra) != null && s.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(j.ReservedArrowTypeParam, { at: e });
          }
          parseMaybeUnary(e, s) {
            return !this.hasPlugin("jsx") && this.match(47) ? this.tsParseTypeAssertion() : super.parseMaybeUnary(e, s);
          }
          parseArrow(e) {
            if (this.match(14)) {
              let s = this.tryParse((r) => {
                let i = this.tsParseTypeOrTypePredicateAnnotation(14);
                return (this.canInsertSemicolon() || !this.match(19)) && r(), i;
              });
              if (s.aborted)
                return;
              s.thrown || (s.error && (this.state = s.failState), e.returnType = s.node);
            }
            return super.parseArrow(e);
          }
          parseAssignableListItemTypes(e, s) {
            if (!(s & 2))
              return e;
            this.eat(17) && (e.optional = !0);
            let r = this.tsTryParseTypeAnnotation();
            return r && (e.typeAnnotation = r), this.resetEndLocation(e), e;
          }
          isAssignable(e, s) {
            switch (e.type) {
              case "TSTypeCastExpression":
                return this.isAssignable(e.expression, s);
              case "TSParameterProperty":
                return !0;
              default:
                return super.isAssignable(e, s);
            }
          }
          toAssignable(e) {
            let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            switch (e.type) {
              case "ParenthesizedExpression":
                this.toAssignableParenthesizedExpression(e, s);
                break;
              case "TSAsExpression":
              case "TSSatisfiesExpression":
              case "TSNonNullExpression":
              case "TSTypeAssertion":
                s ? this.expressionScope.recordArrowParameterBindingError(j.UnexpectedTypeCastInParameter, { at: e }) : this.raise(j.UnexpectedTypeCastInParameter, { at: e }), this.toAssignable(e.expression, s);
                break;
              case "AssignmentExpression":
                !s && e.left.type === "TSTypeCastExpression" && (e.left = this.typeCastToParameter(e.left));
              default:
                super.toAssignable(e, s);
            }
          }
          toAssignableParenthesizedExpression(e, s) {
            switch (e.expression.type) {
              case "TSAsExpression":
              case "TSSatisfiesExpression":
              case "TSNonNullExpression":
              case "TSTypeAssertion":
              case "ParenthesizedExpression":
                this.toAssignable(e.expression, s);
                break;
              default:
                super.toAssignable(e, s);
            }
          }
          checkToRestConversion(e, s) {
            switch (e.type) {
              case "TSAsExpression":
              case "TSSatisfiesExpression":
              case "TSTypeAssertion":
              case "TSNonNullExpression":
                this.checkToRestConversion(e.expression, !1);
                break;
              default:
                super.checkToRestConversion(e, s);
            }
          }
          isValidLVal(e, s, r) {
            return Gn({ TSTypeCastExpression: !0, TSParameterProperty: "parameter", TSNonNullExpression: "expression", TSAsExpression: (r !== Oe || !s) && ["expression", !0], TSSatisfiesExpression: (r !== Oe || !s) && ["expression", !0], TSTypeAssertion: (r !== Oe || !s) && ["expression", !0] }, e) || super.isValidLVal(e, s, r);
          }
          parseBindingAtom() {
            switch (this.state.type) {
              case 78:
                return this.parseIdentifier(!0);
              default:
                return super.parseBindingAtom();
            }
          }
          parseMaybeDecoratorArguments(e) {
            if (this.match(47) || this.match(51)) {
              let s = this.tsParseTypeArgumentsInExpression();
              if (this.match(10)) {
                let r = super.parseMaybeDecoratorArguments(e);
                return r.typeParameters = s, r;
              }
              this.unexpected(null, 10);
            }
            return super.parseMaybeDecoratorArguments(e);
          }
          checkCommaAfterRest(e) {
            return this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === e ? (this.next(), !1) : super.checkCommaAfterRest(e);
          }
          isClassMethod() {
            return this.match(47) || super.isClassMethod();
          }
          isClassProperty() {
            return this.match(35) || this.match(14) || super.isClassProperty();
          }
          parseMaybeDefault(e, s) {
            let r = super.parseMaybeDefault(e, s);
            return r.type === "AssignmentPattern" && r.typeAnnotation && r.right.start < r.typeAnnotation.start && this.raise(j.TypeAnnotationAfterAssign, { at: r.typeAnnotation }), r;
          }
          getTokenFromCode(e) {
            if (this.state.inType) {
              if (e === 62) {
                this.finishOp(48, 1);
                return;
              }
              if (e === 60) {
                this.finishOp(47, 1);
                return;
              }
            }
            super.getTokenFromCode(e);
          }
          reScan_lt_gt() {
            let { type: e } = this.state;
            e === 47 ? (this.state.pos -= 1, this.readToken_lt()) : e === 48 && (this.state.pos -= 1, this.readToken_gt());
          }
          reScan_lt() {
            let { type: e } = this.state;
            return e === 51 ? (this.state.pos -= 2, this.finishOp(47, 1), 47) : e;
          }
          toAssignableList(e, s, r) {
            for (let i = 0; i < e.length; i++) {
              let a = e[i];
              (a == null ? void 0 : a.type) === "TSTypeCastExpression" && (e[i] = this.typeCastToParameter(a));
            }
            super.toAssignableList(e, s, r);
          }
          typeCastToParameter(e) {
            return e.expression.typeAnnotation = e.typeAnnotation, this.resetEndLocation(e.expression, e.typeAnnotation.loc.end), e.expression;
          }
          shouldParseArrow(e) {
            return this.match(14) ? e.every((s) => this.isAssignable(s, !0)) : super.shouldParseArrow(e);
          }
          shouldParseAsyncArrow() {
            return this.match(14) || super.shouldParseAsyncArrow();
          }
          canHaveLeadingDecorator() {
            return super.canHaveLeadingDecorator() || this.isAbstractClass();
          }
          jsxParseOpeningElementAfterName(e) {
            if (this.match(47) || this.match(51)) {
              let s = this.tsTryParseAndCatch(() => this.tsParseTypeArgumentsInExpression());
              s && (e.typeParameters = s);
            }
            return super.jsxParseOpeningElementAfterName(e);
          }
          getGetterSetterExpectedParamCount(e) {
            let s = super.getGetterSetterExpectedParamCount(e), r = this.getObjectOrClassMethodParams(e)[0];
            return r && this.isThisParam(r) ? s + 1 : s;
          }
          parseCatchClauseParam() {
            let e = super.parseCatchClauseParam(), s = this.tsTryParseTypeAnnotation();
            return s && (e.typeAnnotation = s, this.resetEndLocation(e)), e;
          }
          tsInAmbientContext(e) {
            let s = this.state.isAmbientContext;
            this.state.isAmbientContext = !0;
            try {
              return e();
            } finally {
              this.state.isAmbientContext = s;
            }
          }
          parseClass(e, s, r) {
            let i = this.state.inAbstractClass;
            this.state.inAbstractClass = !!e.abstract;
            try {
              return super.parseClass(e, s, r);
            } finally {
              this.state.inAbstractClass = i;
            }
          }
          tsParseAbstractDeclaration(e, s) {
            if (this.match(80))
              return e.abstract = !0, this.maybeTakeDecorators(s, this.parseClass(e, !0, !1));
            if (this.isContextual(127)) {
              if (!this.hasFollowingLineBreak())
                return e.abstract = !0, this.raise(j.NonClassMethodPropertyHasAbstractModifer, { at: e }), this.tsParseInterfaceDeclaration(e);
            } else
              this.unexpected(null, 80);
          }
          parseMethod(e, s, r, i, a, n, o) {
            let h = super.parseMethod(e, s, r, i, a, n, o);
            if (h.abstract && (this.hasPlugin("estree") ? h.value.body : h.body)) {
              let { key: l } = h;
              this.raise(j.AbstractMethodHasImplementation, { at: h, methodName: l.type === "Identifier" && !h.computed ? l.name : `[${this.input.slice(l.start, l.end)}]` });
            }
            return h;
          }
          tsParseTypeParameterName() {
            return this.parseIdentifier().name;
          }
          shouldParseAsAmbientContext() {
            return !!this.getPluginOption("typescript", "dts");
          }
          parse() {
            return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = !0), super.parse();
          }
          getExpression() {
            return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = !0), super.getExpression();
          }
          parseExportSpecifier(e, s, r, i) {
            return !s && i ? (this.parseTypeOnlyImportExportSpecifier(e, !1, r), this.finishNode(e, "ExportSpecifier")) : (e.exportKind = "value", super.parseExportSpecifier(e, s, r, i));
          }
          parseImportSpecifier(e, s, r, i, a) {
            return !s && i ? (this.parseTypeOnlyImportExportSpecifier(e, !0, r), this.finishNode(e, "ImportSpecifier")) : (e.importKind = "value", super.parseImportSpecifier(e, s, r, i, r ? Cr : at));
          }
          parseTypeOnlyImportExportSpecifier(e, s, r) {
            let i = s ? "imported" : "local", a = s ? "local" : "exported", n = e[i], o, h = !1, l = !0, f = n.loc.start;
            if (this.isContextual(93)) {
              let R = this.parseIdentifier();
              if (this.isContextual(93)) {
                let B = this.parseIdentifier();
                Ae(this.state.type) ? (h = !0, n = R, o = s ? this.parseIdentifier() : this.parseModuleExportName(), l = !1) : (o = B, l = !1);
              } else
                Ae(this.state.type) ? (l = !1, o = s ? this.parseIdentifier() : this.parseModuleExportName()) : (h = !0, n = R);
            } else
              Ae(this.state.type) && (h = !0, s ? (n = this.parseIdentifier(!0), this.isContextual(93) || this.checkReservedWord(n.name, n.loc.start, !0, !0)) : n = this.parseModuleExportName());
            h && r && this.raise(s ? j.TypeModifierIsUsedInTypeImports : j.TypeModifierIsUsedInTypeExports, { at: f }), e[i] = n, e[a] = o;
            let T = s ? "importKind" : "exportKind";
            e[T] = h ? "type" : "value", l && this.eatContextual(93) && (e[a] = s ? this.parseIdentifier() : this.parseModuleExportName()), e[a] || (e[a] = Fe(e[i])), s && this.checkIdentifier(e[a], h ? Cr : at);
          }
        };
        function to(t) {
          if (t.type !== "MemberExpression")
            return !1;
          let { computed: e, property: s } = t;
          return e && s.type !== "StringLiteral" && (s.type !== "TemplateLiteral" || s.expressions.length > 0) ? !1 : $r(t.object);
        }
        function so(t, e) {
          var s;
          let { type: r } = t;
          if ((s = t.extra) != null && s.parenthesized)
            return !1;
          if (e) {
            if (r === "Literal") {
              let { value: i } = t;
              if (typeof i == "string" || typeof i == "boolean")
                return !0;
            }
          } else if (r === "StringLiteral" || r === "BooleanLiteral")
            return !0;
          return !!(Hr(t, e) || ro(t, e) || r === "TemplateLiteral" && t.expressions.length === 0 || to(t));
        }
        function Hr(t, e) {
          return e ? t.type === "Literal" && (typeof t.value == "number" || "bigint" in t) : t.type === "NumericLiteral" || t.type === "BigIntLiteral";
        }
        function ro(t, e) {
          if (t.type === "UnaryExpression") {
            let { operator: s, argument: r } = t;
            if (s === "-" && Hr(r, e))
              return !0;
          }
          return !1;
        }
        function $r(t) {
          return t.type === "Identifier" ? !0 : t.type !== "MemberExpression" || t.computed ? !1 : $r(t.object);
        }
        var Vr = Ne`placeholders`({ ClassNameIsRequired: "A class name is required.", UnexpectedSpace: "Unexpected space in placeholder." }), io = (t) => class extends t {
          parsePlaceholder(e) {
            if (this.match(142)) {
              let s = this.startNode();
              return this.next(), this.assertNoSpace(), s.name = super.parseIdentifier(!0), this.assertNoSpace(), this.expect(142), this.finishPlaceholder(s, e);
            }
          }
          finishPlaceholder(e, s) {
            let r = !!(e.expectedNode && e.type === "Placeholder");
            return e.expectedNode = s, r ? e : this.finishNode(e, "Placeholder");
          }
          getTokenFromCode(e) {
            e === 37 && this.input.charCodeAt(this.state.pos + 1) === 37 ? this.finishOp(142, 2) : super.getTokenFromCode(e);
          }
          parseExprAtom(e) {
            return this.parsePlaceholder("Expression") || super.parseExprAtom(e);
          }
          parseIdentifier(e) {
            return this.parsePlaceholder("Identifier") || super.parseIdentifier(e);
          }
          checkReservedWord(e, s, r, i) {
            e !== void 0 && super.checkReservedWord(e, s, r, i);
          }
          parseBindingAtom() {
            return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
          }
          isValidLVal(e, s, r) {
            return e === "Placeholder" || super.isValidLVal(e, s, r);
          }
          toAssignable(e, s) {
            e && e.type === "Placeholder" && e.expectedNode === "Expression" ? e.expectedNode = "Pattern" : super.toAssignable(e, s);
          }
          chStartsBindingIdentifier(e, s) {
            return !!(super.chStartsBindingIdentifier(e, s) || this.lookahead().type === 142);
          }
          verifyBreakContinue(e, s) {
            e.label && e.label.type === "Placeholder" || super.verifyBreakContinue(e, s);
          }
          parseExpressionStatement(e, s) {
            if (s.type !== "Placeholder" || s.extra && s.extra.parenthesized)
              return super.parseExpressionStatement(e, s);
            if (this.match(14)) {
              let r = e;
              return r.label = this.finishPlaceholder(s, "Identifier"), this.next(), r.body = super.parseStatementOrSloppyAnnexBFunctionDeclaration(), this.finishNode(r, "LabeledStatement");
            }
            return this.semicolon(), e.name = s.name, this.finishPlaceholder(e, "Statement");
          }
          parseBlock(e, s, r) {
            return this.parsePlaceholder("BlockStatement") || super.parseBlock(e, s, r);
          }
          parseFunctionId(e) {
            return this.parsePlaceholder("Identifier") || super.parseFunctionId(e);
          }
          parseClass(e, s, r) {
            let i = s ? "ClassDeclaration" : "ClassExpression";
            this.next();
            let a = this.state.strict, n = this.parsePlaceholder("Identifier");
            if (n)
              if (this.match(81) || this.match(142) || this.match(5))
                e.id = n;
              else {
                if (r || !s)
                  return e.id = null, e.body = this.finishPlaceholder(n, "ClassBody"), this.finishNode(e, i);
                throw this.raise(Vr.ClassNameIsRequired, { at: this.state.startLoc });
              }
            else
              this.parseClassId(e, s, r);
            return super.parseClassSuper(e), e.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!e.superClass, a), this.finishNode(e, i);
          }
          parseExport(e, s) {
            let r = this.parsePlaceholder("Identifier");
            if (!r)
              return super.parseExport(e, s);
            if (!this.isContextual(97) && !this.match(12))
              return e.specifiers = [], e.source = null, e.declaration = this.finishPlaceholder(r, "Declaration"), this.finishNode(e, "ExportNamedDeclaration");
            this.expectPlugin("exportDefaultFrom");
            let i = this.startNode();
            return i.exported = r, e.specifiers = [this.finishNode(i, "ExportDefaultSpecifier")], super.parseExport(e, s);
          }
          isExportDefaultSpecifier() {
            if (this.match(65)) {
              let e = this.nextTokenStart();
              if (this.isUnparsedContextual(e, "from") && this.input.startsWith(Be(142), this.nextTokenStartSince(e + 4)))
                return !0;
            }
            return super.isExportDefaultSpecifier();
          }
          maybeParseExportDefaultSpecifier(e) {
            return e.specifiers && e.specifiers.length > 0 ? !0 : super.maybeParseExportDefaultSpecifier(e);
          }
          checkExport(e) {
            let { specifiers: s } = e;
            s != null && s.length && (e.specifiers = s.filter((r) => r.exported.type === "Placeholder")), super.checkExport(e), e.specifiers = s;
          }
          parseImport(e) {
            let s = this.parsePlaceholder("Identifier");
            if (!s)
              return super.parseImport(e);
            if (e.specifiers = [], !this.isContextual(97) && !this.match(12))
              return e.source = this.finishPlaceholder(s, "StringLiteral"), this.semicolon(), this.finishNode(e, "ImportDeclaration");
            let r = this.startNodeAtNode(s);
            return r.local = s, e.specifiers.push(this.finishNode(r, "ImportDefaultSpecifier")), this.eat(12) && (this.maybeParseStarImportSpecifier(e) || this.parseNamedImportSpecifiers(e)), this.expectContextual(97), e.source = this.parseImportSource(), this.semicolon(), this.finishNode(e, "ImportDeclaration");
          }
          parseImportSource() {
            return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
          }
          assertNoSpace() {
            this.state.start > this.state.lastTokEndLoc.index && this.raise(Vr.UnexpectedSpace, { at: this.state.lastTokEndLoc });
          }
        }, ao = (t) => class extends t {
          parseV8Intrinsic() {
            if (this.match(54)) {
              let e = this.state.startLoc, s = this.startNode();
              if (this.next(), te(this.state.type)) {
                let r = this.parseIdentifierName(), i = this.createIdentifier(s, r);
                if (i.type = "V8IntrinsicIdentifier", this.match(10))
                  return i;
              }
              this.unexpected(e);
            }
          }
          parseExprAtom(e) {
            return this.parseV8Intrinsic() || super.parseExprAtom(e);
          }
        };
        function me(t, e) {
          let [s, r] = typeof e == "string" ? [e, {}] : e, i = Object.keys(r), a = i.length === 0;
          return t.some((n) => {
            if (typeof n == "string")
              return a && n === s;
            {
              let [o, h] = n;
              if (o !== s)
                return !1;
              for (let l of i)
                if (h[l] !== r[l])
                  return !1;
              return !0;
            }
          });
        }
        function Ve(t, e, s) {
          let r = t.find((i) => Array.isArray(i) ? i[0] === e : i === e);
          return r && Array.isArray(r) && r.length > 1 ? r[1][s] : null;
        }
        var qr = ["minimal", "fsharp", "hack", "smart"], Kr = ["^^", "@@", "^", "%", "#"], Wr = ["hash", "bar"];
        function no(t) {
          if (me(t, "decorators")) {
            if (me(t, "decorators-legacy"))
              throw new Error("Cannot use the decorators and decorators-legacy plugin together");
            let e = Ve(t, "decorators", "decoratorsBeforeExport");
            if (e != null && typeof e != "boolean")
              throw new Error("'decoratorsBeforeExport' must be a boolean, if specified.");
            let s = Ve(t, "decorators", "allowCallParenthesized");
            if (s != null && typeof s != "boolean")
              throw new Error("'allowCallParenthesized' must be a boolean.");
          }
          if (me(t, "flow") && me(t, "typescript"))
            throw new Error("Cannot combine flow and typescript plugins.");
          if (me(t, "placeholders") && me(t, "v8intrinsic"))
            throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
          if (me(t, "pipelineOperator")) {
            let e = Ve(t, "pipelineOperator", "proposal");
            if (!qr.includes(e)) {
              let r = qr.map((i) => `"${i}"`).join(", ");
              throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${r}.`);
            }
            let s = me(t, ["recordAndTuple", { syntaxType: "hash" }]);
            if (e === "hack") {
              if (me(t, "placeholders"))
                throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
              if (me(t, "v8intrinsic"))
                throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
              let r = Ve(t, "pipelineOperator", "topicToken");
              if (!Kr.includes(r)) {
                let i = Kr.map((a) => `"${a}"`).join(", ");
                throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${i}.`);
              }
              if (r === "#" && s)
                throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "hack", topicToken: "#" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
            } else if (e === "smart" && s)
              throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "smart" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
          }
          if (me(t, "moduleAttributes")) {
            if (me(t, "importAssertions"))
              throw new Error("Cannot combine importAssertions and moduleAttributes plugins.");
            if (Ve(t, "moduleAttributes", "version") !== "may-2020")
              throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
          }
          if (me(t, "recordAndTuple") && Ve(t, "recordAndTuple", "syntaxType") != null && !Wr.includes(Ve(t, "recordAndTuple", "syntaxType")))
            throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + Wr.map((e) => `'${e}'`).join(", "));
          if (me(t, "asyncDoExpressions") && !me(t, "doExpressions")) {
            let e = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
            throw e.missingPlugins = "doExpressions", e;
          }
        }
        var Jr = { estree: $a, jsx: qn, flow: $n, typescript: eo, v8intrinsic: ao, placeholders: io }, oo = Object.keys(Jr), ho = class extends Xn {
          checkProto(t, e, s, r) {
            if (t.type === "SpreadElement" || this.isObjectMethod(t) || t.computed || t.shorthand)
              return;
            let i = t.key;
            if ((i.type === "Identifier" ? i.name : i.value) === "__proto__") {
              if (e) {
                this.raise(p.RecordNoProto, { at: i });
                return;
              }
              s.used && (r ? r.doubleProtoLoc === null && (r.doubleProtoLoc = i.loc.start) : this.raise(p.DuplicateProto, { at: i })), s.used = !0;
            }
          }
          shouldExitDescending(t, e) {
            return t.type === "ArrowFunctionExpression" && t.start === e;
          }
          getExpression() {
            this.enterInitialScopes(), this.nextToken();
            let t = this.parseExpression();
            return this.match(137) || this.unexpected(), this.finalizeRemainingComments(), t.comments = this.state.comments, t.errors = this.state.errors, this.options.tokens && (t.tokens = this.tokens), t;
          }
          parseExpression(t, e) {
            return t ? this.disallowInAnd(() => this.parseExpressionBase(e)) : this.allowInAnd(() => this.parseExpressionBase(e));
          }
          parseExpressionBase(t) {
            let e = this.state.startLoc, s = this.parseMaybeAssign(t);
            if (this.match(12)) {
              let r = this.startNodeAt(e);
              for (r.expressions = [s]; this.eat(12); )
                r.expressions.push(this.parseMaybeAssign(t));
              return this.toReferencedList(r.expressions), this.finishNode(r, "SequenceExpression");
            }
            return s;
          }
          parseMaybeAssignDisallowIn(t, e) {
            return this.disallowInAnd(() => this.parseMaybeAssign(t, e));
          }
          parseMaybeAssignAllowIn(t, e) {
            return this.allowInAnd(() => this.parseMaybeAssign(t, e));
          }
          setOptionalParametersError(t, e) {
            var s;
            t.optionalParametersLoc = (s = e == null ? void 0 : e.loc) != null ? s : this.state.startLoc;
          }
          parseMaybeAssign(t, e) {
            let s = this.state.startLoc;
            if (this.isContextual(106) && this.prodParam.hasYield) {
              let n = this.parseYield();
              return e && (n = e.call(this, n, s)), n;
            }
            let r;
            t ? r = !1 : (t = new Mt(), r = !0);
            let { type: i } = this.state;
            (i === 10 || te(i)) && (this.state.potentialArrowAt = this.state.start);
            let a = this.parseMaybeConditional(t);
            if (e && (a = e.call(this, a, s)), Ca(this.state.type)) {
              let n = this.startNodeAt(s), o = this.state.value;
              if (n.operator = o, this.match(29)) {
                this.toAssignable(a, !0), n.left = a;
                let h = s.index;
                t.doubleProtoLoc != null && t.doubleProtoLoc.index >= h && (t.doubleProtoLoc = null), t.shorthandAssignLoc != null && t.shorthandAssignLoc.index >= h && (t.shorthandAssignLoc = null), t.privateKeyLoc != null && t.privateKeyLoc.index >= h && (this.checkDestructuringPrivate(t), t.privateKeyLoc = null);
              } else
                n.left = a;
              return this.next(), n.right = this.parseMaybeAssign(), this.checkLVal(a, { in: this.finishNode(n, "AssignmentExpression") }), n;
            } else
              r && this.checkExpressionErrors(t, !0);
            return a;
          }
          parseMaybeConditional(t) {
            let e = this.state.startLoc, s = this.state.potentialArrowAt, r = this.parseExprOps(t);
            return this.shouldExitDescending(r, s) ? r : this.parseConditional(r, e, t);
          }
          parseConditional(t, e, s) {
            if (this.eat(17)) {
              let r = this.startNodeAt(e);
              return r.test = t, r.consequent = this.parseMaybeAssignAllowIn(), this.expect(14), r.alternate = this.parseMaybeAssign(), this.finishNode(r, "ConditionalExpression");
            }
            return t;
          }
          parseMaybeUnaryOrPrivate(t) {
            return this.match(136) ? this.parsePrivateName() : this.parseMaybeUnary(t);
          }
          parseExprOps(t) {
            let e = this.state.startLoc, s = this.state.potentialArrowAt, r = this.parseMaybeUnaryOrPrivate(t);
            return this.shouldExitDescending(r, s) ? r : this.parseExprOp(r, e, -1);
          }
          parseExprOp(t, e, s) {
            if (this.isPrivateName(t)) {
              let i = this.getPrivateNameSV(t);
              (s >= gt(58) || !this.prodParam.hasIn || !this.match(58)) && this.raise(p.PrivateInExpectedIn, { at: t, identifierName: i }), this.classScope.usePrivateName(i, t.loc.start);
            }
            let r = this.state.type;
            if (Sa(r) && (this.prodParam.hasIn || !this.match(58))) {
              let i = gt(r);
              if (i > s) {
                if (r === 39) {
                  if (this.expectPlugin("pipelineOperator"), this.state.inFSharpPipelineDirectBody)
                    return t;
                  this.checkPipelineAtInfixOperator(t, e);
                }
                let a = this.startNodeAt(e);
                a.left = t, a.operator = this.state.value;
                let n = r === 41 || r === 42, o = r === 40;
                if (o && (i = gt(42)), this.next(), r === 39 && this.hasPlugin(["pipelineOperator", { proposal: "minimal" }]) && this.state.type === 96 && this.prodParam.hasAwait)
                  throw this.raise(p.UnexpectedAwaitAfterPipelineBody, { at: this.state.startLoc });
                a.right = this.parseExprOpRightExpr(r, i);
                let h = this.finishNode(a, n || o ? "LogicalExpression" : "BinaryExpression"), l = this.state.type;
                if (o && (l === 41 || l === 42) || n && l === 40)
                  throw this.raise(p.MixingCoalesceWithLogical, { at: this.state.startLoc });
                return this.parseExprOp(h, e, s);
              }
            }
            return t;
          }
          parseExprOpRightExpr(t, e) {
            let s = this.state.startLoc;
            switch (t) {
              case 39:
                switch (this.getPluginOption("pipelineOperator", "proposal")) {
                  case "hack":
                    return this.withTopicBindingContext(() => this.parseHackPipeBody());
                  case "smart":
                    return this.withTopicBindingContext(() => {
                      if (this.prodParam.hasYield && this.isContextual(106))
                        throw this.raise(p.PipeBodyIsTighter, { at: this.state.startLoc });
                      return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(t, e), s);
                    });
                  case "fsharp":
                    return this.withSoloAwaitPermittingContext(() => this.parseFSharpPipelineBody(e));
                }
              default:
                return this.parseExprOpBaseRightExpr(t, e);
            }
          }
          parseExprOpBaseRightExpr(t, e) {
            let s = this.state.startLoc;
            return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), s, Da(t) ? e - 1 : e);
          }
          parseHackPipeBody() {
            var t;
            let { startLoc: e } = this.state, s = this.parseMaybeAssign();
            return ja.has(s.type) && !((t = s.extra) != null && t.parenthesized) && this.raise(p.PipeUnparenthesizedBody, { at: e, type: s.type }), this.topicReferenceWasUsedInCurrentContext() || this.raise(p.PipeTopicUnused, { at: e }), s;
          }
          checkExponentialAfterUnary(t) {
            this.match(57) && this.raise(p.UnexpectedTokenUnaryExponentiation, { at: t.argument });
          }
          parseMaybeUnary(t, e) {
            let s = this.state.startLoc, r = this.isContextual(96);
            if (r && this.isAwaitAllowed()) {
              this.next();
              let o = this.parseAwait(s);
              return e || this.checkExponentialAfterUnary(o), o;
            }
            let i = this.match(34), a = this.startNode();
            if (Ia(this.state.type)) {
              a.operator = this.state.value, a.prefix = !0, this.match(72) && this.expectPlugin("throwExpressions");
              let o = this.match(89);
              if (this.next(), a.argument = this.parseMaybeUnary(null, !0), this.checkExpressionErrors(t, !0), this.state.strict && o) {
                let h = a.argument;
                h.type === "Identifier" ? this.raise(p.StrictDelete, { at: a }) : this.hasPropertyAsPrivateName(h) && this.raise(p.DeletePrivateField, { at: a });
              }
              if (!i)
                return e || this.checkExponentialAfterUnary(a), this.finishNode(a, "UnaryExpression");
            }
            let n = this.parseUpdate(a, i, t);
            if (r) {
              let { type: o } = this.state;
              if ((this.hasPlugin("v8intrinsic") ? rt(o) : rt(o) && !this.match(54)) && !this.isAmbiguousAwait())
                return this.raiseOverwrite(p.AwaitNotInAsyncContext, { at: s }), this.parseAwait(s);
            }
            return n;
          }
          parseUpdate(t, e, s) {
            if (e) {
              let a = t;
              return this.checkLVal(a.argument, { in: this.finishNode(a, "UpdateExpression") }), t;
            }
            let r = this.state.startLoc, i = this.parseExprSubscripts(s);
            if (this.checkExpressionErrors(s, !1))
              return i;
            for (; wa(this.state.type) && !this.canInsertSemicolon(); ) {
              let a = this.startNodeAt(r);
              a.operator = this.state.value, a.prefix = !1, a.argument = i, this.next(), this.checkLVal(i, { in: i = this.finishNode(a, "UpdateExpression") });
            }
            return i;
          }
          parseExprSubscripts(t) {
            let e = this.state.startLoc, s = this.state.potentialArrowAt, r = this.parseExprAtom(t);
            return this.shouldExitDescending(r, s) ? r : this.parseSubscripts(r, e);
          }
          parseSubscripts(t, e, s) {
            let r = { optionalChainMember: !1, maybeAsyncArrow: this.atPossibleAsyncArrow(t), stop: !1 };
            do
              t = this.parseSubscript(t, e, s, r), r.maybeAsyncArrow = !1;
            while (!r.stop);
            return t;
          }
          parseSubscript(t, e, s, r) {
            let { type: i } = this.state;
            if (!s && i === 15)
              return this.parseBind(t, e, s, r);
            if (Pt(i))
              return this.parseTaggedTemplateExpression(t, e, r);
            let a = !1;
            if (i === 18) {
              if (s && (this.raise(p.OptionalChainingNoNew, { at: this.state.startLoc }), this.lookaheadCharCode() === 40))
                return r.stop = !0, t;
              r.optionalChainMember = a = !0, this.next();
            }
            if (!s && this.match(10))
              return this.parseCoverCallAndAsyncArrowHead(t, e, r, a);
            {
              let n = this.eat(0);
              return n || a || this.eat(16) ? this.parseMember(t, e, r, n, a) : (r.stop = !0, t);
            }
          }
          parseMember(t, e, s, r, i) {
            let a = this.startNodeAt(e);
            return a.object = t, a.computed = r, r ? (a.property = this.parseExpression(), this.expect(3)) : this.match(136) ? (t.type === "Super" && this.raise(p.SuperPrivateField, { at: e }), this.classScope.usePrivateName(this.state.value, this.state.startLoc), a.property = this.parsePrivateName()) : a.property = this.parseIdentifier(!0), s.optionalChainMember ? (a.optional = i, this.finishNode(a, "OptionalMemberExpression")) : this.finishNode(a, "MemberExpression");
          }
          parseBind(t, e, s, r) {
            let i = this.startNodeAt(e);
            return i.object = t, this.next(), i.callee = this.parseNoCallExpr(), r.stop = !0, this.parseSubscripts(this.finishNode(i, "BindExpression"), e, s);
          }
          parseCoverCallAndAsyncArrowHead(t, e, s, r) {
            let i = this.state.maybeInArrowParameters, a = null;
            this.state.maybeInArrowParameters = !0, this.next();
            let n = this.startNodeAt(e);
            n.callee = t;
            let { maybeAsyncArrow: o, optionalChainMember: h } = s;
            o && (this.expressionScope.enter(Fn()), a = new Mt()), h && (n.optional = r), r ? n.arguments = this.parseCallExpressionArguments(11) : n.arguments = this.parseCallExpressionArguments(11, t.type === "Import", t.type !== "Super", n, a);
            let l = this.finishCallExpression(n, h);
            return o && this.shouldParseAsyncArrow() && !r ? (s.stop = !0, this.checkDestructuringPrivate(a), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), l = this.parseAsyncArrowFromCallExpression(this.startNodeAt(e), l)) : (o && (this.checkExpressionErrors(a, !0), this.expressionScope.exit()), this.toReferencedArguments(l)), this.state.maybeInArrowParameters = i, l;
          }
          toReferencedArguments(t, e) {
            this.toReferencedListDeep(t.arguments, e);
          }
          parseTaggedTemplateExpression(t, e, s) {
            let r = this.startNodeAt(e);
            return r.tag = t, r.quasi = this.parseTemplate(!0), s.optionalChainMember && this.raise(p.OptionalChainingNoTemplate, { at: e }), this.finishNode(r, "TaggedTemplateExpression");
          }
          atPossibleAsyncArrow(t) {
            return t.type === "Identifier" && t.name === "async" && this.state.lastTokEndLoc.index === t.end && !this.canInsertSemicolon() && t.end - t.start === 5 && t.start === this.state.potentialArrowAt;
          }
          finishCallExpression(t, e) {
            if (t.callee.type === "Import")
              if (t.arguments.length === 2 && (this.hasPlugin("moduleAttributes") || this.expectPlugin("importAssertions")), t.arguments.length === 0 || t.arguments.length > 2)
                this.raise(p.ImportCallArity, { at: t, maxArgumentCount: this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1 });
              else
                for (let s of t.arguments)
                  s.type === "SpreadElement" && this.raise(p.ImportCallSpreadArgument, { at: s });
            return this.finishNode(t, e ? "OptionalCallExpression" : "CallExpression");
          }
          parseCallExpressionArguments(t, e, s, r, i) {
            let a = [], n = !0, o = this.state.inFSharpPipelineDirectBody;
            for (this.state.inFSharpPipelineDirectBody = !1; !this.eat(t); ) {
              if (n)
                n = !1;
              else if (this.expect(12), this.match(t)) {
                e && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes") && this.raise(p.ImportCallArgumentTrailingComma, { at: this.state.lastTokStartLoc }), r && this.addTrailingCommaExtraToNode(r), this.next();
                break;
              }
              a.push(this.parseExprListItem(!1, i, s));
            }
            return this.state.inFSharpPipelineDirectBody = o, a;
          }
          shouldParseAsyncArrow() {
            return this.match(19) && !this.canInsertSemicolon();
          }
          parseAsyncArrowFromCallExpression(t, e) {
            var s;
            return this.resetPreviousNodeTrailingComments(e), this.expect(19), this.parseArrowExpression(t, e.arguments, !0, (s = e.extra) == null ? void 0 : s.trailingCommaLoc), e.innerComments && nt(t, e.innerComments), e.callee.trailingComments && nt(t, e.callee.trailingComments), t;
          }
          parseNoCallExpr() {
            let t = this.state.startLoc;
            return this.parseSubscripts(this.parseExprAtom(), t, !0);
          }
          parseExprAtom(t) {
            let e, s = null, { type: r } = this.state;
            switch (r) {
              case 79:
                return this.parseSuper();
              case 83:
                return e = this.startNode(), this.next(), this.match(16) ? this.parseImportMetaProperty(e) : (this.match(10) || this.raise(p.UnsupportedImport, { at: this.state.lastTokStartLoc }), this.finishNode(e, "Import"));
              case 78:
                return e = this.startNode(), this.next(), this.finishNode(e, "ThisExpression");
              case 90:
                return this.parseDo(this.startNode(), !1);
              case 56:
              case 31:
                return this.readRegexp(), this.parseRegExpLiteral(this.state.value);
              case 132:
                return this.parseNumericLiteral(this.state.value);
              case 133:
                return this.parseBigIntLiteral(this.state.value);
              case 134:
                return this.parseDecimalLiteral(this.state.value);
              case 131:
                return this.parseStringLiteral(this.state.value);
              case 84:
                return this.parseNullLiteral();
              case 85:
                return this.parseBooleanLiteral(!0);
              case 86:
                return this.parseBooleanLiteral(!1);
              case 10: {
                let i = this.state.potentialArrowAt === this.state.start;
                return this.parseParenAndDistinguishExpression(i);
              }
              case 2:
              case 1:
                return this.parseArrayLike(this.state.type === 2 ? 4 : 3, !1, !0);
              case 0:
                return this.parseArrayLike(3, !0, !1, t);
              case 6:
              case 7:
                return this.parseObjectLike(this.state.type === 6 ? 9 : 8, !1, !0);
              case 5:
                return this.parseObjectLike(8, !1, !1, t);
              case 68:
                return this.parseFunctionOrFunctionSent();
              case 26:
                s = this.parseDecorators();
              case 80:
                return this.parseClass(this.maybeTakeDecorators(s, this.startNode()), !1);
              case 77:
                return this.parseNewOrNewTarget();
              case 25:
              case 24:
                return this.parseTemplate(!1);
              case 15: {
                e = this.startNode(), this.next(), e.object = null;
                let i = e.callee = this.parseNoCallExpr();
                if (i.type === "MemberExpression")
                  return this.finishNode(e, "BindExpression");
                throw this.raise(p.UnsupportedBind, { at: i });
              }
              case 136:
                return this.raise(p.PrivateInExpectedIn, { at: this.state.startLoc, identifierName: this.state.value }), this.parsePrivateName();
              case 33:
                return this.parseTopicReferenceThenEqualsSign(54, "%");
              case 32:
                return this.parseTopicReferenceThenEqualsSign(44, "^");
              case 37:
              case 38:
                return this.parseTopicReference("hack");
              case 44:
              case 54:
              case 27: {
                let i = this.getPluginOption("pipelineOperator", "proposal");
                if (i)
                  return this.parseTopicReference(i);
                this.unexpected();
                break;
              }
              case 47: {
                let i = this.input.codePointAt(this.nextTokenStart());
                ke(i) || i === 62 ? this.expectOnePlugin(["jsx", "flow", "typescript"]) : this.unexpected();
                break;
              }
              default:
                if (te(r)) {
                  if (this.isContextual(125) && this.lookaheadCharCode() === 123 && !this.hasFollowingLineBreak())
                    return this.parseModuleExpression();
                  let i = this.state.potentialArrowAt === this.state.start, a = this.state.containsEsc, n = this.parseIdentifier();
                  if (!a && n.name === "async" && !this.canInsertSemicolon()) {
                    let { type: o } = this.state;
                    if (o === 68)
                      return this.resetPreviousNodeTrailingComments(n), this.next(), this.parseAsyncFunctionExpression(this.startNodeAtNode(n));
                    if (te(o))
                      return this.lookaheadCharCode() === 61 ? this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(n)) : n;
                    if (o === 90)
                      return this.resetPreviousNodeTrailingComments(n), this.parseDo(this.startNodeAtNode(n), !0);
                  }
                  return i && this.match(19) && !this.canInsertSemicolon() ? (this.next(), this.parseArrowExpression(this.startNodeAtNode(n), [n], !1)) : n;
                } else
                  this.unexpected();
            }
          }
          parseTopicReferenceThenEqualsSign(t, e) {
            let s = this.getPluginOption("pipelineOperator", "proposal");
            if (s)
              return this.state.type = t, this.state.value = e, this.state.pos--, this.state.end--, this.state.endLoc = fe(this.state.endLoc, -1), this.parseTopicReference(s);
            this.unexpected();
          }
          parseTopicReference(t) {
            let e = this.startNode(), s = this.state.startLoc, r = this.state.type;
            return this.next(), this.finishTopicReference(e, s, t, r);
          }
          finishTopicReference(t, e, s, r) {
            if (this.testTopicReferenceConfiguration(s, e, r)) {
              let i = s === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
              return this.topicReferenceIsAllowedInCurrentContext() || this.raise(s === "smart" ? p.PrimaryTopicNotAllowed : p.PipeTopicUnbound, { at: e }), this.registerTopicReference(), this.finishNode(t, i);
            } else
              throw this.raise(p.PipeTopicUnconfiguredToken, { at: e, token: Be(r) });
          }
          testTopicReferenceConfiguration(t, e, s) {
            switch (t) {
              case "hack":
                return this.hasPlugin(["pipelineOperator", { topicToken: Be(s) }]);
              case "smart":
                return s === 27;
              default:
                throw this.raise(p.PipeTopicRequiresHackPipes, { at: e });
            }
          }
          parseAsyncArrowUnaryFunction(t) {
            this.prodParam.enter(Bt(!0, this.prodParam.hasYield));
            let e = [this.parseIdentifier()];
            return this.prodParam.exit(), this.hasPrecedingLineBreak() && this.raise(p.LineTerminatorBeforeArrow, { at: this.state.curPosition() }), this.expect(19), this.parseArrowExpression(t, e, !0);
          }
          parseDo(t, e) {
            this.expectPlugin("doExpressions"), e && this.expectPlugin("asyncDoExpressions"), t.async = e, this.next();
            let s = this.state.labels;
            return this.state.labels = [], e ? (this.prodParam.enter(Lt), t.body = this.parseBlock(), this.prodParam.exit()) : t.body = this.parseBlock(), this.state.labels = s, this.finishNode(t, "DoExpression");
          }
          parseSuper() {
            let t = this.startNode();
            return this.next(), this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod ? this.raise(p.SuperNotAllowed, { at: t }) : !this.scope.allowSuper && !this.options.allowSuperOutsideMethod && this.raise(p.UnexpectedSuper, { at: t }), !this.match(10) && !this.match(0) && !this.match(16) && this.raise(p.UnsupportedSuper, { at: t }), this.finishNode(t, "Super");
          }
          parsePrivateName() {
            let t = this.startNode(), e = this.startNodeAt(fe(this.state.startLoc, 1)), s = this.state.value;
            return this.next(), t.id = this.createIdentifier(e, s), this.finishNode(t, "PrivateName");
          }
          parseFunctionOrFunctionSent() {
            let t = this.startNode();
            if (this.next(), this.prodParam.hasYield && this.match(16)) {
              let e = this.createIdentifier(this.startNodeAtNode(t), "function");
              return this.next(), this.match(102) ? this.expectPlugin("functionSent") : this.hasPlugin("functionSent") || this.unexpected(), this.parseMetaProperty(t, e, "sent");
            }
            return this.parseFunction(t);
          }
          parseMetaProperty(t, e, s) {
            t.meta = e;
            let r = this.state.containsEsc;
            return t.property = this.parseIdentifier(!0), (t.property.name !== s || r) && this.raise(p.UnsupportedMetaProperty, { at: t.property, target: e.name, onlyValidPropertyName: s }), this.finishNode(t, "MetaProperty");
          }
          parseImportMetaProperty(t) {
            let e = this.createIdentifier(this.startNodeAtNode(t), "import");
            return this.next(), this.isContextual(100) && (this.inModule || this.raise(p.ImportMetaOutsideModule, { at: e }), this.sawUnambiguousESM = !0), this.parseMetaProperty(t, e, "meta");
          }
          parseLiteralAtNode(t, e, s) {
            return this.addExtra(s, "rawValue", t), this.addExtra(s, "raw", this.input.slice(s.start, this.state.end)), s.value = t, this.next(), this.finishNode(s, e);
          }
          parseLiteral(t, e) {
            let s = this.startNode();
            return this.parseLiteralAtNode(t, e, s);
          }
          parseStringLiteral(t) {
            return this.parseLiteral(t, "StringLiteral");
          }
          parseNumericLiteral(t) {
            return this.parseLiteral(t, "NumericLiteral");
          }
          parseBigIntLiteral(t) {
            return this.parseLiteral(t, "BigIntLiteral");
          }
          parseDecimalLiteral(t) {
            return this.parseLiteral(t, "DecimalLiteral");
          }
          parseRegExpLiteral(t) {
            let e = this.parseLiteral(t.value, "RegExpLiteral");
            return e.pattern = t.pattern, e.flags = t.flags, e;
          }
          parseBooleanLiteral(t) {
            let e = this.startNode();
            return e.value = t, this.next(), this.finishNode(e, "BooleanLiteral");
          }
          parseNullLiteral() {
            let t = this.startNode();
            return this.next(), this.finishNode(t, "NullLiteral");
          }
          parseParenAndDistinguishExpression(t) {
            let e = this.state.startLoc, s;
            this.next(), this.expressionScope.enter(Dn());
            let r = this.state.maybeInArrowParameters, i = this.state.inFSharpPipelineDirectBody;
            this.state.maybeInArrowParameters = !0, this.state.inFSharpPipelineDirectBody = !1;
            let a = this.state.startLoc, n = [], o = new Mt(), h = !0, l, f;
            for (; !this.match(11); ) {
              if (h)
                h = !1;
              else if (this.expect(12, o.optionalParametersLoc === null ? null : o.optionalParametersLoc), this.match(11)) {
                f = this.state.startLoc;
                break;
              }
              if (this.match(21)) {
                let B = this.state.startLoc;
                if (l = this.state.startLoc, n.push(this.parseParenItem(this.parseRestBinding(), B)), !this.checkCommaAfterRest(41))
                  break;
              } else
                n.push(this.parseMaybeAssignAllowIn(o, this.parseParenItem));
            }
            let T = this.state.lastTokEndLoc;
            this.expect(11), this.state.maybeInArrowParameters = r, this.state.inFSharpPipelineDirectBody = i;
            let R = this.startNodeAt(e);
            return t && this.shouldParseArrow(n) && (R = this.parseArrow(R)) ? (this.checkDestructuringPrivate(o), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), this.parseArrowExpression(R, n, !1), R) : (this.expressionScope.exit(), n.length || this.unexpected(this.state.lastTokStartLoc), f && this.unexpected(f), l && this.unexpected(l), this.checkExpressionErrors(o, !0), this.toReferencedListDeep(n, !0), n.length > 1 ? (s = this.startNodeAt(a), s.expressions = n, this.finishNode(s, "SequenceExpression"), this.resetEndLocation(s, T)) : s = n[0], this.wrapParenthesis(e, s));
          }
          wrapParenthesis(t, e) {
            if (!this.options.createParenthesizedExpressions)
              return this.addExtra(e, "parenthesized", !0), this.addExtra(e, "parenStart", t.index), this.takeSurroundingComments(e, t.index, this.state.lastTokEndLoc.index), e;
            let s = this.startNodeAt(t);
            return s.expression = e, this.finishNode(s, "ParenthesizedExpression");
          }
          shouldParseArrow(t) {
            return !this.canInsertSemicolon();
          }
          parseArrow(t) {
            if (this.eat(19))
              return t;
          }
          parseParenItem(t, e) {
            return t;
          }
          parseNewOrNewTarget() {
            let t = this.startNode();
            if (this.next(), this.match(16)) {
              let e = this.createIdentifier(this.startNodeAtNode(t), "new");
              this.next();
              let s = this.parseMetaProperty(t, e, "target");
              return !this.scope.inNonArrowFunction && !this.scope.inClass && !this.options.allowNewTargetOutsideFunction && this.raise(p.UnexpectedNewTarget, { at: s }), s;
            }
            return this.parseNew(t);
          }
          parseNew(t) {
            if (this.parseNewCallee(t), this.eat(10)) {
              let e = this.parseExprList(11);
              this.toReferencedList(e), t.arguments = e;
            } else
              t.arguments = [];
            return this.finishNode(t, "NewExpression");
          }
          parseNewCallee(t) {
            t.callee = this.parseNoCallExpr(), t.callee.type === "Import" && this.raise(p.ImportCallNotNewExpression, { at: t.callee });
          }
          parseTemplateElement(t) {
            let { start: e, startLoc: s, end: r, value: i } = this.state, a = e + 1, n = this.startNodeAt(fe(s, 1));
            i === null && (t || this.raise(p.InvalidEscapeSequenceTemplate, { at: fe(this.state.firstInvalidTemplateEscapePos, 1) }));
            let o = this.match(24), h = o ? -1 : -2, l = r + h;
            n.value = { raw: this.input.slice(a, l).replace(/\r\n?/g, `
`), cooked: i === null ? null : i.slice(1, h) }, n.tail = o, this.next();
            let f = this.finishNode(n, "TemplateElement");
            return this.resetEndLocation(f, fe(this.state.lastTokEndLoc, h)), f;
          }
          parseTemplate(t) {
            let e = this.startNode();
            e.expressions = [];
            let s = this.parseTemplateElement(t);
            for (e.quasis = [s]; !s.tail; )
              e.expressions.push(this.parseTemplateSubstitution()), this.readTemplateContinuation(), e.quasis.push(s = this.parseTemplateElement(t));
            return this.finishNode(e, "TemplateLiteral");
          }
          parseTemplateSubstitution() {
            return this.parseExpression();
          }
          parseObjectLike(t, e, s, r) {
            s && this.expectPlugin("recordAndTuple");
            let i = this.state.inFSharpPipelineDirectBody;
            this.state.inFSharpPipelineDirectBody = !1;
            let a = /* @__PURE__ */ Object.create(null), n = !0, o = this.startNode();
            for (o.properties = [], this.next(); !this.match(t); ) {
              if (n)
                n = !1;
              else if (this.expect(12), this.match(t)) {
                this.addTrailingCommaExtraToNode(o);
                break;
              }
              let l;
              e ? l = this.parseBindingProperty() : (l = this.parsePropertyDefinition(r), this.checkProto(l, s, a, r)), s && !this.isObjectProperty(l) && l.type !== "SpreadElement" && this.raise(p.InvalidRecordProperty, { at: l }), l.shorthand && this.addExtra(l, "shorthand", !0), o.properties.push(l);
            }
            this.next(), this.state.inFSharpPipelineDirectBody = i;
            let h = "ObjectExpression";
            return e ? h = "ObjectPattern" : s && (h = "RecordExpression"), this.finishNode(o, h);
          }
          addTrailingCommaExtraToNode(t) {
            this.addExtra(t, "trailingComma", this.state.lastTokStart), this.addExtra(t, "trailingCommaLoc", this.state.lastTokStartLoc, !1);
          }
          maybeAsyncOrAccessorProp(t) {
            return !t.computed && t.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
          }
          parsePropertyDefinition(t) {
            let e = [];
            if (this.match(26))
              for (this.hasPlugin("decorators") && this.raise(p.UnsupportedPropertyDecorator, { at: this.state.startLoc }); this.match(26); )
                e.push(this.parseDecorator());
            let s = this.startNode(), r = !1, i = !1, a;
            if (this.match(21))
              return e.length && this.unexpected(), this.parseSpread();
            e.length && (s.decorators = e, e = []), s.method = !1, t && (a = this.state.startLoc);
            let n = this.eat(55);
            this.parsePropertyNamePrefixOperator(s);
            let o = this.state.containsEsc, h = this.parsePropertyName(s, t);
            if (!n && !o && this.maybeAsyncOrAccessorProp(s)) {
              let l = h.name;
              l === "async" && !this.hasPrecedingLineBreak() && (r = !0, this.resetPreviousNodeTrailingComments(h), n = this.eat(55), this.parsePropertyName(s)), (l === "get" || l === "set") && (i = !0, this.resetPreviousNodeTrailingComments(h), s.kind = l, this.match(55) && (n = !0, this.raise(p.AccessorIsGenerator, { at: this.state.curPosition(), kind: l }), this.next()), this.parsePropertyName(s));
            }
            return this.parseObjPropValue(s, a, n, r, !1, i, t);
          }
          getGetterSetterExpectedParamCount(t) {
            return t.kind === "get" ? 0 : 1;
          }
          getObjectOrClassMethodParams(t) {
            return t.params;
          }
          checkGetterSetterParams(t) {
            var e;
            let s = this.getGetterSetterExpectedParamCount(t), r = this.getObjectOrClassMethodParams(t);
            r.length !== s && this.raise(t.kind === "get" ? p.BadGetterArity : p.BadSetterArity, { at: t }), t.kind === "set" && ((e = r[r.length - 1]) == null ? void 0 : e.type) === "RestElement" && this.raise(p.BadSetterRestParameter, { at: t });
          }
          parseObjectMethod(t, e, s, r, i) {
            if (i) {
              let a = this.parseMethod(t, e, !1, !1, !1, "ObjectMethod");
              return this.checkGetterSetterParams(a), a;
            }
            if (s || e || this.match(10))
              return r && this.unexpected(), t.kind = "method", t.method = !0, this.parseMethod(t, e, s, !1, !1, "ObjectMethod");
          }
          parseObjectProperty(t, e, s, r) {
            if (t.shorthand = !1, this.eat(14))
              return t.value = s ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowIn(r), this.finishNode(t, "ObjectProperty");
            if (!t.computed && t.key.type === "Identifier") {
              if (this.checkReservedWord(t.key.name, t.key.loc.start, !0, !1), s)
                t.value = this.parseMaybeDefault(e, Fe(t.key));
              else if (this.match(29)) {
                let i = this.state.startLoc;
                r != null ? r.shorthandAssignLoc === null && (r.shorthandAssignLoc = i) : this.raise(p.InvalidCoverInitializedName, { at: i }), t.value = this.parseMaybeDefault(e, Fe(t.key));
              } else
                t.value = Fe(t.key);
              return t.shorthand = !0, this.finishNode(t, "ObjectProperty");
            }
          }
          parseObjPropValue(t, e, s, r, i, a, n) {
            let o = this.parseObjectMethod(t, s, r, i, a) || this.parseObjectProperty(t, e, i, n);
            return o || this.unexpected(), o;
          }
          parsePropertyName(t, e) {
            if (this.eat(0))
              t.computed = !0, t.key = this.parseMaybeAssignAllowIn(), this.expect(3);
            else {
              let { type: s, value: r } = this.state, i;
              if (Ae(s))
                i = this.parseIdentifier(!0);
              else
                switch (s) {
                  case 132:
                    i = this.parseNumericLiteral(r);
                    break;
                  case 131:
                    i = this.parseStringLiteral(r);
                    break;
                  case 133:
                    i = this.parseBigIntLiteral(r);
                    break;
                  case 134:
                    i = this.parseDecimalLiteral(r);
                    break;
                  case 136: {
                    let a = this.state.startLoc;
                    e != null ? e.privateKeyLoc === null && (e.privateKeyLoc = a) : this.raise(p.UnexpectedPrivateField, { at: a }), i = this.parsePrivateName();
                    break;
                  }
                  default:
                    this.unexpected();
                }
              t.key = i, s !== 136 && (t.computed = !1);
            }
            return t.key;
          }
          initFunction(t, e) {
            t.id = null, t.generator = !1, t.async = e;
          }
          parseMethod(t, e, s, r, i, a) {
            let n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !1;
            this.initFunction(t, s), t.generator = e, this.scope.enter(De | Tt | (n ? _e : 0) | (i ? xr : 0)), this.prodParam.enter(Bt(s, t.generator)), this.parseFunctionParams(t, r);
            let o = this.parseFunctionBodyAndFinish(t, a, !0);
            return this.prodParam.exit(), this.scope.exit(), o;
          }
          parseArrayLike(t, e, s, r) {
            s && this.expectPlugin("recordAndTuple");
            let i = this.state.inFSharpPipelineDirectBody;
            this.state.inFSharpPipelineDirectBody = !1;
            let a = this.startNode();
            return this.next(), a.elements = this.parseExprList(t, !s, r, a), this.state.inFSharpPipelineDirectBody = i, this.finishNode(a, s ? "TupleExpression" : "ArrayExpression");
          }
          parseArrowExpression(t, e, s, r) {
            this.scope.enter(De | ss);
            let i = Bt(s, !1);
            !this.match(5) && this.prodParam.hasIn && (i |= et), this.prodParam.enter(i), this.initFunction(t, s);
            let a = this.state.maybeInArrowParameters;
            return e && (this.state.maybeInArrowParameters = !0, this.setArrowFunctionParameters(t, e, r)), this.state.maybeInArrowParameters = !1, this.parseFunctionBody(t, !0), this.prodParam.exit(), this.scope.exit(), this.state.maybeInArrowParameters = a, this.finishNode(t, "ArrowFunctionExpression");
          }
          setArrowFunctionParameters(t, e, s) {
            this.toAssignableList(e, s, !1), t.params = e;
          }
          parseFunctionBodyAndFinish(t, e) {
            let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            return this.parseFunctionBody(t, !1, s), this.finishNode(t, e);
          }
          parseFunctionBody(t, e) {
            let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = e && !this.match(5);
            if (this.expressionScope.enter(Mr()), r)
              t.body = this.parseMaybeAssign(), this.checkParams(t, !1, e, !1);
            else {
              let i = this.state.strict, a = this.state.labels;
              this.state.labels = [], this.prodParam.enter(this.prodParam.currentFlags() | jr), t.body = this.parseBlock(!0, !1, (n) => {
                let o = !this.isSimpleParamList(t.params);
                n && o && this.raise(p.IllegalLanguageModeDirective, { at: (t.kind === "method" || t.kind === "constructor") && t.key ? t.key.loc.end : t });
                let h = !i && this.state.strict;
                this.checkParams(t, !this.state.strict && !e && !s && !o, e, h), this.state.strict && t.id && this.checkIdentifier(t.id, rn, h);
              }), this.prodParam.exit(), this.state.labels = a;
            }
            this.expressionScope.exit();
          }
          isSimpleParameter(t) {
            return t.type === "Identifier";
          }
          isSimpleParamList(t) {
            for (let e = 0, s = t.length; e < s; e++)
              if (!this.isSimpleParameter(t[e]))
                return !1;
            return !0;
          }
          checkParams(t, e, s) {
            let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, i = !e && /* @__PURE__ */ new Set(), a = { type: "FormalParameters" };
            for (let n of t.params)
              this.checkLVal(n, { in: a, binding: It, checkClashes: i, strictModeChanged: r });
          }
          parseExprList(t, e, s, r) {
            let i = [], a = !0;
            for (; !this.eat(t); ) {
              if (a)
                a = !1;
              else if (this.expect(12), this.match(t)) {
                r && this.addTrailingCommaExtraToNode(r), this.next();
                break;
              }
              i.push(this.parseExprListItem(e, s));
            }
            return i;
          }
          parseExprListItem(t, e, s) {
            let r;
            if (this.match(12))
              t || this.raise(p.UnexpectedToken, { at: this.state.curPosition(), unexpected: "," }), r = null;
            else if (this.match(21)) {
              let i = this.state.startLoc;
              r = this.parseParenItem(this.parseSpread(e), i);
            } else if (this.match(17)) {
              this.expectPlugin("partialApplication"), s || this.raise(p.UnexpectedArgumentPlaceholder, { at: this.state.startLoc });
              let i = this.startNode();
              this.next(), r = this.finishNode(i, "ArgumentPlaceholder");
            } else
              r = this.parseMaybeAssignAllowIn(e, this.parseParenItem);
            return r;
          }
          parseIdentifier(t) {
            let e = this.startNode(), s = this.parseIdentifierName(t);
            return this.createIdentifier(e, s);
          }
          createIdentifier(t, e) {
            return t.name = e, t.loc.identifierName = e, this.finishNode(t, "Identifier");
          }
          parseIdentifierName(t) {
            let e, { startLoc: s, type: r } = this.state;
            Ae(r) ? e = this.state.value : this.unexpected();
            let i = we(r);
            return t ? i && this.replaceToken(130) : this.checkReservedWord(e, s, i, !1), this.next(), e;
          }
          checkReservedWord(t, e, s, r) {
            if (!(t.length > 10 || !Za(t))) {
              if (s && Ga(t)) {
                this.raise(p.UnexpectedKeyword, { at: e, keyword: t });
                return;
              }
              if ((this.state.strict ? r ? fr : dr : cr)(t, this.inModule)) {
                this.raise(p.UnexpectedReservedWord, { at: e, reservedWord: t });
                return;
              } else if (t === "yield") {
                if (this.prodParam.hasYield) {
                  this.raise(p.YieldBindingIdentifier, { at: e });
                  return;
                }
              } else if (t === "await") {
                if (this.prodParam.hasAwait) {
                  this.raise(p.AwaitBindingIdentifier, { at: e });
                  return;
                }
                if (this.scope.inStaticBlock) {
                  this.raise(p.AwaitBindingIdentifierInStaticBlock, { at: e });
                  return;
                }
                this.expressionScope.recordAsyncArrowParametersError({ at: e });
              } else if (t === "arguments" && this.scope.inClassAndNotInNonArrowFunction) {
                this.raise(p.ArgumentsInClass, { at: e });
                return;
              }
            }
          }
          isAwaitAllowed() {
            return !!(this.prodParam.hasAwait || this.options.allowAwaitOutsideFunction && !this.scope.inFunction);
          }
          parseAwait(t) {
            let e = this.startNodeAt(t);
            return this.expressionScope.recordParameterInitializerError(p.AwaitExpressionFormalParameter, { at: e }), this.eat(55) && this.raise(p.ObsoleteAwaitStar, { at: e }), !this.scope.inFunction && !this.options.allowAwaitOutsideFunction && (this.isAmbiguousAwait() ? this.ambiguousScriptDifferentAst = !0 : this.sawUnambiguousESM = !0), this.state.soloAwait || (e.argument = this.parseMaybeUnary(null, !0)), this.finishNode(e, "AwaitExpression");
          }
          isAmbiguousAwait() {
            if (this.hasPrecedingLineBreak())
              return !0;
            let { type: t } = this.state;
            return t === 53 || t === 10 || t === 0 || Pt(t) || t === 101 && !this.state.containsEsc || t === 135 || t === 56 || this.hasPlugin("v8intrinsic") && t === 54;
          }
          parseYield() {
            let t = this.startNode();
            this.expressionScope.recordParameterInitializerError(p.YieldInParameter, { at: t }), this.next();
            let e = !1, s = null;
            if (!this.hasPrecedingLineBreak())
              switch (e = this.eat(55), this.state.type) {
                case 13:
                case 137:
                case 8:
                case 11:
                case 3:
                case 9:
                case 14:
                case 12:
                  if (!e)
                    break;
                default:
                  s = this.parseMaybeAssign();
              }
            return t.delegate = e, t.argument = s, this.finishNode(t, "YieldExpression");
          }
          checkPipelineAtInfixOperator(t, e) {
            this.hasPlugin(["pipelineOperator", { proposal: "smart" }]) && t.type === "SequenceExpression" && this.raise(p.PipelineHeadSequenceExpression, { at: e });
          }
          parseSmartPipelineBodyInStyle(t, e) {
            if (this.isSimpleReference(t)) {
              let s = this.startNodeAt(e);
              return s.callee = t, this.finishNode(s, "PipelineBareFunction");
            } else {
              let s = this.startNodeAt(e);
              return this.checkSmartPipeTopicBodyEarlyErrors(e), s.expression = t, this.finishNode(s, "PipelineTopicExpression");
            }
          }
          isSimpleReference(t) {
            switch (t.type) {
              case "MemberExpression":
                return !t.computed && this.isSimpleReference(t.object);
              case "Identifier":
                return !0;
              default:
                return !1;
            }
          }
          checkSmartPipeTopicBodyEarlyErrors(t) {
            if (this.match(19))
              throw this.raise(p.PipelineBodyNoArrow, { at: this.state.startLoc });
            this.topicReferenceWasUsedInCurrentContext() || this.raise(p.PipelineTopicUnused, { at: t });
          }
          withTopicBindingContext(t) {
            let e = this.state.topicContext;
            this.state.topicContext = { maxNumOfResolvableTopics: 1, maxTopicIndex: null };
            try {
              return t();
            } finally {
              this.state.topicContext = e;
            }
          }
          withSmartMixTopicForbiddingContext(t) {
            if (this.hasPlugin(["pipelineOperator", { proposal: "smart" }])) {
              let e = this.state.topicContext;
              this.state.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null };
              try {
                return t();
              } finally {
                this.state.topicContext = e;
              }
            } else
              return t();
          }
          withSoloAwaitPermittingContext(t) {
            let e = this.state.soloAwait;
            this.state.soloAwait = !0;
            try {
              return t();
            } finally {
              this.state.soloAwait = e;
            }
          }
          allowInAnd(t) {
            let e = this.prodParam.currentFlags();
            if (et & ~e) {
              this.prodParam.enter(e | et);
              try {
                return t();
              } finally {
                this.prodParam.exit();
              }
            }
            return t();
          }
          disallowInAnd(t) {
            let e = this.prodParam.currentFlags();
            if (et & e) {
              this.prodParam.enter(e & ~et);
              try {
                return t();
              } finally {
                this.prodParam.exit();
              }
            }
            return t();
          }
          registerTopicReference() {
            this.state.topicContext.maxTopicIndex = 0;
          }
          topicReferenceIsAllowedInCurrentContext() {
            return this.state.topicContext.maxNumOfResolvableTopics >= 1;
          }
          topicReferenceWasUsedInCurrentContext() {
            return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
          }
          parseFSharpPipelineBody(t) {
            let e = this.state.startLoc;
            this.state.potentialArrowAt = this.state.start;
            let s = this.state.inFSharpPipelineDirectBody;
            this.state.inFSharpPipelineDirectBody = !0;
            let r = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), e, t);
            return this.state.inFSharpPipelineDirectBody = s, r;
          }
          parseModuleExpression() {
            this.expectPlugin("moduleBlocks");
            let t = this.startNode();
            this.next(), this.match(5) || this.unexpected(null, 5);
            let e = this.startNodeAt(this.state.endLoc);
            this.next();
            let s = this.initializeScopes(!0);
            this.enterInitialScopes();
            try {
              t.body = this.parseProgram(e, 8, "module");
            } finally {
              s();
            }
            return this.finishNode(t, "ModuleExpression");
          }
          parsePropertyNamePrefixOperator(t) {
          }
        }, Ps = { kind: "loop" }, lo = { kind: "switch" }, po = /[\uD800-\uDFFF]/u, As = /in(?:stanceof)?/y;
        function uo(t, e) {
          for (let s = 0; s < t.length; s++) {
            let r = t[s], { type: i } = r;
            if (typeof i == "number") {
              {
                if (i === 136) {
                  let { loc: a, start: n, value: o, end: h } = r, l = n + 1, f = fe(a.start, 1);
                  t.splice(s, 1, new je({ type: Ie(27), value: "#", start: n, end: l, startLoc: a.start, endLoc: f }), new je({ type: Ie(130), value: o, start: l, end: h, startLoc: f, endLoc: a.end })), s++;
                  continue;
                }
                if (Pt(i)) {
                  let { loc: a, start: n, value: o, end: h } = r, l = n + 1, f = fe(a.start, 1), T;
                  e.charCodeAt(n) === 96 ? T = new je({ type: Ie(22), value: "`", start: n, end: l, startLoc: a.start, endLoc: f }) : T = new je({ type: Ie(8), value: "}", start: n, end: l, startLoc: a.start, endLoc: f });
                  let R, B, se, re;
                  i === 24 ? (B = h - 1, se = fe(a.end, -1), R = o === null ? null : o.slice(1, -1), re = new je({ type: Ie(22), value: "`", start: B, end: h, startLoc: se, endLoc: a.end })) : (B = h - 2, se = fe(a.end, -2), R = o === null ? null : o.slice(1, -2), re = new je({ type: Ie(23), value: "${", start: B, end: h, startLoc: se, endLoc: a.end })), t.splice(s, 1, T, new je({ type: Ie(20), value: R, start: l, end: B, startLoc: f, endLoc: se }), re), s += 2;
                  continue;
                }
              }
              r.type = Ie(i);
            }
          }
          return t;
        }
        var co = class extends ho {
          parseTopLevel(t, e) {
            return t.program = this.parseProgram(e), t.comments = this.state.comments, this.options.tokens && (t.tokens = uo(this.tokens, this.input)), this.finishNode(t, "File");
          }
          parseProgram(t) {
            let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 137, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.options.sourceType;
            if (t.sourceType = s, t.interpreter = this.parseInterpreterDirective(), this.parseBlockBody(t, !0, !0, e), this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0)
              for (let [i, a] of Array.from(this.scope.undefinedExports))
                this.raise(p.ModuleExportUndefined, { at: a, localName: i });
            let r;
            return e === 137 ? r = this.finishNode(t, "Program") : r = this.finishNodeAt(t, "Program", fe(this.state.startLoc, -1)), r;
          }
          stmtToDirective(t) {
            let e = t;
            e.type = "Directive", e.value = e.expression, delete e.expression;
            let s = e.value, r = s.value, i = this.input.slice(s.start, s.end), a = s.value = i.slice(1, -1);
            return this.addExtra(s, "raw", i), this.addExtra(s, "rawValue", a), this.addExtra(s, "expressionValue", r), s.type = "DirectiveLiteral", e;
          }
          parseInterpreterDirective() {
            if (!this.match(28))
              return null;
            let t = this.startNode();
            return t.value = this.state.value, this.next(), this.finishNode(t, "InterpreterDirective");
          }
          isLet() {
            return this.isContextual(99) ? this.hasFollowingBindingAtom() : !1;
          }
          chStartsBindingIdentifier(t, e) {
            if (ke(t)) {
              if (As.lastIndex = e, As.test(this.input)) {
                let s = this.codePointAtPos(As.lastIndex);
                if (!Je(s) && s !== 92)
                  return !1;
              }
              return !0;
            } else
              return t === 92;
          }
          chStartsBindingPattern(t) {
            return t === 91 || t === 123;
          }
          hasFollowingBindingAtom() {
            let t = this.nextTokenStart(), e = this.codePointAtPos(t);
            return this.chStartsBindingPattern(e) || this.chStartsBindingIdentifier(e, t);
          }
          hasFollowingBindingIdentifier() {
            let t = this.nextTokenStart(), e = this.codePointAtPos(t);
            return this.chStartsBindingIdentifier(e, t);
          }
          startsUsingForOf() {
            let t = this.lookahead();
            return t.type === 101 && !t.containsEsc ? !1 : (this.expectPlugin("explicitResourceManagement"), !0);
          }
          parseModuleItem() {
            return this.parseStatementLike(15);
          }
          parseStatementListItem() {
            return this.parseStatementLike(6 | (!this.options.annexB || this.state.strict ? 0 : 8));
          }
          parseStatementOrSloppyAnnexBFunctionDeclaration() {
            let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, e = 0;
            return this.options.annexB && !this.state.strict && (e |= 4, t && (e |= 8)), this.parseStatementLike(e);
          }
          parseStatement() {
            return this.parseStatementLike(0);
          }
          parseStatementLike(t) {
            let e = null;
            return this.match(26) && (e = this.parseDecorators(!0)), this.parseStatementContent(t, e);
          }
          parseStatementContent(t, e) {
            let s = this.state.type, r = this.startNode(), i = !!(t & 2), a = !!(t & 4), n = t & 1;
            switch (s) {
              case 60:
                return this.parseBreakContinueStatement(r, !0);
              case 63:
                return this.parseBreakContinueStatement(r, !1);
              case 64:
                return this.parseDebuggerStatement(r);
              case 90:
                return this.parseDoWhileStatement(r);
              case 91:
                return this.parseForStatement(r);
              case 68:
                if (this.lookaheadCharCode() === 46)
                  break;
                return a || this.raise(this.state.strict ? p.StrictFunction : this.options.annexB ? p.SloppyFunctionAnnexB : p.SloppyFunction, { at: this.state.startLoc }), this.parseFunctionStatement(r, !1, !i && a);
              case 80:
                return i || this.unexpected(), this.parseClass(this.maybeTakeDecorators(e, r), !0);
              case 69:
                return this.parseIfStatement(r);
              case 70:
                return this.parseReturnStatement(r);
              case 71:
                return this.parseSwitchStatement(r);
              case 72:
                return this.parseThrowStatement(r);
              case 73:
                return this.parseTryStatement(r);
              case 105:
                if (this.hasFollowingLineBreak() || this.state.containsEsc || !this.hasFollowingBindingIdentifier())
                  break;
                return this.expectPlugin("explicitResourceManagement"), !this.scope.inModule && this.scope.inTopLevel ? this.raise(p.UnexpectedUsingDeclaration, { at: this.state.startLoc }) : i || this.raise(p.UnexpectedLexicalDeclaration, { at: this.state.startLoc }), this.parseVarStatement(r, "using");
              case 99: {
                if (this.state.containsEsc)
                  break;
                let l = this.nextTokenStart(), f = this.codePointAtPos(l);
                if (f !== 91 && (!i && this.hasFollowingLineBreak() || !this.chStartsBindingIdentifier(f, l) && f !== 123))
                  break;
              }
              case 75:
                i || this.raise(p.UnexpectedLexicalDeclaration, { at: this.state.startLoc });
              case 74: {
                let l = this.state.value;
                return this.parseVarStatement(r, l);
              }
              case 92:
                return this.parseWhileStatement(r);
              case 76:
                return this.parseWithStatement(r);
              case 5:
                return this.parseBlock();
              case 13:
                return this.parseEmptyStatement(r);
              case 83: {
                let l = this.lookaheadCharCode();
                if (l === 40 || l === 46)
                  break;
              }
              case 82: {
                !this.options.allowImportExportEverywhere && !n && this.raise(p.UnexpectedImportExport, { at: this.state.startLoc }), this.next();
                let l;
                return s === 83 ? (l = this.parseImport(r), l.type === "ImportDeclaration" && (!l.importKind || l.importKind === "value") && (this.sawUnambiguousESM = !0)) : (l = this.parseExport(r, e), (l.type === "ExportNamedDeclaration" && (!l.exportKind || l.exportKind === "value") || l.type === "ExportAllDeclaration" && (!l.exportKind || l.exportKind === "value") || l.type === "ExportDefaultDeclaration") && (this.sawUnambiguousESM = !0)), this.assertModuleNodeAllowed(l), l;
              }
              default:
                if (this.isAsyncFunction())
                  return i || this.raise(p.AsyncFunctionInSingleStatementContext, { at: this.state.startLoc }), this.next(), this.parseFunctionStatement(r, !0, !i && a);
            }
            let o = this.state.value, h = this.parseExpression();
            return te(s) && h.type === "Identifier" && this.eat(14) ? this.parseLabeledStatement(r, o, h, t) : this.parseExpressionStatement(r, h, e);
          }
          assertModuleNodeAllowed(t) {
            !this.options.allowImportExportEverywhere && !this.inModule && this.raise(p.ImportOutsideModule, { at: t });
          }
          decoratorsEnabledBeforeExport() {
            return this.hasPlugin("decorators-legacy") ? !0 : this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") !== !1;
          }
          maybeTakeDecorators(t, e, s) {
            return t && (e.decorators && e.decorators.length > 0 ? (typeof this.getPluginOption("decorators", "decoratorsBeforeExport") != "boolean" && this.raise(p.DecoratorsBeforeAfterExport, { at: e.decorators[0] }), e.decorators.unshift(...t)) : e.decorators = t, this.resetStartLocationFromNode(e, t[0]), s && this.resetStartLocationFromNode(s, e)), e;
          }
          canHaveLeadingDecorator() {
            return this.match(80);
          }
          parseDecorators(t) {
            let e = [];
            do
              e.push(this.parseDecorator());
            while (this.match(26));
            if (this.match(82))
              t || this.unexpected(), this.decoratorsEnabledBeforeExport() || this.raise(p.DecoratorExportClass, { at: this.state.startLoc });
            else if (!this.canHaveLeadingDecorator())
              throw this.raise(p.UnexpectedLeadingDecorator, { at: this.state.startLoc });
            return e;
          }
          parseDecorator() {
            this.expectOnePlugin(["decorators", "decorators-legacy"]);
            let t = this.startNode();
            if (this.next(), this.hasPlugin("decorators")) {
              let e = this.state.startLoc, s;
              if (this.match(10)) {
                let r = this.state.startLoc;
                this.next(), s = this.parseExpression(), this.expect(11), s = this.wrapParenthesis(r, s);
                let i = this.state.startLoc;
                t.expression = this.parseMaybeDecoratorArguments(s), this.getPluginOption("decorators", "allowCallParenthesized") === !1 && t.expression !== s && this.raise(p.DecoratorArgumentsOutsideParentheses, { at: i });
              } else {
                for (s = this.parseIdentifier(!1); this.eat(16); ) {
                  let r = this.startNodeAt(e);
                  r.object = s, this.match(136) ? (this.classScope.usePrivateName(this.state.value, this.state.startLoc), r.property = this.parsePrivateName()) : r.property = this.parseIdentifier(!0), r.computed = !1, s = this.finishNode(r, "MemberExpression");
                }
                t.expression = this.parseMaybeDecoratorArguments(s);
              }
            } else
              t.expression = this.parseExprSubscripts();
            return this.finishNode(t, "Decorator");
          }
          parseMaybeDecoratorArguments(t) {
            if (this.eat(10)) {
              let e = this.startNodeAtNode(t);
              return e.callee = t, e.arguments = this.parseCallExpressionArguments(11, !1), this.toReferencedList(e.arguments), this.finishNode(e, "CallExpression");
            }
            return t;
          }
          parseBreakContinueStatement(t, e) {
            return this.next(), this.isLineTerminator() ? t.label = null : (t.label = this.parseIdentifier(), this.semicolon()), this.verifyBreakContinue(t, e), this.finishNode(t, e ? "BreakStatement" : "ContinueStatement");
          }
          verifyBreakContinue(t, e) {
            let s;
            for (s = 0; s < this.state.labels.length; ++s) {
              let r = this.state.labels[s];
              if ((t.label == null || r.name === t.label.name) && (r.kind != null && (e || r.kind === "loop") || t.label && e))
                break;
            }
            if (s === this.state.labels.length) {
              let r = e ? "BreakStatement" : "ContinueStatement";
              this.raise(p.IllegalBreakContinue, { at: t, type: r });
            }
          }
          parseDebuggerStatement(t) {
            return this.next(), this.semicolon(), this.finishNode(t, "DebuggerStatement");
          }
          parseHeaderExpression() {
            this.expect(10);
            let t = this.parseExpression();
            return this.expect(11), t;
          }
          parseDoWhileStatement(t) {
            return this.next(), this.state.labels.push(Ps), t.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.state.labels.pop(), this.expect(92), t.test = this.parseHeaderExpression(), this.eat(13), this.finishNode(t, "DoWhileStatement");
          }
          parseForStatement(t) {
            this.next(), this.state.labels.push(Ps);
            let e = null;
            if (this.isAwaitAllowed() && this.eatContextual(96) && (e = this.state.lastTokStartLoc), this.scope.enter(Xe), this.expect(10), this.match(13))
              return e !== null && this.unexpected(e), this.parseFor(t, null);
            let s = this.isContextual(99), r = this.isContextual(105) && !this.hasFollowingLineBreak(), i = s && this.hasFollowingBindingAtom() || r && this.hasFollowingBindingIdentifier() && this.startsUsingForOf();
            if (this.match(74) || this.match(75) || i) {
              let l = this.startNode(), f = this.state.value;
              this.next(), this.parseVar(l, !0, f);
              let T = this.finishNode(l, "VariableDeclaration"), R = this.match(58);
              return R && r && this.raise(p.ForInUsing, { at: T }), (R || this.isContextual(101)) && T.declarations.length === 1 ? this.parseForIn(t, T, e) : (e !== null && this.unexpected(e), this.parseFor(t, T));
            }
            let a = this.isContextual(95), n = new Mt(), o = this.parseExpression(!0, n), h = this.isContextual(101);
            if (h && (s && this.raise(p.ForOfLet, { at: o }), e === null && a && o.type === "Identifier" && this.raise(p.ForOfAsync, { at: o })), h || this.match(58)) {
              this.checkDestructuringPrivate(n), this.toAssignable(o, !0);
              let l = h ? "ForOfStatement" : "ForInStatement";
              return this.checkLVal(o, { in: { type: l } }), this.parseForIn(t, o, e);
            } else
              this.checkExpressionErrors(n, !0);
            return e !== null && this.unexpected(e), this.parseFor(t, o);
          }
          parseFunctionStatement(t, e, s) {
            return this.next(), this.parseFunction(t, 1 | (s ? 2 : 0) | (e ? 8 : 0));
          }
          parseIfStatement(t) {
            return this.next(), t.test = this.parseHeaderExpression(), t.consequent = this.parseStatementOrSloppyAnnexBFunctionDeclaration(), t.alternate = this.eat(66) ? this.parseStatementOrSloppyAnnexBFunctionDeclaration() : null, this.finishNode(t, "IfStatement");
          }
          parseReturnStatement(t) {
            return !this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction && this.raise(p.IllegalReturn, { at: this.state.startLoc }), this.next(), this.isLineTerminator() ? t.argument = null : (t.argument = this.parseExpression(), this.semicolon()), this.finishNode(t, "ReturnStatement");
          }
          parseSwitchStatement(t) {
            this.next(), t.discriminant = this.parseHeaderExpression();
            let e = t.cases = [];
            this.expect(5), this.state.labels.push(lo), this.scope.enter(Xe);
            let s;
            for (let r; !this.match(8); )
              if (this.match(61) || this.match(65)) {
                let i = this.match(61);
                s && this.finishNode(s, "SwitchCase"), e.push(s = this.startNode()), s.consequent = [], this.next(), i ? s.test = this.parseExpression() : (r && this.raise(p.MultipleDefaultsInSwitch, { at: this.state.lastTokStartLoc }), r = !0, s.test = null), this.expect(14);
              } else
                s ? s.consequent.push(this.parseStatementListItem()) : this.unexpected();
            return this.scope.exit(), s && this.finishNode(s, "SwitchCase"), this.next(), this.state.labels.pop(), this.finishNode(t, "SwitchStatement");
          }
          parseThrowStatement(t) {
            return this.next(), this.hasPrecedingLineBreak() && this.raise(p.NewlineAfterThrow, { at: this.state.lastTokEndLoc }), t.argument = this.parseExpression(), this.semicolon(), this.finishNode(t, "ThrowStatement");
          }
          parseCatchClauseParam() {
            let t = this.parseBindingAtom();
            return this.scope.enter(this.options.annexB && t.type === "Identifier" ? yr : 0), this.checkLVal(t, { in: { type: "CatchClause" }, binding: en }), t;
          }
          parseTryStatement(t) {
            if (this.next(), t.block = this.parseBlock(), t.handler = null, this.match(62)) {
              let e = this.startNode();
              this.next(), this.match(10) ? (this.expect(10), e.param = this.parseCatchClauseParam(), this.expect(11)) : (e.param = null, this.scope.enter(Xe)), e.body = this.withSmartMixTopicForbiddingContext(() => this.parseBlock(!1, !1)), this.scope.exit(), t.handler = this.finishNode(e, "CatchClause");
            }
            return t.finalizer = this.eat(67) ? this.parseBlock() : null, !t.handler && !t.finalizer && this.raise(p.NoCatchOrFinally, { at: t }), this.finishNode(t, "TryStatement");
          }
          parseVarStatement(t, e) {
            let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            return this.next(), this.parseVar(t, !1, e, s), this.semicolon(), this.finishNode(t, "VariableDeclaration");
          }
          parseWhileStatement(t) {
            return this.next(), t.test = this.parseHeaderExpression(), this.state.labels.push(Ps), t.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.state.labels.pop(), this.finishNode(t, "WhileStatement");
          }
          parseWithStatement(t) {
            return this.state.strict && this.raise(p.StrictWith, { at: this.state.startLoc }), this.next(), t.object = this.parseHeaderExpression(), t.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.finishNode(t, "WithStatement");
          }
          parseEmptyStatement(t) {
            return this.next(), this.finishNode(t, "EmptyStatement");
          }
          parseLabeledStatement(t, e, s, r) {
            for (let a of this.state.labels)
              a.name === e && this.raise(p.LabelRedeclaration, { at: s, labelName: e });
            let i = va(this.state.type) ? "loop" : this.match(71) ? "switch" : null;
            for (let a = this.state.labels.length - 1; a >= 0; a--) {
              let n = this.state.labels[a];
              if (n.statementStart === t.start)
                n.statementStart = this.state.start, n.kind = i;
              else
                break;
            }
            return this.state.labels.push({ name: e, kind: i, statementStart: this.state.start }), t.body = r & 8 ? this.parseStatementOrSloppyAnnexBFunctionDeclaration(!0) : this.parseStatement(), this.state.labels.pop(), t.label = s, this.finishNode(t, "LabeledStatement");
          }
          parseExpressionStatement(t, e, s) {
            return t.expression = e, this.semicolon(), this.finishNode(t, "ExpressionStatement");
          }
          parseBlock() {
            let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, s = arguments.length > 2 ? arguments[2] : void 0, r = this.startNode();
            return t && this.state.strictErrors.clear(), this.expect(5), e && this.scope.enter(Xe), this.parseBlockBody(r, t, !1, 8, s), e && this.scope.exit(), this.finishNode(r, "BlockStatement");
          }
          isValidDirective(t) {
            return t.type === "ExpressionStatement" && t.expression.type === "StringLiteral" && !t.expression.extra.parenthesized;
          }
          parseBlockBody(t, e, s, r, i) {
            let a = t.body = [], n = t.directives = [];
            this.parseBlockOrModuleBlockBody(a, e ? n : void 0, s, r, i);
          }
          parseBlockOrModuleBlockBody(t, e, s, r, i) {
            let a = this.state.strict, n = !1, o = !1;
            for (; !this.match(r); ) {
              let h = s ? this.parseModuleItem() : this.parseStatementListItem();
              if (e && !o) {
                if (this.isValidDirective(h)) {
                  let l = this.stmtToDirective(h);
                  e.push(l), !n && l.value.value === "use strict" && (n = !0, this.setStrict(!0));
                  continue;
                }
                o = !0, this.state.strictErrors.clear();
              }
              t.push(h);
            }
            i && i.call(this, n), a || this.setStrict(!1), this.next();
          }
          parseFor(t, e) {
            return t.init = e, this.semicolon(!1), t.test = this.match(13) ? null : this.parseExpression(), this.semicolon(!1), t.update = this.match(11) ? null : this.parseExpression(), this.expect(11), t.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(t, "ForStatement");
          }
          parseForIn(t, e, s) {
            let r = this.match(58);
            return this.next(), r ? s !== null && this.unexpected(s) : t.await = s !== null, e.type === "VariableDeclaration" && e.declarations[0].init != null && (!r || !this.options.annexB || this.state.strict || e.kind !== "var" || e.declarations[0].id.type !== "Identifier") && this.raise(p.ForInOfLoopInitializer, { at: e, type: r ? "ForInStatement" : "ForOfStatement" }), e.type === "AssignmentPattern" && this.raise(p.InvalidLhs, { at: e, ancestor: { type: "ForStatement" } }), t.left = e, t.right = r ? this.parseExpression() : this.parseMaybeAssignAllowIn(), this.expect(11), t.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(t, r ? "ForInStatement" : "ForOfStatement");
          }
          parseVar(t, e, s) {
            let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, i = t.declarations = [];
            for (t.kind = s; ; ) {
              let a = this.startNode();
              if (this.parseVarId(a, s), a.init = this.eat(29) ? e ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn() : null, a.init === null && !r && (a.id.type !== "Identifier" && !(e && (this.match(58) || this.isContextual(101))) ? this.raise(p.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "destructuring" }) : s === "const" && !(this.match(58) || this.isContextual(101)) && this.raise(p.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "const" })), i.push(this.finishNode(a, "VariableDeclarator")), !this.eat(12))
                break;
            }
            return t;
          }
          parseVarId(t, e) {
            e === "using" && !this.inModule && this.match(96) && this.raise(p.AwaitInUsingBinding, { at: this.state.startLoc });
            let s = this.parseBindingAtom();
            this.checkLVal(s, { in: { type: "VariableDeclarator" }, binding: e === "var" ? It : Qe }), t.id = s;
          }
          parseAsyncFunctionExpression(t) {
            return this.parseFunction(t, 8);
          }
          parseFunction(t) {
            let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s = e & 2, r = !!(e & 1), i = r && !(e & 4), a = !!(e & 8);
            this.initFunction(t, a), this.match(55) && (s && this.raise(p.GeneratorInSingleStatementContext, { at: this.state.startLoc }), this.next(), t.generator = !0), r && (t.id = this.parseFunctionId(i));
            let n = this.state.maybeInArrowParameters;
            return this.state.maybeInArrowParameters = !1, this.scope.enter(De), this.prodParam.enter(Bt(a, t.generator)), r || (t.id = this.parseFunctionId()), this.parseFunctionParams(t, !1), this.withSmartMixTopicForbiddingContext(() => {
              this.parseFunctionBodyAndFinish(t, r ? "FunctionDeclaration" : "FunctionExpression");
            }), this.prodParam.exit(), this.scope.exit(), r && !s && this.registerFunctionStatementId(t), this.state.maybeInArrowParameters = n, t;
          }
          parseFunctionId(t) {
            return t || te(this.state.type) ? this.parseIdentifier() : null;
          }
          parseFunctionParams(t, e) {
            this.expect(10), this.expressionScope.enter(kn()), t.params = this.parseBindingList(11, 41, 2 | (e ? 4 : 0)), this.expressionScope.exit();
          }
          registerFunctionStatementId(t) {
            t.id && this.scope.declareName(t.id.name, !this.options.annexB || this.state.strict || t.generator || t.async ? this.scope.treatFunctionsAsVar ? It : Qe : br, t.id.loc.start);
          }
          parseClass(t, e, s) {
            this.next();
            let r = this.state.strict;
            return this.state.strict = !0, this.parseClassId(t, e, s), this.parseClassSuper(t), t.body = this.parseClassBody(!!t.superClass, r), this.finishNode(t, e ? "ClassDeclaration" : "ClassExpression");
          }
          isClassProperty() {
            return this.match(29) || this.match(13) || this.match(8);
          }
          isClassMethod() {
            return this.match(10);
          }
          isNonstaticConstructor(t) {
            return !t.computed && !t.static && (t.key.name === "constructor" || t.key.value === "constructor");
          }
          parseClassBody(t, e) {
            this.classScope.enter();
            let s = { hadConstructor: !1, hadSuperClass: t }, r = [], i = this.startNode();
            if (i.body = [], this.expect(5), this.withSmartMixTopicForbiddingContext(() => {
              for (; !this.match(8); ) {
                if (this.eat(13)) {
                  if (r.length > 0)
                    throw this.raise(p.DecoratorSemicolon, { at: this.state.lastTokEndLoc });
                  continue;
                }
                if (this.match(26)) {
                  r.push(this.parseDecorator());
                  continue;
                }
                let a = this.startNode();
                r.length && (a.decorators = r, this.resetStartLocationFromNode(a, r[0]), r = []), this.parseClassMember(i, a, s), a.kind === "constructor" && a.decorators && a.decorators.length > 0 && this.raise(p.DecoratorConstructor, { at: a });
              }
            }), this.state.strict = e, this.next(), r.length)
              throw this.raise(p.TrailingDecorator, { at: this.state.startLoc });
            return this.classScope.exit(), this.finishNode(i, "ClassBody");
          }
          parseClassMemberFromModifier(t, e) {
            let s = this.parseIdentifier(!0);
            if (this.isClassMethod()) {
              let r = e;
              return r.kind = "method", r.computed = !1, r.key = s, r.static = !1, this.pushClassMethod(t, r, !1, !1, !1, !1), !0;
            } else if (this.isClassProperty()) {
              let r = e;
              return r.computed = !1, r.key = s, r.static = !1, t.body.push(this.parseClassProperty(r)), !0;
            }
            return this.resetPreviousNodeTrailingComments(s), !1;
          }
          parseClassMember(t, e, s) {
            let r = this.isContextual(104);
            if (r) {
              if (this.parseClassMemberFromModifier(t, e))
                return;
              if (this.eat(5)) {
                this.parseClassStaticBlock(t, e);
                return;
              }
            }
            this.parseClassMemberWithIsStatic(t, e, s, r);
          }
          parseClassMemberWithIsStatic(t, e, s, r) {
            let i = e, a = e, n = e, o = e, h = e, l = i, f = i;
            if (e.static = r, this.parsePropertyNamePrefixOperator(e), this.eat(55)) {
              l.kind = "method";
              let re = this.match(136);
              if (this.parseClassElementName(l), re) {
                this.pushClassPrivateMethod(t, a, !0, !1);
                return;
              }
              this.isNonstaticConstructor(i) && this.raise(p.ConstructorIsGenerator, { at: i.key }), this.pushClassMethod(t, i, !0, !1, !1, !1);
              return;
            }
            let T = te(this.state.type) && !this.state.containsEsc, R = this.match(136), B = this.parseClassElementName(e), se = this.state.startLoc;
            if (this.parsePostMemberNameModifiers(f), this.isClassMethod()) {
              if (l.kind = "method", R) {
                this.pushClassPrivateMethod(t, a, !1, !1);
                return;
              }
              let re = this.isNonstaticConstructor(i), ce = !1;
              re && (i.kind = "constructor", s.hadConstructor && !this.hasPlugin("typescript") && this.raise(p.DuplicateConstructor, { at: B }), re && this.hasPlugin("typescript") && e.override && this.raise(p.OverrideOnConstructor, { at: B }), s.hadConstructor = !0, ce = s.hadSuperClass), this.pushClassMethod(t, i, !1, !1, re, ce);
            } else if (this.isClassProperty())
              R ? this.pushClassPrivateProperty(t, o) : this.pushClassProperty(t, n);
            else if (T && B.name === "async" && !this.isLineTerminator()) {
              this.resetPreviousNodeTrailingComments(B);
              let re = this.eat(55);
              f.optional && this.unexpected(se), l.kind = "method";
              let ce = this.match(136);
              this.parseClassElementName(l), this.parsePostMemberNameModifiers(f), ce ? this.pushClassPrivateMethod(t, a, re, !0) : (this.isNonstaticConstructor(i) && this.raise(p.ConstructorIsAsync, { at: i.key }), this.pushClassMethod(t, i, re, !0, !1, !1));
            } else if (T && (B.name === "get" || B.name === "set") && !(this.match(55) && this.isLineTerminator())) {
              this.resetPreviousNodeTrailingComments(B), l.kind = B.name;
              let re = this.match(136);
              this.parseClassElementName(i), re ? this.pushClassPrivateMethod(t, a, !1, !1) : (this.isNonstaticConstructor(i) && this.raise(p.ConstructorIsAccessor, { at: i.key }), this.pushClassMethod(t, i, !1, !1, !1, !1)), this.checkGetterSetterParams(i);
            } else if (T && B.name === "accessor" && !this.isLineTerminator()) {
              this.expectPlugin("decoratorAutoAccessors"), this.resetPreviousNodeTrailingComments(B);
              let re = this.match(136);
              this.parseClassElementName(n), this.pushClassAccessorProperty(t, h, re);
            } else
              this.isLineTerminator() ? R ? this.pushClassPrivateProperty(t, o) : this.pushClassProperty(t, n) : this.unexpected();
          }
          parseClassElementName(t) {
            let { type: e, value: s } = this.state;
            if ((e === 130 || e === 131) && t.static && s === "prototype" && this.raise(p.StaticPrototype, { at: this.state.startLoc }), e === 136) {
              s === "constructor" && this.raise(p.ConstructorClassPrivateField, { at: this.state.startLoc });
              let r = this.parsePrivateName();
              return t.key = r, r;
            }
            return this.parsePropertyName(t);
          }
          parseClassStaticBlock(t, e) {
            var s;
            this.scope.enter(_e | Et | Tt);
            let r = this.state.labels;
            this.state.labels = [], this.prodParam.enter(Ze);
            let i = e.body = [];
            this.parseBlockOrModuleBlockBody(i, void 0, !1, 8), this.prodParam.exit(), this.scope.exit(), this.state.labels = r, t.body.push(this.finishNode(e, "StaticBlock")), (s = e.decorators) != null && s.length && this.raise(p.DecoratorStaticBlock, { at: e });
          }
          pushClassProperty(t, e) {
            !e.computed && (e.key.name === "constructor" || e.key.value === "constructor") && this.raise(p.ConstructorClassField, { at: e.key }), t.body.push(this.parseClassProperty(e));
          }
          pushClassPrivateProperty(t, e) {
            let s = this.parseClassPrivateProperty(e);
            t.body.push(s), this.classScope.declarePrivateName(this.getPrivateNameSV(s.key), ps, s.key.loc.start);
          }
          pushClassAccessorProperty(t, e, s) {
            if (!s && !e.computed) {
              let i = e.key;
              (i.name === "constructor" || i.value === "constructor") && this.raise(p.ConstructorClassField, { at: i });
            }
            let r = this.parseClassAccessorProperty(e);
            t.body.push(r), s && this.classScope.declarePrivateName(this.getPrivateNameSV(r.key), ps, r.key.loc.start);
          }
          pushClassMethod(t, e, s, r, i, a) {
            t.body.push(this.parseMethod(e, s, r, i, a, "ClassMethod", !0));
          }
          pushClassPrivateMethod(t, e, s, r) {
            let i = this.parseMethod(e, s, r, !1, !1, "ClassPrivateMethod", !0);
            t.body.push(i);
            let a = i.kind === "get" ? i.static ? hn : pn : i.kind === "set" ? i.static ? ln : un : ps;
            this.declareClassPrivateMethodInScope(i, a);
          }
          declareClassPrivateMethodInScope(t, e) {
            this.classScope.declarePrivateName(this.getPrivateNameSV(t.key), e, t.key.loc.start);
          }
          parsePostMemberNameModifiers(t) {
          }
          parseClassPrivateProperty(t) {
            return this.parseInitializer(t), this.semicolon(), this.finishNode(t, "ClassPrivateProperty");
          }
          parseClassProperty(t) {
            return this.parseInitializer(t), this.semicolon(), this.finishNode(t, "ClassProperty");
          }
          parseClassAccessorProperty(t) {
            return this.parseInitializer(t), this.semicolon(), this.finishNode(t, "ClassAccessorProperty");
          }
          parseInitializer(t) {
            this.scope.enter(_e | Tt), this.expressionScope.enter(Mr()), this.prodParam.enter(Ze), t.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null, this.expressionScope.exit(), this.prodParam.exit(), this.scope.exit();
          }
          parseClassId(t, e, s) {
            let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Ar;
            if (te(this.state.type))
              t.id = this.parseIdentifier(), e && this.declareNameFromIdentifier(t.id, r);
            else if (s || !e)
              t.id = null;
            else
              throw this.raise(p.MissingClassName, { at: this.state.startLoc });
          }
          parseClassSuper(t) {
            t.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
          }
          parseExport(t, e) {
            let s = this.maybeParseExportDefaultSpecifier(t), r = !s || this.eat(12), i = r && this.eatExportStar(t), a = i && this.maybeParseExportNamespaceSpecifier(t), n = r && (!a || this.eat(12)), o = s || i;
            if (i && !a) {
              if (s && this.unexpected(), e)
                throw this.raise(p.UnsupportedDecoratorExport, { at: t });
              return this.parseExportFrom(t, !0), this.finishNode(t, "ExportAllDeclaration");
            }
            let h = this.maybeParseExportNamedSpecifiers(t);
            s && r && !i && !h && this.unexpected(null, 5), a && n && this.unexpected(null, 97);
            let l;
            if (o || h) {
              if (l = !1, e)
                throw this.raise(p.UnsupportedDecoratorExport, { at: t });
              this.parseExportFrom(t, o);
            } else
              l = this.maybeParseExportDeclaration(t);
            if (o || h || l) {
              var f;
              let T = t;
              if (this.checkExport(T, !0, !1, !!T.source), ((f = T.declaration) == null ? void 0 : f.type) === "ClassDeclaration")
                this.maybeTakeDecorators(e, T.declaration, T);
              else if (e)
                throw this.raise(p.UnsupportedDecoratorExport, { at: t });
              return this.finishNode(T, "ExportNamedDeclaration");
            }
            if (this.eat(65)) {
              let T = t, R = this.parseExportDefaultExpression();
              if (T.declaration = R, R.type === "ClassDeclaration")
                this.maybeTakeDecorators(e, R, T);
              else if (e)
                throw this.raise(p.UnsupportedDecoratorExport, { at: t });
              return this.checkExport(T, !0, !0), this.finishNode(T, "ExportDefaultDeclaration");
            }
            this.unexpected(null, 5);
          }
          eatExportStar(t) {
            return this.eat(55);
          }
          maybeParseExportDefaultSpecifier(t) {
            if (this.isExportDefaultSpecifier()) {
              this.expectPlugin("exportDefaultFrom");
              let e = this.startNode();
              return e.exported = this.parseIdentifier(!0), t.specifiers = [this.finishNode(e, "ExportDefaultSpecifier")], !0;
            }
            return !1;
          }
          maybeParseExportNamespaceSpecifier(t) {
            if (this.isContextual(93)) {
              t.specifiers || (t.specifiers = []);
              let e = this.startNodeAt(this.state.lastTokStartLoc);
              return this.next(), e.exported = this.parseModuleExportName(), t.specifiers.push(this.finishNode(e, "ExportNamespaceSpecifier")), !0;
            }
            return !1;
          }
          maybeParseExportNamedSpecifiers(t) {
            if (this.match(5)) {
              t.specifiers || (t.specifiers = []);
              let e = t.exportKind === "type";
              return t.specifiers.push(...this.parseExportSpecifiers(e)), t.source = null, t.declaration = null, this.hasPlugin("importAssertions") && (t.assertions = []), !0;
            }
            return !1;
          }
          maybeParseExportDeclaration(t) {
            return this.shouldParseExportDeclaration() ? (t.specifiers = [], t.source = null, this.hasPlugin("importAssertions") && (t.assertions = []), t.declaration = this.parseExportDeclaration(t), !0) : !1;
          }
          isAsyncFunction() {
            if (!this.isContextual(95))
              return !1;
            let t = this.nextTokenStart();
            return !ds.test(this.input.slice(this.state.pos, t)) && this.isUnparsedContextual(t, "function");
          }
          parseExportDefaultExpression() {
            let t = this.startNode();
            if (this.match(68))
              return this.next(), this.parseFunction(t, 5);
            if (this.isAsyncFunction())
              return this.next(), this.next(), this.parseFunction(t, 13);
            if (this.match(80))
              return this.parseClass(t, !0, !0);
            if (this.match(26))
              return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") === !0 && this.raise(p.DecoratorBeforeExport, { at: this.state.startLoc }), this.parseClass(this.maybeTakeDecorators(this.parseDecorators(!1), this.startNode()), !0, !0);
            if (this.match(75) || this.match(74) || this.isLet())
              throw this.raise(p.UnsupportedDefaultExport, { at: this.state.startLoc });
            let e = this.parseMaybeAssignAllowIn();
            return this.semicolon(), e;
          }
          parseExportDeclaration(t) {
            return this.match(80) ? this.parseClass(this.startNode(), !0, !1) : this.parseStatementListItem();
          }
          isExportDefaultSpecifier() {
            let { type: t } = this.state;
            if (te(t)) {
              if (t === 95 && !this.state.containsEsc || t === 99)
                return !1;
              if ((t === 128 || t === 127) && !this.state.containsEsc) {
                let { type: r } = this.lookahead();
                if (te(r) && r !== 97 || r === 5)
                  return this.expectOnePlugin(["flow", "typescript"]), !1;
              }
            } else if (!this.match(65))
              return !1;
            let e = this.nextTokenStart(), s = this.isUnparsedContextual(e, "from");
            if (this.input.charCodeAt(e) === 44 || te(this.state.type) && s)
              return !0;
            if (this.match(65) && s) {
              let r = this.input.charCodeAt(this.nextTokenStartSince(e + 4));
              return r === 34 || r === 39;
            }
            return !1;
          }
          parseExportFrom(t, e) {
            if (this.eatContextual(97)) {
              t.source = this.parseImportSource(), this.checkExport(t);
              let s = this.maybeParseImportAssertions();
              s && (t.assertions = s, this.checkJSONModuleImport(t));
            } else
              e && this.unexpected();
            this.semicolon();
          }
          shouldParseExportDeclaration() {
            let { type: t } = this.state;
            return t === 26 && (this.expectOnePlugin(["decorators", "decorators-legacy"]), this.hasPlugin("decorators")) ? (this.getPluginOption("decorators", "decoratorsBeforeExport") === !0 && this.raise(p.DecoratorBeforeExport, { at: this.state.startLoc }), !0) : t === 74 || t === 75 || t === 68 || t === 80 || this.isLet() || this.isAsyncFunction();
          }
          checkExport(t, e, s, r) {
            if (e) {
              if (s) {
                if (this.checkDuplicateExports(t, "default"), this.hasPlugin("exportDefaultFrom")) {
                  var i;
                  let a = t.declaration;
                  a.type === "Identifier" && a.name === "from" && a.end - a.start === 4 && !((i = a.extra) != null && i.parenthesized) && this.raise(p.ExportDefaultFromAsIdentifier, { at: a });
                }
              } else if (t.specifiers && t.specifiers.length)
                for (let a of t.specifiers) {
                  let { exported: n } = a, o = n.type === "Identifier" ? n.name : n.value;
                  if (this.checkDuplicateExports(a, o), !r && a.local) {
                    let { local: h } = a;
                    h.type !== "Identifier" ? this.raise(p.ExportBindingIsString, { at: a, localName: h.value, exportName: o }) : (this.checkReservedWord(h.name, h.loc.start, !0, !1), this.scope.checkLocalExport(h));
                  }
                }
              else if (t.declaration) {
                if (t.declaration.type === "FunctionDeclaration" || t.declaration.type === "ClassDeclaration") {
                  let a = t.declaration.id;
                  if (!a)
                    throw new Error("Assertion failure");
                  this.checkDuplicateExports(t, a.name);
                } else if (t.declaration.type === "VariableDeclaration")
                  for (let a of t.declaration.declarations)
                    this.checkDeclaration(a.id);
              }
            }
          }
          checkDeclaration(t) {
            if (t.type === "Identifier")
              this.checkDuplicateExports(t, t.name);
            else if (t.type === "ObjectPattern")
              for (let e of t.properties)
                this.checkDeclaration(e);
            else if (t.type === "ArrayPattern")
              for (let e of t.elements)
                e && this.checkDeclaration(e);
            else
              t.type === "ObjectProperty" ? this.checkDeclaration(t.value) : t.type === "RestElement" ? this.checkDeclaration(t.argument) : t.type === "AssignmentPattern" && this.checkDeclaration(t.left);
          }
          checkDuplicateExports(t, e) {
            this.exportedIdentifiers.has(e) && (e === "default" ? this.raise(p.DuplicateDefaultExport, { at: t }) : this.raise(p.DuplicateExport, { at: t, exportName: e })), this.exportedIdentifiers.add(e);
          }
          parseExportSpecifiers(t) {
            let e = [], s = !0;
            for (this.expect(5); !this.eat(8); ) {
              if (s)
                s = !1;
              else if (this.expect(12), this.eat(8))
                break;
              let r = this.isContextual(128), i = this.match(131), a = this.startNode();
              a.local = this.parseModuleExportName(), e.push(this.parseExportSpecifier(a, i, t, r));
            }
            return e;
          }
          parseExportSpecifier(t, e, s, r) {
            return this.eatContextual(93) ? t.exported = this.parseModuleExportName() : e ? t.exported = On(t.local) : t.exported || (t.exported = Fe(t.local)), this.finishNode(t, "ExportSpecifier");
          }
          parseModuleExportName() {
            if (this.match(131)) {
              let t = this.parseStringLiteral(this.state.value), e = t.value.match(po);
              return e && this.raise(p.ModuleExportNameHasLoneSurrogate, { at: t, surrogateCharCode: e[0].charCodeAt(0) }), t;
            }
            return this.parseIdentifier(!0);
          }
          isJSONModuleImport(t) {
            return t.assertions != null ? t.assertions.some((e) => {
              let { key: s, value: r } = e;
              return r.value === "json" && (s.type === "Identifier" ? s.name === "type" : s.value === "type");
            }) : !1;
          }
          checkImportReflection(t) {
            if (t.module) {
              var e;
              (t.specifiers.length !== 1 || t.specifiers[0].type !== "ImportDefaultSpecifier") && this.raise(p.ImportReflectionNotBinding, { at: t.specifiers[0].loc.start }), ((e = t.assertions) == null ? void 0 : e.length) > 0 && this.raise(p.ImportReflectionHasAssertion, { at: t.specifiers[0].loc.start });
            }
          }
          checkJSONModuleImport(t) {
            if (this.isJSONModuleImport(t) && t.type !== "ExportAllDeclaration") {
              let { specifiers: e } = t;
              if (e != null) {
                let s = e.find((r) => {
                  let i;
                  if (r.type === "ExportSpecifier" ? i = r.local : r.type === "ImportSpecifier" && (i = r.imported), i !== void 0)
                    return i.type === "Identifier" ? i.name !== "default" : i.value !== "default";
                });
                s !== void 0 && this.raise(p.ImportJSONBindingNotDefault, { at: s.loc.start });
              }
            }
          }
          parseMaybeImportReflection(t) {
            let e = !1;
            if (this.isContextual(125)) {
              let s = this.lookahead(), r = s.type;
              te(r) ? (r !== 97 || this.input.charCodeAt(this.nextTokenStartSince(s.end)) === 102) && (e = !0) : r !== 12 && (e = !0);
            }
            e ? (this.expectPlugin("importReflection"), this.next(), t.module = !0) : this.hasPlugin("importReflection") && (t.module = !1);
          }
          parseImport(t) {
            if (t.specifiers = [], !this.match(131)) {
              this.parseMaybeImportReflection(t);
              let s = !this.maybeParseDefaultImportSpecifier(t) || this.eat(12), r = s && this.maybeParseStarImportSpecifier(t);
              s && !r && this.parseNamedImportSpecifiers(t), this.expectContextual(97);
            }
            t.source = this.parseImportSource();
            let e = this.maybeParseImportAssertions();
            if (e)
              t.assertions = e;
            else {
              let s = this.maybeParseModuleAttributes();
              s && (t.attributes = s);
            }
            return this.checkImportReflection(t), this.checkJSONModuleImport(t), this.semicolon(), this.finishNode(t, "ImportDeclaration");
          }
          parseImportSource() {
            return this.match(131) || this.unexpected(), this.parseExprAtom();
          }
          shouldParseDefaultImport(t) {
            return te(this.state.type);
          }
          parseImportSpecifierLocal(t, e, s) {
            e.local = this.parseIdentifier(), t.specifiers.push(this.finishImportSpecifier(e, s));
          }
          finishImportSpecifier(t, e) {
            let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Qe;
            return this.checkLVal(t.local, { in: { type: e }, binding: s }), this.finishNode(t, e);
          }
          parseAssertEntries() {
            let t = [], e = /* @__PURE__ */ new Set();
            do {
              if (this.match(8))
                break;
              let s = this.startNode(), r = this.state.value;
              if (e.has(r) && this.raise(p.ModuleAttributesWithDuplicateKeys, { at: this.state.startLoc, key: r }), e.add(r), this.match(131) ? s.key = this.parseStringLiteral(r) : s.key = this.parseIdentifier(!0), this.expect(14), !this.match(131))
                throw this.raise(p.ModuleAttributeInvalidValue, { at: this.state.startLoc });
              s.value = this.parseStringLiteral(this.state.value), t.push(this.finishNode(s, "ImportAttribute"));
            } while (this.eat(12));
            return t;
          }
          maybeParseModuleAttributes() {
            if (this.match(76) && !this.hasPrecedingLineBreak())
              this.expectPlugin("moduleAttributes"), this.next();
            else
              return this.hasPlugin("moduleAttributes") ? [] : null;
            let t = [], e = /* @__PURE__ */ new Set();
            do {
              let s = this.startNode();
              if (s.key = this.parseIdentifier(!0), s.key.name !== "type" && this.raise(p.ModuleAttributeDifferentFromType, { at: s.key }), e.has(s.key.name) && this.raise(p.ModuleAttributesWithDuplicateKeys, { at: s.key, key: s.key.name }), e.add(s.key.name), this.expect(14), !this.match(131))
                throw this.raise(p.ModuleAttributeInvalidValue, { at: this.state.startLoc });
              s.value = this.parseStringLiteral(this.state.value), this.finishNode(s, "ImportAttribute"), t.push(s);
            } while (this.eat(12));
            return t;
          }
          maybeParseImportAssertions() {
            if (this.isContextual(94) && !this.hasPrecedingLineBreak())
              this.expectPlugin("importAssertions"), this.next();
            else
              return this.hasPlugin("importAssertions") ? [] : null;
            this.eat(5);
            let t = this.parseAssertEntries();
            return this.eat(8), t;
          }
          maybeParseDefaultImportSpecifier(t) {
            return this.shouldParseDefaultImport(t) ? (this.parseImportSpecifierLocal(t, this.startNode(), "ImportDefaultSpecifier"), !0) : !1;
          }
          maybeParseStarImportSpecifier(t) {
            if (this.match(55)) {
              let e = this.startNode();
              return this.next(), this.expectContextual(93), this.parseImportSpecifierLocal(t, e, "ImportNamespaceSpecifier"), !0;
            }
            return !1;
          }
          parseNamedImportSpecifiers(t) {
            let e = !0;
            for (this.expect(5); !this.eat(8); ) {
              if (e)
                e = !1;
              else {
                if (this.eat(14))
                  throw this.raise(p.DestructureNamedImport, { at: this.state.startLoc });
                if (this.expect(12), this.eat(8))
                  break;
              }
              let s = this.startNode(), r = this.match(131), i = this.isContextual(128);
              s.imported = this.parseModuleExportName();
              let a = this.parseImportSpecifier(s, r, t.importKind === "type" || t.importKind === "typeof", i, void 0);
              t.specifiers.push(a);
            }
          }
          parseImportSpecifier(t, e, s, r, i) {
            if (this.eatContextual(93))
              t.local = this.parseIdentifier();
            else {
              let { imported: a } = t;
              if (e)
                throw this.raise(p.ImportBindingIsString, { at: t, importName: a.value });
              this.checkReservedWord(a.name, t.loc.start, !0, !0), t.local || (t.local = Fe(a));
            }
            return this.finishImportSpecifier(t, "ImportSpecifier", i);
          }
          isThisParam(t) {
            return t.type === "Identifier" && t.name === "this";
          }
        }, Xr = class extends co {
          constructor(t, e) {
            t = I(t), super(t, e), this.options = t, this.initializeScopes(), this.plugins = mo(this.options.plugins), this.filename = t.sourceFilename;
          }
          getScopeHandler() {
            return cs;
          }
          parse() {
            this.enterInitialScopes();
            let t = this.startNode(), e = this.startNode();
            return this.nextToken(), t.errors = null, this.parseTopLevel(t, e), t.errors = this.state.errors, t;
          }
        };
        function mo(t) {
          let e = /* @__PURE__ */ new Map();
          for (let s of t) {
            let [r, i] = Array.isArray(s) ? s : [s, {}];
            e.has(r) || e.set(r, i || {});
          }
          return e;
        }
        function fo(t, e) {
          var s;
          if (((s = e) == null ? void 0 : s.sourceType) === "unambiguous") {
            e = Object.assign({}, e);
            try {
              e.sourceType = "module";
              let r = pt(e, t), i = r.parse();
              if (r.sawUnambiguousESM)
                return i;
              if (r.ambiguousScriptDifferentAst)
                try {
                  return e.sourceType = "script", pt(e, t).parse();
                } catch {
                }
              else
                i.program.sourceType = "script";
              return i;
            } catch (r) {
              try {
                return e.sourceType = "script", pt(e, t).parse();
              } catch {
              }
              throw r;
            }
          } else
            return pt(e, t).parse();
        }
        function yo(t, e) {
          let s = pt(e, t);
          return s.options.strictMode && (s.state.strict = !0), s.getExpression();
        }
        function xo(t) {
          let e = {};
          for (let s of Object.keys(t))
            e[s] = Ie(t[s]);
          return e;
        }
        var go = xo(ge);
        function pt(t, e) {
          let s = Xr;
          return t != null && t.plugins && (no(t.plugins), s = Po(t.plugins)), new s(t, e);
        }
        var Gr = {};
        function Po(t) {
          let e = oo.filter((i) => me(t, i)), s = e.join("/"), r = Gr[s];
          if (!r) {
            r = Xr;
            for (let i of e)
              r = Jr[i](r);
            Gr[s] = r;
          }
          return r;
        }
        L.parse = fo, L.parseExpression = yo, L.tokTypes = go;
      } }), aa = P({ "src/language-js/parse/json.js"(L, N) {
        S();
        var I = Gs(), A = Xt(), g = Qs(), E = Zs();
        function y() {
          let z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { allowComments: W = !0 } = z;
          return function(C) {
            let { parseExpression: Z } = er(), le;
            try {
              le = Z(C, { tokens: !0, ranges: !0 });
            } catch (H) {
              throw E(H);
            }
            if (!W && I(le.comments))
              throw O(le.comments[0], "Comment");
            return V(le), le;
          };
        }
        function O(z, W) {
          let [C, Z] = [z.loc.start, z.loc.end].map((le) => {
            let { line: H, column: Y } = le;
            return { line: H, column: Y + 1 };
          });
          return A(`${W} is not allowed in JSON.`, { start: C, end: Z });
        }
        function V(z) {
          switch (z.type) {
            case "ArrayExpression":
              for (let W of z.elements)
                W !== null && V(W);
              return;
            case "ObjectExpression":
              for (let W of z.properties)
                V(W);
              return;
            case "ObjectProperty":
              if (z.computed)
                throw O(z.key, "Computed key");
              if (z.shorthand)
                throw O(z.key, "Shorthand property");
              z.key.type !== "Identifier" && V(z.key), V(z.value);
              return;
            case "UnaryExpression": {
              let { operator: W, argument: C } = z;
              if (W !== "+" && W !== "-")
                throw O(z, `Operator '${z.operator}'`);
              if (C.type === "NumericLiteral" || C.type === "Identifier" && (C.name === "Infinity" || C.name === "NaN"))
                return;
              throw O(C, `Operator '${W}' before '${C.type}'`);
            }
            case "Identifier":
              if (z.name !== "Infinity" && z.name !== "NaN" && z.name !== "undefined")
                throw O(z, `Identifier '${z.name}'`);
              return;
            case "TemplateLiteral":
              if (I(z.expressions))
                throw O(z.expressions[0], "'TemplateLiteral' with expression");
              for (let W of z.quasis)
                V(W);
              return;
            case "NullLiteral":
            case "BooleanLiteral":
            case "NumericLiteral":
            case "StringLiteral":
            case "TemplateElement":
              return;
            default:
              throw O(z, `'${z.type}'`);
          }
        }
        var X = y(), Q = { json: g({ parse: X, hasPragma() {
          return !0;
        } }), json5: g(X), "json-stringify": g({ parse: y({ allowComments: !1 }), astFormat: "estree-json" }) };
        N.exports = Q;
      } });
      S();
      var na = U(), oa = _(), ha = ae(), Ke = Qs(), la = Zs(), pa = ia(), ua = aa(), ca = { sourceType: "module", allowImportExportEverywhere: !0, allowReturnOutsideFunction: !0, allowSuperOutsideMethod: !0, allowUndeclaredExports: !0, errorRecovery: !0, createParenthesizedExpressions: !0, plugins: ["doExpressions", "exportDefaultFrom", "functionBind", "functionSent", "throwExpressions", "partialApplication", ["decorators", { decoratorsBeforeExport: !1 }], "importAssertions", "decimal", "moduleBlocks", "asyncDoExpressions", "regexpUnicodeSets", "destructuringPrivate", "decoratorAutoAccessors"], tokens: !0, ranges: !0 }, da = ["recordAndTuple", { syntaxType: "hash" }], tr = "v8intrinsic", sr = [["pipelineOperator", { proposal: "hack", topicToken: "%" }], ["pipelineOperator", { proposal: "minimal" }], ["pipelineOperator", { proposal: "fsharp" }]], ve = function(L) {
        let N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ca;
        return Object.assign(Object.assign({}, N), {}, { plugins: [...N.plugins, ...L] });
      }, ma = /@(?:no)?flow\b/;
      function fa(L, N) {
        if (N.filepath && N.filepath.endsWith(".js.flow"))
          return !0;
        let I = oa(L);
        I && (L = L.slice(I.length));
        let A = ha(L, 0);
        return A !== !1 && (L = L.slice(0, A)), ma.test(L);
      }
      function ya(L, N, I) {
        let A = er()[L], g = A(N, I), E = g.errors.find((y) => !Ta.has(y.reasonCode));
        if (E)
          throw E;
        return g;
      }
      function We(L) {
        for (var N = arguments.length, I = new Array(N > 1 ? N - 1 : 0), A = 1; A < N; A++)
          I[A - 1] = arguments[A];
        return function(g, E) {
          let y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          if ((y.parser === "babel" || y.parser === "__babel_estree") && fa(g, y))
            return y.parser = "babel-flow", rr(g, E, y);
          let O = I;
          y.__babelSourceType === "script" && (O = O.map((z) => Object.assign(Object.assign({}, z), {}, { sourceType: "script" }))), /#[[{]/.test(g) && (O = O.map((z) => ve([da], z)));
          let V = /%[A-Z]/.test(g);
          g.includes("|>") ? O = (V ? [...sr, tr] : sr).flatMap((z) => O.map((W) => ve([z], W))) : V && (O = O.map((z) => ve([tr], z)));
          let { result: X, error: Q } = na(...O.map((z) => () => ya(L, g, z)));
          if (!X)
            throw la(Q);
          return y.originalText = g, pa(X, y);
        };
      }
      var xa = We("parse", ve(["jsx", "flow"])), rr = We("parse", ve(["jsx", ["flow", { all: !0, enums: !0 }]])), ga = We("parse", ve(["jsx", "typescript"]), ve(["typescript"])), Pa = We("parse", ve(["jsx", "flow", "estree"])), Aa = We("parseExpression", ve(["jsx"])), ba = We("parseExpression", ve(["typescript"])), Ta = /* @__PURE__ */ new Set(["StrictNumericEscape", "StrictWith", "StrictOctalLiteral", "StrictDelete", "StrictEvalArguments", "StrictEvalArgumentsBinding", "StrictFunction", "EmptyTypeArguments", "EmptyTypeParameters", "ConstructorHasTypeParameters", "UnsupportedParameterPropertyKind", "UnexpectedParameterModifier", "MixedLabeledAndUnlabeledElements", "InvalidTupleMemberLabel", "NonClassMethodPropertyHasAbstractModifer", "ReadonlyForMethodSignature", "ClassMethodHasDeclare", "ClassMethodHasReadonly", "InvalidModifierOnTypeMember", "DuplicateAccessibilityModifier", "IndexSignatureHasDeclare", "DecoratorExportClass", "ParamDupe", "InvalidDecimal", "RestTrailingComma", "UnsupportedParameterDecorator", "UnterminatedJsxContent", "UnexpectedReservedWord", "ModuleAttributesWithDuplicateKeys", "LineTerminatorBeforeArrow", "InvalidEscapeSequenceTemplate", "NonAbstractClassHasAbstractMethod", "UnsupportedPropertyDecorator", "OptionalTypeBeforeRequired", "PatternIsOptional", "OptionalBindingPattern", "DeclareClassFieldHasInitializer", "TypeImportCannotSpecifyDefaultAndNamed", "DeclareFunctionHasImplementation", "ConstructorClassField", "VarRedeclaration", "InvalidPrivateFieldResolution", "DuplicateExport"]), ir = Ke(xa), ar = Ke(ga), nr = Ke(Aa), Ea = Ke(ba);
      d.exports = { parsers: Object.assign(Object.assign({ babel: ir, "babel-flow": Ke(rr), "babel-ts": ar }, ua), {}, { __js_expression: nr, __vue_expression: nr, __vue_ts_expression: Ea, __vue_event_binding: ir, __vue_ts_event_binding: ar, __babel_estree: Ke(Pa) }) };
    });
    return $i();
  });
})(Qr);
var bo = Qr.exports;
const vo = /* @__PURE__ */ Ao(bo);
export {
  vo as default
};
